// tslint:disable:object-literal-key-quotes

export const translations = {
  "DE": {
    "Permissions": "Berechtigungen",
    "Permission.ShowUsers": "Benutzer anzeigen",
    "Permission.EditUsers": "Benutzer verwalten",
    "Permission.ShowProjects": "Projekte anzeigen",
    "Permission.EditProjects": "Projekte verwalten",
    "Permission.ShowApplications": "Anträge anzeigen",
    "Permission.EditApplications": "Anträge verwalten",
    "Permission.ShowDemandRequest": "Bedarfsanfragen anzeigen",
    "Permission.EditDemandRequest": "Bedarfsanfragen verwalten",
    "Permission.CreateDemandRequest": "Bedarfsanfragen erstellen",
    "Permission.ShowUserRoles": "Benutzerrollen anzeigen",
    "Permission.EditUserRoles": "Benutzerrollen verwalten",
    "Permission.ShowGeraete": "Geräte anzeigen",
    "Permission.EditGeraete": "Geräte verwalten",
    "Permission.ReadGeraete": "Geräte lesen",
    "Permission.Administration": "Administration",
    "Permission.ReadAuftrag": "Aufträge lesen",
    "Permission.ListAuftraege": "Aufträge anzeigen",
    "Permission.ShowKarte": "Karte anzeigen",
    "Permission.ProtokollAnzeigen": "Protokoll anzeigen",
    "Permission.ProtokollBearbeiten": "Protokoll bearbeiten",
    "Permission.KarteAnzeigen": "Karte anzeigen",
    "Permission.WorkflowsAnzeigen": "Workflows anzeigen",
    "Permission.WorkflowsBearbeiten": "Workflows bearbeiten",
    "Permission.FahrerBearbeiten": "Fahrer bearbeiten",
    "Permission.FahrerAnzeigen": "Fahrer anzeigen",
    "Permission.FahrzeugBearbeiten": "Fahrzeuge bearbeiten",
    "Permission.FahrzeugAnzeigen": "Fahrzeuge anzeigen",
    "Permission.ArtikelAnzeigen": "Artikel anzeigen",
    "Permission.ArtikelBearbeiten": "Artikel bearbeiten",
    "Permission.UvvKatalogAnzeigen": "UVV-Katalog anzeigen",
    "Permission.UvvKatalogBearbeiten": "UVV-Katalog bearbeiten",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Abfahrtskontrolle-Katalog anzeigen",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Abfahrtskontrolle-Katalog bearbeiten",
    "Permission.FormulareBearbeiten": "Formulare bearbeiten",
    "Permission.UvvPruefungenAnzeigen": "UVV-Prüfungen anzeigen",
    "Permission.UvvPruefungenBearbeiten": "UVV-Prüfungen bearbeiten",
    "Permission.UvvPruefGegenstaendeAnzeigen": "UVV-Gegenstände anzeigen",
    "Permission.UvvPruefGegenstaendeBearbeiten": "UVV-Gegenstände bearbeiten",
    "Permission.ChecklisteBearbeiten": "Checklisten bearbeiten",
    "Permission.ChecklisteAnzeigen": "Checklisten anzeigen",
    "Permission.AdresseAnzeigen": "Adressen anzeigen",
    "Permission.DokumenteBearbeiten": "Dokumente bearbeiten",
    "Permission.DruckformulareAnzeigen": "Druckformulare anzeigen",
    "Permission.DruckformulareBearbeiten": "Druckformulare bearbeiten",
    "Permission.ArtikelgruppenAnzeigen": "Artikelgruppen anzeigen",
    "Permission.ArtikelgruppenBearbeiten": "Artikelgruppen bearbeiten",
    "Permission.Sysadmin": "Sysadmin",
    "Permission.FahrzeuggruppenAnzeigen": "Fahrzeuggruppen anzeigen",
    "Permission.FahrzeuggruppenBearbeiten": "Fahrzeuggruppen bearbeiten",
    "Permission.GeraetegruppenAnzeigen": "Geraetegruppen anzeigen",
    "Permission.GeraetegruppenBearbeiten": "Geraetegruppen bearbeiten",
    "Permission.StatuszusatzinfoAnzeigen": "Statuszusatzinfo anzeigen",
    "Permission.StatuszusatzinfoBearbeiten": "Statuszusatzinfo bearbeiten",
    "Permission.Nachrichten": "Nachrichten",
    "Permission.AdresseBearbeiten": "Adressen bearbeiten",
    "Permission.WaageAnzeigen": "Waagen anzeigen",
    "Permission.WaageBearbeiten": "Waagen bearbeiten",
    "Permission.Tabellenkonfiguration": "Tabellenkonfiguration",
    "Permission.EditGeraeteEinfacheDaten": "Geräte einfache Daten ändern",
    "Permission.AuftraegeBearbeiten": "Aufträge bearbeiten",
    "Permission.AuftraegeLoeschen": "Aufträge löschen",
    "Permission.DokumenteAnzeigen": "Dokumente anzeigen",
    "Permission.Dashboard": "Übersicht (Dashboard)",
    "Permission.GastzugangAnzeigen": "Gastzugang anzeigen",
    "Permission.GastzugangBearbeiten": "Gastzugang bearbeiten",
    "Permission.StammtourAnzeigen": "Stammtour anzeigen",
    "Permission.StammtourBearbeiten": "Stammtour bearbeiten",
    "Permission.StoerzeitAnzeigen": "Störzeit anzeigen",
    "Permission.StoerzeitBearbeiten": "Störzeit bearbeiten",
    "Permission.TourenAnzeigen": "Touren anzeigen",
    "Permission.TourenBearbeiten": "Touren bearbeiten",
    "Permission.Tourenplanung": "Tourenplanung",
    "Anmelden mit Personalnummer": "Anmelden mit Personalnummer",
    "TourWiegung1": "1. Wiegung",
    "TourWiegung2": "2. Wiegung",
    "BitteWiegung1Durchfuehren": "Bitte 1. Wiegung durchführen",
    "BitteWiegung2Durchfuehren": "Bitte 2. Wiegung durchführen",
    "Permission.AbfahrtskontrolleBearbeiten": "Abfahrtskontrolle bearbeiten",
    "Permission.AbfahrtskontrolleAnzeigen": "Abfahrtskontrolle anzeigen",
    "Permission.Auswertungen": "Auswertungen",
    "Permission.TexteAnzeigen": "Texte anzeigen",
    "Permission.TexteBearbeiten": "Texte bearbeiten",
    "AuftragWiegung1": "1. Wiegung",
    "AuftragWiegung2": "2. Wiegung",
    "Beladung": "Beladung",
    "Auftrag scannen": "Auftrag scannen",
    "Tour": "Tour",
    "Home_Anmelden": "Anmelden mit Personalnummer",
    "Home_TourStarten": "Tour starten",
    "Home_TourBeenden": "Tour beenden",
    "Home_AuftragScannen": "Auftrag scannen",
    "Home_Beladung": "Beladung",
    "Home_Hofauftraege": "Hofaufträge",
    "Wareneingang": "Wareneingang",
    "Glas-Analyse": "Glas-Analyse",
    "Home_Uebersicht": "Übersicht",
    "Home_Kunden": "Kunden",
    "NagivationHome": "Home",
    "UVV-Prüfungen": "UVV-Prüfungen",
    "Dokumente": "Dokumente",
    "Abmelden": "Abmelden",
    "Smartwatch": "Smartwatch",
    "ProGlove": "ProGlove",
    "Home_System": "System",
    "Permission.VertraegeAnzeigen": "Verträge anzeigen",
    "Permission.VertraegeBearbeiten": "Verträge bearbeiten",
    "Save": "Speichern",
    "Cancel": "Abbrechen",
    "NeuenTransportauftragAnlegen": "Neuen Transportauftrag anlegen?",
    "NeuenWareneingangAnlegen": "Neuen Wareneingang erfassen?",
    "NeuenHofauftragAnlegen": "Neuen Hofauftrag anlegen?",
    "Vertrag": "Vertrag",
    "Neuer Auftrag": "Neuer Auftrag",
    "Abbrechen": "Abbrechen",
    "Home_Zeiterfassung": "Zeiterfassung",
    "SchreibgeschuetztVorStatusmeldung": "Auftrag ist Schreibgeschützt bis zu ersten Statusmeldung",
    "NavigationErlaubenWennSchreibgeschuetzt": "Navigation erlauben wenn schreibgeschützt",
    "TransportauftragLeerePositionenAusblenden": "Positionen mit Menge 0 ausblenden",
    "Auswertungen": "Auswertungen",
    "Abfahrtskontrolle": "Abfahrtskontrolle",
    "UVV-Gegenstände": "UVV-Gegenstände",
    "UVV-Katalog": "UVV-Katalog",
    "Einträge": "Einträge",
    "Name": "Name",
    "Beschreibung": "Beschreibung",
    "REST-Schnittstelle": "REST-Schnittstelle",
    "Abrechnung aktiv": "Abrechnung aktiv",
    "API-Token": "API-Token",
    "Angelegt am": "Angelegt am",
    "Vorname": "Vorname",
    "Nachname": "Nachname",
    "Email": "Email",
    "Roles": "Benutzerrollen",
    "Field is required": "Feld ist erforderlich",
    "E-Mail": "E-Mail",
    "Zugangsdaten ändern": "Zugangsdaten ändern",
    "Passwort": "Passwort",
    "Passwort (bestätigen)": "Passwort (bestätigen)",
    "Benutzer bearbeiten": "Benutzer bearbeiten",
    "Key": "Key",
    "Checkliste": "Checkliste",
    "Mandant": "Mandant",
    "ApiToken": "API-Token",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "Max. Entfernung": "Max. Entfernung",
    "Timeout": "Timeout",
    "Icon": "Icon",
    "Nummer": "Nummer",
    "Bezeichnung": "Bezeichnung",
    "Gruppe": "Gruppe",
    "App Version": "App Version",
    "Traffic aktueller Monat": "Traffic aktueller Monat",
    "Personalnr.": "Personalnr.",
    "Personal": "Personal",
    "Zuletzt online": "Zuletzt online",
    "Fahrzeug": "Fahrzeug",
    "Anhänger": "Anhänger",
    "Letzte Position": "Letzte Position",
    "Farbe": "Farbe",
    "Letzte Anmeldung": "Letzte Anmeldung",
    "Letzte Abmeldung": "Letzte Abmeldung",
    "Angemeldet": "Angemeldet",
    "Telefon": "Telefon",
    "Freitext": "Freitext",
    "Platform": "Platform",
    "Version": "Version",
    "Hersteller": "Hersteller",
    "Model": "Model",
    "Alert Berechtigung": "Alert Berechtigung",
    "Erste Verwendung": "Erste Verwendung",
    "Letzte Verwendung": "Letzte Verwendung",
    "Abrechnung ab": "Abrechnung ab",
    "Abrechnung bis": "Abrechnung bis",
    "Preis / Monat": "Preis / Monat",
    "Einmaliger Preis ": "Einmaliger Preis ",
    "Geräte (Systemansicht)": "Geräte (Systemansicht)",
    "RoleName": "RoleName",
    "Symbol": "Symbol",
    "App-Version": "App-Version",
    "Verfügbare Waagen": "Verfügbare Waagen",
    "Importieren": "Importieren",
    "Gerätegruppe bearbeiten": "Gerätegruppe bearbeiten",
    "Kopieren": "Kopieren",
    "Exportieren": "Exportieren",
    "Zeit (h)": "Zeit (h)",
    "Intervall (m)": "Intervall (m)",
    "MeldungText": "MeldungText",
    "Standard-Dauer": "Standard-Dauer",
    "Typ": "Typ",
    "Datum": "Datum",
    "Verlauf": "Verlauf",
    "Auftragsnr.": "Auftragsnr.",
    "Gerätenr.": "Gerätenr.",
    "Gerät": "Gerät",
    "Status": "Status",
    "PushStatus": "PushStatus",
    "Abholdatum": "Abholdatum",
    "Abholzeit": "Abholzeit",
    "Erfasser": "Erfasser",
    "Adress Nr.": "Adress Nr.",
    "Name1": "Name1",
    "Name2": "Name2",
    "Strasse": "Strasse",
    "PLZ": "PLZ",
    "Ort": "Ort",
    "Kunde Nr.": "Kunde Nr.",
    "Kunde Name1": "Kunde Name1",
    "Kunde Name2": "Kunde Name2",
    "Kunde Strasse": "Kunde Strasse",
    "Kunde PLZ": "Kunde PLZ",
    "Kunde Ort": "Kunde Ort",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "DetailInfo1",
    "DetailInfo2": "DetailInfo2",
    "DetailInfo3": "DetailInfo3",
    "Workflow": "Workflow",
    "Statusmeldung": "Statusmeldung",
    "Statuszeit": "Statuszeit",
    "Reihenfolge": "Reihenfolge",
    "CreationDate": "CreationDate",
    "ModificationDate": "ModificationDate",
    "Lieferpositionen": "Lieferpositionen",
    "Auftrag": "Auftrag",
    "RememberMe": "Angemeldet bleiben",
    "Username": "Benutzername",
    "Geräte": "Geräte",
    "Stammdaten": "Stammdaten",
    "Adressen": "Adressen",
    "Artikelgruppen": "Artikelgruppen",
    "Artikel": "Artikel",
    "Checklisten": "Checklisten",
    "Fahrer (Personal)": "Fahrer (Personal)",
    "Fahrzeuge": "Fahrzeuge",
    "Fahrzeuggruppen": "Fahrzeuggruppen",
    "Konfiguration": "Konfiguration",
    "Benutzer": "Benutzer",
    "Benutzerrollen": "Benutzerrollen",
    "Druckformulare": "Druckformulare",
    "Einstellungen": "Einstellungen",
    "Formulare": "Formulare",
    "Gerätegruppen": "Gerätegruppen",
    "Waagen": "Waagen",
    "Workflows": "Workflows",
    "Statuszusatzinfo": "Statuszusatzinfo",
    "Texte": "Texte",
    "Import / Export": "Import / Export",
    "Benutzername": "Benutzername",
    "E-Mail-Adresse": "E-Mail-Adresse",
    "Passwort ändern": "Passwort ändern",
    "Permission.Benachrichtigungen": "Benachrichtigungen",
    "Permission.ZeiterfassungAnzeigen": "Zeiterfassung anzeigen",
    "Permission.ZeiterfassungBearbeiten": "Zeiterfassung bearbeiten",
    "Nachtmodus": "Nachtmodus",
    "Nachmodus": "Nachtmodus",
    "KeineAuftraegeGefunden": "Keine Aufträge gefunden",
    "KeineAuftraegeVorhanden": "Keine Aufträge vorhanden. Zum Aktualisieren nach unten ziehen.",
    "TourStartenAlertButtonText": "Tour starten !",
    "Aktuelle Aufträge anzeigen": "Aktuelle Aufträge anzeigen",
    "Archiv": "Archiv",
    "weitere Aufträge vorhanden": "weitere Aufträge vorhanden",
    "weiterer Auftrag vorhanden": "weiterer Auftrag vorhanden",
    "Anmerkungen": "Anmerkungen",
    "AnmerkungenHierEingeben": "Anmerkungen hier eingeben…",
    "AuftragDarfNichtGeaendertWerden": "Auftrag darf nicht geändert werden",
    "AuftragBereitsAbgeschlossen": "Auftrag wurde bereits abgeschlossen. Änderungen sind nicht mehr möglich.",
    "Start": "Start",
    "System": "System",
    "Transportaufträge": "Transportaufträge",
    "Hofaufträge": "Hofaufträge",
    "Entladeort": "Entladeort",
    "Bitte Entladeort wählen": "Bitte Entladeort wählen",
    "TourStart_Wiegen": "Wiegen",
    "TourEnde_StartWiegung": "Wiegung bei Tour-Start",
    "TourEnde_EndeWiegung": "Wiegung (voller LKW)",
    "Geplante Reihenfolge anzeigen": "Geplante Reihenfolge anzeigen",
    "Permission.GlasAnalyseAnzeigen": "Glas-Analyse anzeigen",
    "Permission.GlasAnalyseBearbeiten": "Glas-Analyse bearbeiten",
    "BitteAuswaehlenPlaceholder": "Bitte wählen",
    "BitteAnlageWaehlen": "Bitte Anlage wählen",
    "Permission.GlasAnalyseKonfiguration": "Glas-Analyse Konfiguration",
    "UVV Prüfung": "UVV Prüfung",
    "Auftrag_Abholadresse": "Adresse",
    "Auftrag_Erzeugeradresse": "Kunde",
    "Auftrag_Verwerteradresse": "Verwerter",
    "Auftrag_Fahrzeug": "Fahrzeug",
    "Auftrag_Abholdatum": "Abholdatum",
    "Auftrag_Abholzeit": "Abholzeit",
    "Permission.BerichteAnzeigen": "Berichte anzeigen",
    "Permission.BerichteBearbeiten": "Berichte bearbeiten",
    "Permission.Kalender": "Kalender",
    "Permission.NVEAnzeigen": "NVE anzeigen",
    "Permission.NVEBearbeiten": "NVE bearbeiten",
    "Permission.RegelAnzeigen": "Regeln anzeigen",
    "Permission.RegelBearbeiten": "Regeln bearbeiten",
    "ExportMessageStatus_0": "Initial",
    "ExportMessageStatus_1": "Gesendet",
    "ExportMessageStatus_2": "Verarbeitet",
    "ExportMessageStatus_3": "Fehler",
    "ExportMessageStatus_4": "Warte auf ACK",
    "Gerätegruppe": "Gerätegruppe",
    "Sonstiges": "Sonstiges",
    "Sprache": "Sprache",
    "APP Version": "APP Version",
    "Local storage": "Local storage",
    "Advanced HTTP": "Advanced HTTP",
    "System Alert Berechtigung": "System Alert Berechtigung",
    "Navigations-App": "Navigations-App",
    "Zurücksetzen": "Zurücksetzen",
    "WebSocket": "WebSocket",
    "Push-Status": "Push-Status",
    "Push-ID": "Push-ID",
    "Push-Type": "Push-Type",
    "Anzahl Artikelgruppen": "Anzahl Artikelgruppen",
    "Anzahl Artikel": "Anzahl Artikel",
    "Anzahl Workflows": "Anzahl Workflows",
    "GPS Dienst läuft": "GPS Dienst läuft",
    "GPS Dienst aktiv": "GPS Dienst aktiv",
    "GPS Auth-Status": "GPS Auth-Status",
    "GPS-Positionen (Puffer)": "GPS-Positionen (Puffer)",
    "Zugangsdaten": "Zugangsdaten",
    "Geräte-Nummer": "Geräte-Nummer",
    "Host": "Host",
    "Speichern": "Speichern",
    "Stammdaten neu laden": "Stammdaten neu laden",
    "Lokale Daten löschen": "Lokale Daten löschen",
    "Diagnosedaten senden": "Diagnosedaten senden",
    "Testdatei senden": "Testdatei senden",
    "Update prüfen": "Update prüfen",
    "Dunkler Modus": "Dunkler Modus",
    "Aktivieren": "Aktivieren",
    "Anzeigen": "Anzeigen",
    "Anmelden": "Anmelden",
    "Personalnummer": "Personalnummer",
    "Kennwort": "Kennwort",
    "Mit NFC anmelden": "Mit NFC anmelden",
    "Bitte eingeben": "Bitte eingeben",
    "Passwort eingeben": "Passwort eingeben",
    "Anmelden mit NFC-Chip": "Anmelden mit NFC-Chip",
    "Zur Anmeldung NFC-Chip scannen": "Zur Anmeldung NFC-Chip scannen",
    "Mit Personalnummer anmelden": "Mit Personalnummer anmelden",
    "Ablaufdatum": "Ablaufdatum",
    "Kein Fahrer für RFID-Chip gefunden": "Kein Fahrer für RFID-Chip gefunden",
    "Nachrichten": "Nachrichten",
    "Berichte": "Berichte",
    "Urlaubsanträge": "Urlaubsanträge",
    "Unfallberichte": "Unfallberichte",
    "Tätigkeitsberichte": "Tätigkeitsberichte",
    "an": "an",
    "aus": "aus",
    "KeineEintraegeVorhanden": "Keine Einträge vorhanden",
    "StoerzeitFuerAuftrag": "Störzeiten für Auftrag",
    "StoerzeitFuerTour": "Störzeiten für Tour",
    "Minuten": "Minuten",
    "Sekunden": "Sekunden",
    "Minute": "Minute",
    "TourNichtGestartetLoeschen": "Tour nicht gestartet. Löschen nicht möglich.",
    "ZeiterfassungOhneTourFehler": "Zeiterfassung kann ohne Tour nicht gestartet werden",
    "Tour start": "Tour start",
    "Kilometerstand": "Kilometerstand",
    "Fahrer": "Fahrer",
    "Beifahrer": "Beifahrer",
    "Bitte wählen": "Bitte wählen",
    "Beifahrer 2": "Beifahrer 2",
    "Abfahrtskontrolle Anhänger": "Abfahrtskontrolle Anhänger",
    "Foto aufnehmen": "Foto aufnehmen",
    "Zum Bearbeiten hier tippen": "Zum Bearbeiten hier tippen",
    "Eingeben": "Eingeben",
    "Uhrzeit": "Uhrzeit",
    "Driver": "Driver",
    "Passenger": "Passenger",
    "Passenger 2": "Passenger 2",
    "Trailer": "Trailer",
    "Vehicle": "Vehicle",
    "BitteEingabePruefen": "Bitte Eingabe prüfen!",
    "RFID scannen": "RFID scannen",
    "Tour scannen": "Tour scannen",
    "Tour starten": "Tour starten",
    "Tour laden": "Tour laden",
    "Tour entladen": "Tour entladen",
    "Schreiben": "Schreiben",
    "Alle Nachrichten löschen?": "Alle Nachrichten löschen?",
    "Löschen": "Löschen",
    "Ja": "Ja",
    "Nein": "Nein",
    "Nächste Prüfung": "Nächste Prüfung",
    "alle anzeigen": "alle anzeigen",
    "Bitte KM eingeben": "Bitte KM eingeben",
    "NFCErkennungLaeuft": "NFC-Erkennung läuft…",
    "RFIDWirdGescannt": "RFID wird gescannt…",
    "OK": "OK",
    "Fehlerbeschreibung": "Fehlerbeschreibung",
    "Bild wirklich löschen?": "Bild wirklich löschen?",
    "Frage": "Frage",
    "Bitte Kilometerstand angeben": "Bitte Kilometerstand angeben",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Bitte Ankunftskontrolle vollständig ausfüllen",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen",
    "Bitte Unterschrift erfassen": "Bitte Unterschrift erfassen",
    "Bitte Namen für die Unterschrift erfassen": "Bitte Namen für die Unterschrift erfassen",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!",
    "AnkunftskontrolleDauerFrage1": "Die vorgegebene Zeit für die Ankunftskontrolle wurde nicht eingehalten. Tour trotzdem beenden?",
    "Tour beenden?": "Tour beenden?",
    "AnkunftskontrolleDauerFrage2": "Die vorgegebene Zeit für die Ankunftskontrolle wurde nicht eingehalten. Tour trotzdem beenden?<br /><br />Es wird eine Nachricht gesendet!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Bitte Abfahrtskontrolle vollständig ausfüllen",
    "AbfahrtskontrolleMeldung1": "Bitte nehmen Sie sich genügend Zeit für die Abfahrtskontrolle!",
    "AbfahrtskontrolleMeldung2": "Die vorgegebene Zeit für die Abfahrtskontrolle wurde nicht eingehalten. Tour trotzdem starten?",
    "AbfahrtskontrolleMeldung3": "Die vorgegebene Zeit für die Abfahrtskontrolle wurde nicht eingehalten. Tour trotzdem starten?<br /><br />Es wird eine Nachricht gesendet!",
    "KeineWiegungTourTrotzdemStarten": "Keine Wiegung durchgeführt. Tour trotzdem starten?",
    "Wiegung": "Wiegung",
    "WiegungErfolgreich": "Wiegung erforderlich!",
    "Tour start?": "Tour start?",
    "Tour aktiv seit": "Tour aktiv seit",
    "Gestartet um": "Gestartet um",
    "Gestartet gestern": "Gestartet gestern",
    "Gestartet": "Gestartet",
    "Keine gültige Auftragsnummer": "Keine gültige Auftragsnummer",
    "Heute offene Aufträge": "Heute offene Aufträge",
    "Heute erledigt Aufträge": "Heute erledigt Aufträge",
    "Morgen": "Morgen",
    "Keine Transportaufträge": "Keine Transportaufträge",
    "1 Transportauftrag": "1 Transportauftrag",
    "aktuelle Aufträge": "aktuelle Aufträge",
    "Statusmeldung428": "Statusmeldung nicht möglich. Wiegung wurde bereits gestartet. Bitte Tour beenden und bei Bedarf neu starten.",
    "Meldung429": "<p>Statusmeldung nicht möglich. Tour ist noch nicht gestartet.</p><p>Tour jetzt starten?</p>",
    "Meldung430": "Status nicht erlaubt. Bitte einen der folgenden Status melden",
    "Meldung431": "Es wurden nicht alle Positionen fertig gemeldet. Palette wirklich fertig melden?",
    "Meldung432": "Statusmeldung nicht möglich. Bitte erst eine Begründung für die Zeiterfassung '{{NAME}}' eintragen.",
    "Es muss mindestens ein Foto gemacht werden!": "Es muss mindestens ein Foto gemacht werden!",
    "Alle Aufträge": "Alle Aufträge",
    "Kommissionierung": "Kommissionierung",
    "Wiegungen": "Wiegungen",
    "Gekoppelte Waagen": "Gekoppelte Waagen",
    "Waage suchen...": "Waage suchen...",
    "Keine Wiegedaten vorhanden": "Keine Wiegedaten vorhanden",
    "Keine Waagen konfiguriert": "Keine Waagen konfiguriert",
    "Waage": "Waage",
    "MAC Adresse": "MAC Adresse",
    "Aktiv": "Aktiv",
    "Uhr synchronisieren": "Uhr synchronisieren",
    "Wiegen 1": "Wiegen 1",
    "Wiegen 2": "Wiegen 2",
    "Tarieren": "Tarieren",
    "Keine neue Waage gefunden": "Keine neue Waage gefunden",
    "TourAktivBeendenMeldung449": "Tour ist noch aktiv. Jetzt Tour beenden?",
    "WirklichAbmelden": "Wirklich abmelden?",
    "Aktuelle Tour": "Aktuelle Tour",
    "Tour beenden": "Tour beenden",
    "Zeiterfassung": "Zeiterfassung",
    "Zeiterfassung starten": "Zeiterfassung starten",
    "Tour Ende": "Tour Ende",
    "Art": "Art",
    "Arbeitszeit bearbeiten": "Arbeitszeit bearbeiten",
    "Wiegen": "Wiegen",
    "Tätigkeitsbericht": "Tätigkeitsbericht",
    "Personaldaten": "Personaldaten",
    "Tätigkeit": "Tätigkeit",
    "Übernachtung": "Übernachtung",
    "Beschreibung der Tätigkeit": "Beschreibung der Tätigkeit",
    "Neuer Urlaubsantrag": "Neuer Urlaubsantrag",
    "Abteilung": "Abteilung",
    "Urlaub": "Urlaub",
    "Angemeldete Beifahrer": "Angemeldete Beifahrer",
    "Beifahrer hinzufügen": "Beifahrer hinzufügen",
    "Beifahrer NFC scannen": "Beifahrer NFC scannen",
    "BeifahrerListeNichtGeladen": "Liste der Beifahrer konnte nicht geladen werden. Bitte überprüfen Sie Ihre Internetverbindung.",
    "Beifahrer wurde gescannnt": "Beifahrer wurde gescannnt",
    "NfcKeinBeifahrerGefunden": "Kein Beifahrer für RFID-Chip gefunden",
    "BeifahrerAlsFahrerMeldung473": "Sie sind bereits als Fahrer für diese Tour angemeldet. Sie können sich nicht erneut als Beifahrer anmelden.",
    "BeifahrerBereitsAngemeldet": "Sie sind bereits als Beifahrer angemeldet.",
    "MaxZweiBeifahrerMoeglich": "Es können maximal 2 Beifahrer angemeldet werden",
    "BeifahrerNichtGefunden": "Beifahrer nicht gefunden",
    "BeifahrerWurdeHinzugefuegt": "Beifahrer wurde hinzugefügt",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Ein Anhänger kann nicht als Fahrzeug gescannt werden",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Ein LKW kann nicht als Anhänger gescannt werden",
    "AngemeldetSeit": "Angemeldet seit",
    "Hinzufügen": "Hinzufügen",
    "NFC scannen": "NFC scannen",
    "Beifahrer abmelden": "Beifahrer abmelden",
    "Hallo": "Hallo",
    "FuehrerscheinkontrolleText1": "die Führerscheinkontrolle ist fällig.",
    "FuehrerscheinkontrolleTextFoto": "Bitte fotografieren Sie die Vorder- und Rückseite Ihres Führerscheins.",
    "Foto Vorderseite": "Foto Vorderseite",
    "Foto Rückseite": "Foto Rückseite",
    "FuehrerscheinkontrolleTextNFC": "Bitte scannen Sie den NFC-Chip auf ihrem Führerschein.",
    "FuehrerscheinkontrolleNfcFalsch": "Ungültiger NFC-Chip",
    "Fahrerkarten": "Fahrerkarten",
    "Führerscheinkontrolle": "Führerscheinkontrolle",
    "Später": "Später",
    "Führerschein erfolgreich gescannt": "Führerschein erfolgreich gescannt",
    "Bitte Ablaufdatum erfassen": "Bitte Ablaufdatum erfassen",
    "Führerscheinprüfung wirklich verschieben?": "Führerscheinprüfung wirklich verschieben?",
    "Abmelden?": "Abmelden?",
    "Bitte NFC-Chip scannen": "Bitte NFC-Chip scannen",
    "Suchen": "Suchen",
    "Archiv anzeigen": "Archiv anzeigen",
    "Übersicht": "Übersicht",
    "Bitte Entladeort auswählen": "Bitte Entladeort auswählen",
    "Von": "Von",
    "Bis": "Bis",
    "Zeitausgleich": "Zeitausgleich",
    "Urlaub 2": "Urlaub 2",
    "Urlaub 3": "Urlaub 3",
    "Urlaub 4": "Urlaub 4",
    "Unterschrift erforderlich": "Unterschrift erforderlich",
    "Zum unterschreiben hier tippen": "Zum unterschreiben hier tippen",
    "Unterschrift": "Unterschrift",
    "Wird geladen...": "Wird geladen...",
    "Funktion im Browser nicht verfügbar": "Funktion im Browser nicht verfügbar",
    "GETRENNT": "GETRENNT",
    "FormValidationError": "Bitte prüfen Sie Ihre Eingaben. Das Formular wurde nicht vollständig ausgefüllt.",
    "Permission.ListTouren": "Touren anzeigen",
    "Permission.EditTouren": "Touren bearbeiten",
    "Protokoll": "Protokoll",
    "Werkstatt": "Werkstatt",
    "Kostenstellen": "Kostenstellen",
    "Benachrichtigungen": "Benachrichtigungen",
    "Externe Systeme": "Externe Systeme",
    "Regeln": "Regeln",
    "Masterdata1": "Kostenstelle",
    "Feld ist erforderlich": "Feld ist erforderlich",
    "FormularfehlerText": "Bitte prüfen Sie Ihre Eingaben. Das Formular wurde nicht vollständig ausgefüllt.",
    "Eintrag wirklich löschen?": "Eintrag wirklich löschen?",
    "MasterdataList1": "Kostenstellen",
    "EintragWirklichLoeschen": "Diesen Eintrag wirklich löschen?",
    "Loeschen": "Löschen",
    "AusgewaehlteZeilenWirklichLoeschen": "Ausgewählte Zeilen wirklich löschen?",
    "Gerätegruppe einschränken": "Gerätegruppe einschränken",
    "Fahrer-Namen nicht anzeigen": "Fahrer-Namen nicht anzeigen",
    "Rolle bearbeiten": "Rolle bearbeiten",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Gerätegruppen bearbeiten (einfache Daten)",
    "Permission.Werkstattuebersicht": "Werkstattübersicht",
    "Permission.Kostenstellen": "Kostenstellen",
    "Permission.EinstellungenKunde": "Einstellungen (einfach)",
    "Design": "Design",
    "Benutzeranmeldung": "Benutzeranmeldung",
    "Fotos": "Fotos",
    "Tour E-Mails": "Tour E-Mails",
    "Sicherheitshinweis": "Sicherheitshinweis",
    "Pellets": "Pellets",
    "Allgemein": "Allgemein",
    "Custom CSS": "Custom CSS",
    "Barcodes": "Barcodes",
    "Datenherkunft": "Datenherkunft",
    "Freigabeprozess": "Freigabeprozess",
    "Kontakte": "Kontakte",
    "Menü": "Menü",
    "Preise": "Preise",
    "Verträge": "Verträge",
    "Tour-Start": "Tour-Start",
    "Tour-Ende": "Tour-Ende",
    "GPS": "GPS",
    "GPS-Positionen": "GPS-Positionen",
    "Position senden": "Position senden",
    "Navigation": "Navigation",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Behälter",
    "Peripherie": "Peripherie",
    "Drucker": "Drucker",
    "Mobile Waagen": "Mobile Waagen",
    "Stationäre Waagen": "Stationäre Waagen",
    "Proglove": "Proglove",
    "LKW-Beladung": "LKW-Beladung",
    "Web": "Web",
    "Tourenplanung": "Tourenplanung",
    "Sondermodule": "Sondermodule",
    "Sprachen": "Sprachen",
    "Datenbereinigung": "Datenbereinigung",
    "Daten-Export": "Daten-Export",
    "Fehlerdiagnose": "Fehlerdiagnose",
    "Untermandanten": "Untermandanten",
    "WebSocket-Verbindung": "WebSocket-Verbindung",
    "Aufträge": "Aufträge",
    "Karte": "Karte",
    "ExtNummer": "Ext. Auftragsnummer",
    "ExtNummerHierEingeben": "Ext. Auftragsnummer hier eingeben…",
    "Foto aus Galerie auswählen": "Foto aus Galerie auswählen"
  },
  "EN": {
    "Permissions": "Authorizations",
    "Permission.ShowUsers": "Show users",
    "Permission.EditUsers": "Manage users",
    "Permission.ShowProjects": "Show projects",
    "Permission.EditProjects": "Manage projects",
    "Permission.ShowApplications": "Show applications",
    "Permission.EditApplications": "Manage applications",
    "Permission.ShowDemandRequest": "Show requirement requests",
    "Permission.EditDemandRequest": "Manage requirement requests",
    "Permission.CreateDemandRequest": "Create requirement requests",
    "Permission.ShowUserRoles": "Show user roles",
    "Permission.EditUserRoles": "Manage user roles",
    "Permission.ShowGeraete": "Show devices",
    "Permission.EditGeraete": "Manage devices",
    "Permission.ReadGeraete": "Read devices",
    "Permission.Administration": "Administration",
    "Permission.ReadAuftrag": "Read orders",
    "Permission.ListAuftraege": "Show orders",
    "Permission.ShowKarte": "Show map",
    "Permission.ProtokollAnzeigen": "Show protocol",
    "Permission.ProtokollBearbeiten": "Edit protocol",
    "Permission.KarteAnzeigen": "Show map",
    "Permission.WorkflowsAnzeigen": "Show workflows",
    "Permission.WorkflowsBearbeiten": "Edit workflows",
    "Permission.FahrerBearbeiten": "Edit driver",
    "Permission.FahrerAnzeigen": "Show driver",
    "Permission.FahrzeugBearbeiten": "Edit vehicles",
    "Permission.FahrzeugAnzeigen": "Show vehicles",
    "Permission.ArtikelAnzeigen": "Show article",
    "Permission.ArtikelBearbeiten": "Edit article",
    "Permission.UvvKatalogAnzeigen": "Show UVV catalog",
    "Permission.UvvKatalogBearbeiten": "Edit UVV catalog",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Show departure control catalog",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Edit departure control catalog",
    "Permission.FormulareBearbeiten": "Edit forms",
    "Permission.UvvPruefungenAnzeigen": "Show UVV inspections",
    "Permission.UvvPruefungenBearbeiten": "Process UVV inspections",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Display UVV objects",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Edit UVV objects",
    "Permission.ChecklisteBearbeiten": "Edit checklists",
    "Permission.ChecklisteAnzeigen": "Show checklists",
    "Permission.AdresseAnzeigen": "Show addresses",
    "Permission.DokumenteBearbeiten": "Edit documents",
    "Permission.DruckformulareAnzeigen": "Show print forms",
    "Permission.DruckformulareBearbeiten": "Edit print forms",
    "Permission.ArtikelgruppenAnzeigen": "Show article groups",
    "Permission.ArtikelgruppenBearbeiten": "Edit article groups",
    "Permission.Sysadmin": "Sysadmin",
    "Permission.FahrzeuggruppenAnzeigen": "Show vehicle groups",
    "Permission.FahrzeuggruppenBearbeiten": "Edit vehicle groups",
    "Permission.GeraetegruppenAnzeigen": "Show device groups",
    "Permission.GeraetegruppenBearbeiten": "Edit device groups",
    "Permission.StatuszusatzinfoAnzeigen": "Display additional status information",
    "Permission.StatuszusatzinfoBearbeiten": "Edit additional status info",
    "Permission.Nachrichten": "News",
    "Permission.AdresseBearbeiten": "Edit addresses",
    "Permission.WaageAnzeigen": "Show scales",
    "Permission.WaageBearbeiten": "Edit scales",
    "Permission.Tabellenkonfiguration": "Table configuration",
    "Permission.EditGeraeteEinfacheDaten": "Devices Change simple data",
    "Permission.AuftraegeBearbeiten": "Edit orders",
    "Permission.AuftraegeLoeschen": "Delete orders",
    "Permission.DokumenteAnzeigen": "Show documents",
    "Permission.Dashboard": "Overview (Dashboard)",
    "Permission.GastzugangAnzeigen": "Show guest access",
    "Permission.GastzugangBearbeiten": "Edit guest access",
    "Permission.StammtourAnzeigen": "Show regular tour",
    "Permission.StammtourBearbeiten": "Edit regular tour",
    "Permission.StoerzeitAnzeigen": "Display fault time",
    "Permission.StoerzeitBearbeiten": "Edit fault time",
    "Permission.TourenAnzeigen": "Show tours",
    "Permission.TourenBearbeiten": "Edit tours",
    "Permission.Tourenplanung": "Tour planning",
    "Anmelden mit Personalnummer": "Log in with personnel number",
    "TourWiegung1": "1. Weighing",
    "TourWiegung2": "2. Weighing",
    "BitteWiegung1Durchfuehren": "Please carry out 1st weighing",
    "BitteWiegung2Durchfuehren": "Please carry out 2nd weighing",
    "Permission.AbfahrtskontrolleBearbeiten": "Edit departure control",
    "Permission.AbfahrtskontrolleAnzeigen": "Show departure control",
    "Permission.Auswertungen": "Evaluations",
    "Permission.TexteAnzeigen": "Show texts",
    "Permission.TexteBearbeiten": "Edit texts",
    "AuftragWiegung1": "1. Weighing",
    "AuftragWiegung2": "2. Weighing",
    "Beladung": "Loading",
    "Auftrag scannen": "Scan order",
    "Tour": "Tour",
    "Home_Anmelden": "Log in with personnel number",
    "Home_TourStarten": "Start tour",
    "Home_TourBeenden": "End tour",
    "Home_AuftragScannen": "Scan order",
    "Home_Beladung": "Loading",
    "Home_Hofauftraege": "Court orders",
    "Wareneingang": "Incoming goods",
    "Glas-Analyse": "Glass analysis",
    "Home_Uebersicht": "Overview",
    "Home_Kunden": "Customers",
    "NagivationHome": "Home",
    "UVV-Prüfungen": "UVV inspections",
    "Dokumente": "Documents",
    "Abmelden": "Log out",
    "Smartwatch": "Smartwatch",
    "ProGlove": "ProGlove",
    "Home_System": "System",
    "Permission.VertraegeAnzeigen": "Show contracts",
    "Permission.VertraegeBearbeiten": "Edit contracts",
    "Save": "Save",
    "Cancel": "Cancel",
    "NeuenTransportauftragAnlegen": "Create a new transport request?",
    "NeuenWareneingangAnlegen": "Enter a new goods receipt?",
    "NeuenHofauftragAnlegen": "Create a new yard order?",
    "Vertrag": "Contract",
    "Neuer Auftrag": "New order",
    "Abbrechen": "Cancel",
    "Home_Zeiterfassung": "Time recording",
    "SchreibgeschuetztVorStatusmeldung": "Order is write-protected until the first status message",
    "NavigationErlaubenWennSchreibgeschuetzt": "Allow navigation if read-only",
    "TransportauftragLeerePositionenAusblenden": "Hide items with quantity 0",
    "Auswertungen": "Evaluations",
    "Abfahrtskontrolle": "Departure control",
    "UVV-Gegenstände": "UVV objects",
    "UVV-Katalog": "UVV catalog",
    "Einträge": "Entries",
    "Name": "Name",
    "Beschreibung": "Description",
    "REST-Schnittstelle": "REST interface",
    "Abrechnung aktiv": "Billing active",
    "API-Token": "API token",
    "Angelegt am": "Created on",
    "Vorname": "First name",
    "Nachname": "Last name",
    "Email": "Email",
    "Roles": "User roles",
    "Field is required": "Field is required",
    "E-Mail": "E-mail",
    "Zugangsdaten ändern": "Change access data",
    "Passwort": "Password",
    "Passwort (bestätigen)": "Password (confirm)",
    "Benutzer bearbeiten": "Edit user",
    "Key": "Key",
    "Checkliste": "Checklist",
    "Mandant": "Client",
    "ApiToken": "API token",
    "Latitude": "Latitude",
    "Longitude": "Longitude",
    "Max. Entfernung": "Max. Distance",
    "Timeout": "Timeout",
    "Icon": "Icon",
    "Nummer": "Number",
    "Bezeichnung": "Designation",
    "Gruppe": "Group",
    "App Version": "App version",
    "Traffic aktueller Monat": "Traffic current month",
    "Personalnr.": "Personnel no.",
    "Personal": "Personnel",
    "Zuletzt online": "Last online",
    "Fahrzeug": "Vehicle",
    "Anhänger": "Trailer",
    "Letzte Position": "Last position",
    "Farbe": "Color",
    "Letzte Anmeldung": "Last registration",
    "Letzte Abmeldung": "Last deregistration",
    "Angemeldet": "Registered",
    "Telefon": "Telephone",
    "Freitext": "Free text",
    "Platform": "Platform",
    "Version": "Version",
    "Hersteller": "Manufacturer",
    "Model": "Model",
    "Alert Berechtigung": "Alert authorization",
    "Erste Verwendung": "First use",
    "Letzte Verwendung": "Last use",
    "Abrechnung ab": "Billing from",
    "Abrechnung bis": "Settlement until",
    "Preis / Monat": "Price / month",
    "Einmaliger Preis ": "One-off price",
    "Geräte (Systemansicht)": "Devices (system view)",
    "RoleName": "RoleName",
    "Symbol": "Icon",
    "App-Version": "App version",
    "Verfügbare Waagen": "Available scales",
    "Importieren": "Import",
    "Gerätegruppe bearbeiten": "Edit device group",
    "Kopieren": "Copy",
    "Exportieren": "Export",
    "Zeit (h)": "Time (h)",
    "Intervall (m)": "Interval (m)",
    "MeldungText": "MessageText",
    "Standard-Dauer": "Standard duration",
    "Typ": "Type",
    "Datum": "Date",
    "Verlauf": "Course",
    "Auftragsnr.": "Order no.",
    "Gerätenr.": "Device no.",
    "Gerät": "Device",
    "Status": "Status",
    "PushStatus": "PushStatus",
    "Abholdatum": "Collection date",
    "Abholzeit": "Pick-up time",
    "Erfasser": "Collector",
    "Adress Nr.": "Address no.",
    "Name1": "Name1",
    "Name2": "Name2",
    "Strasse": "Street",
    "PLZ": "ZIP CODE",
    "Ort": "Location",
    "Kunde Nr.": "Customer no.",
    "Kunde Name1": "Customer Name1",
    "Kunde Name2": "Customer name2",
    "Kunde Strasse": "Customer Street",
    "Kunde PLZ": "Customer Postcode",
    "Kunde Ort": "Customer Location",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "DetailInfo1",
    "DetailInfo2": "DetailInfo2",
    "DetailInfo3": "DetailInfo3",
    "Workflow": "Workflow",
    "Statusmeldung": "Status message",
    "Statuszeit": "Status time",
    "Reihenfolge": "Sequence",
    "CreationDate": "CreationDate",
    "ModificationDate": "ModificationDate",
    "Lieferpositionen": "Delivery items",
    "Auftrag": "Order",
    "RememberMe": "Stay logged in",
    "Username": "User name",
    "Geräte": "Devices",
    "Stammdaten": "Master data",
    "Adressen": "Addresses",
    "Artikelgruppen": "Article groups",
    "Artikel": "Article",
    "Checklisten": "Checklists",
    "Fahrer (Personal)": "Driver (personnel)",
    "Fahrzeuge": "Vehicles",
    "Fahrzeuggruppen": "Vehicle groups",
    "Konfiguration": "Configuration",
    "Benutzer": "Users",
    "Benutzerrollen": "User roles",
    "Druckformulare": "Print forms",
    "Einstellungen": "Settings",
    "Formulare": "Forms",
    "Gerätegruppen": "Device groups",
    "Waagen": "Scales",
    "Workflows": "Workflows",
    "Statuszusatzinfo": "Additional status info",
    "Texte": "Texts",
    "Import / Export": "Import / Export",
    "Benutzername": "User name",
    "E-Mail-Adresse": "E-mail address",
    "Passwort ändern": "Change password",
    "Permission.Benachrichtigungen": "Notifications",
    "Permission.ZeiterfassungAnzeigen": "Show time recording",
    "Permission.ZeiterfassungBearbeiten": "Edit time recording",
    "Nachtmodus": "Dark mode",
    "Nachmodus": "Dark mode",
    "KeineAuftraegeGefunden": "No orders found",
    "KeineAuftraegeVorhanden": "No orders available. Pull down to refresh.",
    "TourStartenAlertButtonText": "Start tour !",
    "Aktuelle Aufträge anzeigen": "Show current orders",
    "Archiv": "Archive",
    "weitere Aufträge vorhanden": "further orders available",
    "weiterer Auftrag vorhanden": "further order available",
    "Anmerkungen": "Notes",
    "AnmerkungenHierEingeben": "Enter comments here..",
    "AuftragDarfNichtGeaendertWerden": "Order must not be changed",
    "AuftragBereitsAbgeschlossen": "Order has already been completed. Changes are no longer possible.",
    "Start": "Start",
    "System": "System",
    "Transportaufträge": "Transportation orders",
    "Hofaufträge": "Court orders",
    "Entladeort": "Unloading point",
    "Bitte Entladeort wählen": "Please select unloading location",
    "TourStart_Wiegen": "Weighing",
    "TourEnde_StartWiegung": "Weighing at the start of the tour",
    "TourEnde_EndeWiegung": "Weighing (full truck)",
    "Geplante Reihenfolge anzeigen": "Show planned sequence",
    "Permission.GlasAnalyseAnzeigen": "Show glass analysis",
    "Permission.GlasAnalyseBearbeiten": "Edit glass analysis",
    "BitteAuswaehlenPlaceholder": "Please select",
    "BitteAnlageWaehlen": "Please select system",
    "Permission.GlasAnalyseKonfiguration": "Glass analysis configuration",
    "UVV Prüfung": "UVV inspection",
    "Auftrag_Abholadresse": "Address",
    "Auftrag_Erzeugeradresse": "Customer",
    "Auftrag_Verwerteradresse": "Recycler",
    "Auftrag_Fahrzeug": "Vehicle",
    "Auftrag_Abholdatum": "Collection date",
    "Auftrag_Abholzeit": "Pick-up time",
    "Permission.BerichteAnzeigen": "Show reports",
    "Permission.BerichteBearbeiten": "Edit reports",
    "Permission.Kalender": "Calendar",
    "Permission.NVEAnzeigen": "Show NVE",
    "Permission.NVEBearbeiten": "Edit NVE",
    "Permission.RegelAnzeigen": "Show rules",
    "Permission.RegelBearbeiten": "Edit rules",
    "ExportMessageStatus_0": "Initial",
    "ExportMessageStatus_1": "Sent",
    "ExportMessageStatus_2": "Processed",
    "ExportMessageStatus_3": "Error",
    "ExportMessageStatus_4": "Wait for ACK",
    "Gerätegruppe": "Device group",
    "Sonstiges": "Miscellaneous",
    "Sprache": "Language",
    "APP Version": "APP version",
    "Local storage": "Local storage",
    "Advanced HTTP": "Advanced HTTP",
    "System Alert Berechtigung": "System Alert Authorization",
    "Navigations-App": "Navigation app",
    "Zurücksetzen": "Reset",
    "WebSocket": "WebSocket",
    "Push-Status": "Push status",
    "Push-ID": "Push ID",
    "Push-Type": "Push type",
    "Anzahl Artikelgruppen": "Number of article groups",
    "Anzahl Artikel": "Number of articles",
    "Anzahl Workflows": "Number of workflows",
    "GPS Dienst läuft": "GPS service running",
    "GPS Dienst aktiv": "GPS service active",
    "GPS Auth-Status": "GPS Auth-Status",
    "GPS-Positionen (Puffer)": "GPS positions (buffer)",
    "Zugangsdaten": "Access data",
    "Geräte-Nummer": "Device number",
    "Host": "Host",
    "Speichern": "Save",
    "Stammdaten neu laden": "Reload master data",
    "Lokale Daten löschen": "Delete local data",
    "Diagnosedaten senden": "Send diagnostic data",
    "Testdatei senden": "Send test file",
    "Update prüfen": "Check update",
    "Dunkler Modus": "Dark mode",
    "Aktivieren": "Activate",
    "Anzeigen": "Display",
    "Anmelden": "Log in",
    "Personalnummer": "Personnel number",
    "Kennwort": "Password",
    "Mit NFC anmelden": "Log in with NFC",
    "Bitte eingeben": "Please enter",
    "Passwort eingeben": "Enter password",
    "Anmelden mit NFC-Chip": "Log in with NFC chip",
    "Zur Anmeldung NFC-Chip scannen": "Scan NFC chip to log in",
    "Mit Personalnummer anmelden": "Log in with personnel number",
    "Ablaufdatum": "Expiration date",
    "Kein Fahrer für RFID-Chip gefunden": "No driver found for RFID chip",
    "Nachrichten": "Messages",
    "Berichte": "Reports",
    "Urlaubsanträge": "Vacation requests",
    "Unfallberichte": "Accident reports",
    "Tätigkeitsberichte": "Activity reports",
    "an": "on",
    "aus": "off",
    "KeineEintraegeVorhanden": "No entries available",
    "StoerzeitFuerAuftrag": "Fault times for order",
    "StoerzeitFuerTour": "Fault times for tour",
    "Minuten": "Minutes",
    "Sekunden": "Seconds",
    "Minute": "Minute",
    "TourNichtGestartetLoeschen": "Tour not started. Deletion not possible.",
    "ZeiterfassungOhneTourFehler": "Time recording cannot be started without a tour",
    "Tour start": "Tour start",
    "Kilometerstand": "Mileage",
    "Fahrer": "Driver",
    "Beifahrer": "Passenger",
    "Bitte wählen": "Please select",
    "Beifahrer 2": "Passenger 2",
    "Abfahrtskontrolle Anhänger": "Trailer departure check",
    "Foto aufnehmen": "Take a photo",
    "Zum Bearbeiten hier tippen": "Tap here to edit",
    "Eingeben": "Enter",
    "Uhrzeit": "Time",
    "Driver": "Driver",
    "Passenger": "Passenger",
    "Passenger 2": "Passenger 2",
    "Trailer": "Trailer",
    "Vehicle": "Vehicle",
    "BitteEingabePruefen": "Please check input!",
    "RFID scannen": "Scan RFID",
    "Tour scannen": "Scan tour",
    "Tour starten": "Start tour",
    "Tour laden": "Load tour",
    "Tour entladen": "Unload tour",
    "Schreiben": "Write",
    "Alle Nachrichten löschen?": "Delete all messages?",
    "Löschen": "Delete",
    "Ja": "Yes",
    "Nein": "No",
    "Nächste Prüfung": "Next test",
    "alle anzeigen": "show all",
    "Bitte KM eingeben": "Please enter KM",
    "NFCErkennungLaeuft": "NFC recognition is running..",
    "RFIDWirdGescannt": "RFID is scanned..",
    "OK": "OK",
    "Fehlerbeschreibung": "Error description",
    "Bild wirklich löschen?": "Really delete the image?",
    "Frage": "Question",
    "Bitte Kilometerstand angeben": "Please state mileage",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Please fill in the arrival check completely",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Please fill in the arrival control tag completely",
    "Bitte Unterschrift erfassen": "Please enter your signature",
    "Bitte Namen für die Unterschrift erfassen": "Please enter names for the signature",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Please allow sufficient time for the arrival check!",
    "AnkunftskontrolleDauerFrage1": "The specified time for the arrival check was not adhered to. Finish the tour anyway?",
    "Tour beenden?": "Finish the tour?",
    "AnkunftskontrolleDauerFrage2": "The specified time for the arrival check was not adhered to. Finish the tour anyway?<br /><br />A message will be sent!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Please fill in the departure check completely",
    "AbfahrtskontrolleMeldung1": "Please allow sufficient time for the departure check!",
    "AbfahrtskontrolleMeldung2": "The specified time for the departure check was not adhered to. Start the tour anyway?",
    "AbfahrtskontrolleMeldung3": "The specified time for the departure check was not adhered to. Start the tour anyway?<br /><br />A message will be sent!",
    "KeineWiegungTourTrotzdemStarten": "No weighing performed. Start the tour anyway?",
    "Wiegung": "Weighing",
    "WiegungErfolgreich": "Weighing required!",
    "Tour start?": "Tour start?",
    "Tour aktiv seit": "Tour active since",
    "Gestartet um": "Started at",
    "Gestartet gestern": "Started yesterday",
    "Gestartet": "Started",
    "Keine gültige Auftragsnummer": "No valid order number",
    "Heute offene Aufträge": "Open orders today",
    "Heute erledigt Aufträge": "Orders completed today",
    "Morgen": "Tomorrow",
    "Keine Transportaufträge": "No transport orders",
    "1 Transportauftrag": "1 transport order",
    "aktuelle Aufträge": "current orders",
    "Statusmeldung428": "Status message not possible. Weighing has already started. Please end tour and restart if necessary.",
    "Meldung429": "<p>Status message not possible. Tour has not yet started.</p><p>Start tour now?</p>",
    "Meldung430": "Status not allowed. Please report one of the following statuses",
    "Meldung431": "Not all items have been reported as complete. Are you sure that the pallet is ready?",
    "Meldung432": "Status message not possible. Please first enter a reason for the time recording '{{NAME}}'.",
    "Es muss mindestens ein Foto gemacht werden!": "At least one photo must be taken!",
    "Alle Aufträge": "All orders",
    "Kommissionierung": "Order picking",
    "Wiegungen": "Weighing",
    "Gekoppelte Waagen": "Coupled scales",
    "Waage suchen...": "Search scales...",
    "Keine Wiegedaten vorhanden": "No weighing data available",
    "Keine Waagen konfiguriert": "No scales configured",
    "Waage": "Scales",
    "MAC Adresse": "MAC address",
    "Aktiv": "Active",
    "Uhr synchronisieren": "Synchronize clock",
    "Wiegen 1": "Cradle 1",
    "Wiegen 2": "Cradle 2",
    "Tarieren": "Taring",
    "Keine neue Waage gefunden": "No new scales found",
    "TourAktivBeendenMeldung449": "Tour is still active. End tour now?",
    "WirklichAbmelden": "Really unsubscribe?",
    "Aktuelle Tour": "Current tour",
    "Tour beenden": "End tour",
    "Zeiterfassung": "Time recording",
    "Zeiterfassung starten": "Start time recording",
    "Tour Ende": "Tour end",
    "Art": "Kind",
    "Arbeitszeit bearbeiten": "Edit working time",
    "Wiegen": "Weighing",
    "Tätigkeitsbericht": "Activity report",
    "Personaldaten": "Personnel data",
    "Tätigkeit": "Activity",
    "Übernachtung": "Overnight stay",
    "Beschreibung der Tätigkeit": "Description of the activity",
    "Neuer Urlaubsantrag": "New vacation request",
    "Abteilung": "Department",
    "Urlaub": "Vacation",
    "Angemeldete Beifahrer": "Registered passengers",
    "Beifahrer hinzufügen": "Add passenger",
    "Beifahrer NFC scannen": "Scan passenger NFC",
    "BeifahrerListeNichtGeladen": "List of passengers could not be loaded. Please check your internet connection.",
    "Beifahrer wurde gescannnt": "Passenger was scanned",
    "NfcKeinBeifahrerGefunden": "No passenger found for RFID chip",
    "BeifahrerAlsFahrerMeldung473": "You are already registered as a driver for this tour. You cannot register again as a passenger.",
    "BeifahrerBereitsAngemeldet": "You are already registered as a passenger.",
    "MaxZweiBeifahrerMoeglich": "A maximum of 2 co-drivers can be registered",
    "BeifahrerNichtGefunden": "Passenger not found",
    "BeifahrerWurdeHinzugefuegt": "Passenger was added",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "A trailer cannot be scanned as a vehicle",
    "Ein LKW kann nicht als Anhänger gescannt werden": "A truck cannot be scanned as a trailer",
    "AngemeldetSeit": "Registered since",
    "Hinzufügen": "Add",
    "NFC scannen": "NFC scan",
    "Beifahrer abmelden": "Log out passenger",
    "Hallo": "Hello",
    "FuehrerscheinkontrolleText1": "the driver's license check is due.",
    "FuehrerscheinkontrolleTextFoto": "Please take a photo of the front and back of your driver's license.",
    "Foto Vorderseite": "Photo front",
    "Foto Rückseite": "Photo back",
    "FuehrerscheinkontrolleTextNFC": "Please scan the NFC chip on your driver's license.",
    "FuehrerscheinkontrolleNfcFalsch": "Invalid NFC chip",
    "Fahrerkarten": "Driver cards",
    "Führerscheinkontrolle": "Driver's license check",
    "Später": "Later",
    "Führerschein erfolgreich gescannt": "Driver's license successfully scanned",
    "Bitte Ablaufdatum erfassen": "Please enter expiration date",
    "Führerscheinprüfung wirklich verschieben?": "Can you really postpone your driving test?",
    "Abmelden?": "Log out?",
    "Bitte NFC-Chip scannen": "Please scan NFC chip",
    "Suchen": "Search",
    "Archiv anzeigen": "Show archive",
    "Übersicht": "Overview",
    "Bitte Entladeort auswählen": "Please select unloading location",
    "Von": "From",
    "Bis": "Until",
    "Zeitausgleich": "Time compensation",
    "Urlaub 2": "Vacation 2",
    "Urlaub 3": "Vacation 3",
    "Urlaub 4": "Vacation 4",
    "Unterschrift erforderlich": "Signature required",
    "Zum unterschreiben hier tippen": "Type here to sign",
    "Unterschrift": "Signature",
    "Wird geladen...": "Loading...",
    "Funktion im Browser nicht verfügbar": "Function not available in the browser",
    "GETRENNT": "DISCONNECTED",
    "FormValidationError": "Please check your entries. The form has not been completed in full.",
    "Permission.ListTouren": "Show tours",
    "Permission.EditTouren": "Edit tours",
    "Protokoll": "Protocol",
    "Werkstatt": "Workshop",
    "Kostenstellen": "Cost centres",
    "Benachrichtigungen": "Notifications",
    "Externe Systeme": "External systems",
    "Regeln": "Rules",
    "Masterdata1": "Cost centre",
    "Feld ist erforderlich": "Field is required",
    "FormularfehlerText": "Please check your entries. The form has not been completed in full.",
    "Eintrag wirklich löschen?": "Really delete entry?",
    "MasterdataList1": "Cost centres",
    "EintragWirklichLoeschen": "Are you sure you want to delete this entry?",
    "Loeschen": "Delete",
    "AusgewaehlteZeilenWirklichLoeschen": "Really delete selected lines?",
    "Gerätegruppe einschränken": "Restrict device group",
    "Fahrer-Namen nicht anzeigen": "Do not display driver names",
    "Rolle bearbeiten": "Edit role",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Edit device groups (simple data)",
    "Permission.Werkstattuebersicht": "Workshop overview",
    "Permission.Kostenstellen": "Cost centres",
    "Permission.EinstellungenKunde": "Settings (simple)",
    "Design": "Design",
    "Benutzeranmeldung": "User login",
    "Fotos": "Photos",
    "Tour E-Mails": "Tour emails",
    "Sicherheitshinweis": "Safety note",
    "Pellets": "Pellets",
    "Allgemein": "General",
    "Custom CSS": "Custom CSS",
    "Barcodes": "Barcodes",
    "Datenherkunft": "Data origin",
    "Freigabeprozess": "Release process",
    "Kontakte": "Contacts",
    "Menü": "Menu",
    "Preise": "Prices",
    "Verträge": "Contracts",
    "Tour-Start": "Tour start",
    "Tour-Ende": "Tour end",
    "GPS": "GPS",
    "GPS-Positionen": "GPS positions",
    "Position senden": "Send position",
    "Navigation": "Navigation",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Container",
    "Peripherie": "Peripherals",
    "Drucker": "Printer",
    "Mobile Waagen": "Mobile scales",
    "Stationäre Waagen": "Stationary scales",
    "Proglove": "Proglove",
    "LKW-Beladung": "Lorry loading",
    "Web": "Web",
    "Tourenplanung": "Tour planning",
    "Sondermodule": "Special modules",
    "Sprachen": "Languages",
    "Datenbereinigung": "Data cleansing",
    "Daten-Export": "Data export",
    "Fehlerdiagnose": "Fault diagnosis",
    "Untermandanten": "Sub-clients",
    "WebSocket-Verbindung": "WebSocket connection",
    "Aufträge": "Orders",
    "Karte": "Map",
    "ExtNummer": "Ext. order number",
    "ExtNummerHierEingeben": "Enter ext. order number here..",
    "Foto aus Galerie auswählen": "Select photo from gallery"
  },
  "PL": {
    "Permissions": "Zezwolenia",
    "Permission.ShowUsers": "Pokaż użytkowników",
    "Permission.EditUsers": "Zarządzanie użytkownikami",
    "Permission.ShowProjects": "Pokaż projekty",
    "Permission.EditProjects": "Zarządzanie projektami",
    "Permission.ShowApplications": "Pokaż aplikacje",
    "Permission.EditApplications": "Zarządzanie aplikacjami",
    "Permission.ShowDemandRequest": "Zapytania dotyczące wymagań pokazowych",
    "Permission.EditDemandRequest": "Zarządzanie zamówieniami zakupu",
    "Permission.CreateDemandRequest": "Tworzenie zapytań o wymagania",
    "Permission.ShowUserRoles": "Wyświetlanie ról użytkowników",
    "Permission.EditUserRoles": "Zarządzanie rolami użytkowników",
    "Permission.ShowGeraete": "Pokaż urządzenia",
    "Permission.EditGeraete": "Zarządzanie urządzeniami",
    "Permission.ReadGeraete": "Czytaj urządzenia",
    "Permission.Administration": "Administracja",
    "Permission.ReadAuftrag": "Przeczytaj zamówienia",
    "Permission.ListAuftraege": "Pokaż zamówienia",
    "Permission.ShowKarte": "Pokaż mapę",
    "Permission.ProtokollAnzeigen": "Pokaż protokół",
    "Permission.ProtokollBearbeiten": "Edytuj protokół",
    "Permission.KarteAnzeigen": "Pokaż mapę",
    "Permission.WorkflowsAnzeigen": "Pokaż przepływy pracy",
    "Permission.WorkflowsBearbeiten": "Edycja przepływów pracy",
    "Permission.FahrerBearbeiten": "Edytuj sterownik",
    "Permission.FahrerAnzeigen": "Pokaż kierowcę",
    "Permission.FahrzeugBearbeiten": "Edycja pojazdów",
    "Permission.FahrzeugAnzeigen": "Pokaż pojazdy",
    "Permission.ArtikelAnzeigen": "Pokaż artykuł",
    "Permission.ArtikelBearbeiten": "Edytuj artykuł",
    "Permission.UvvKatalogAnzeigen": "Pokaż katalog UVV",
    "Permission.UvvKatalogBearbeiten": "Edytuj katalog UVV",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Pokaż katalog kontroli odlotów",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Edytuj katalog kontroli odlotów",
    "Permission.FormulareBearbeiten": "Edycja formularzy",
    "Permission.UvvPruefungenAnzeigen": "Pokaż inspekcje UVV",
    "Permission.UvvPruefungenBearbeiten": "Kontrole UVV procesu",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Wyświetlanie obiektów UVV",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Edycja obiektów UVV",
    "Permission.ChecklisteBearbeiten": "Edycja list kontrolnych",
    "Permission.ChecklisteAnzeigen": "Wyświetlanie list kontrolnych",
    "Permission.AdresseAnzeigen": "Pokaż adresy",
    "Permission.DokumenteBearbeiten": "Edycja dokumentów",
    "Permission.DruckformulareAnzeigen": "Pokaż formularze drukowania",
    "Permission.DruckformulareBearbeiten": "Edycja formularzy drukowania",
    "Permission.ArtikelgruppenAnzeigen": "Pokaż grupy artykułów",
    "Permission.ArtikelgruppenBearbeiten": "Edycja grup artykułów",
    "Permission.Sysadmin": "Sysadmin",
    "Permission.FahrzeuggruppenAnzeigen": "Pokaż grupy pojazdów",
    "Permission.FahrzeuggruppenBearbeiten": "Edycja grup pojazdów",
    "Permission.GeraetegruppenAnzeigen": "Wyświetlanie grup urządzeń",
    "Permission.GeraetegruppenBearbeiten": "Edycja grup urządzeń",
    "Permission.StatuszusatzinfoAnzeigen": "Wyświetlanie dodatkowych informacji o stanie",
    "Permission.StatuszusatzinfoBearbeiten": "Edycja dodatkowych informacji o statusie",
    "Permission.Nachrichten": "Aktualności",
    "Permission.AdresseBearbeiten": "Edytuj adresy",
    "Permission.WaageAnzeigen": "Pokaż wagę",
    "Permission.WaageBearbeiten": "Edycja wag",
    "Permission.Tabellenkonfiguration": "Konfiguracja tabeli",
    "Permission.EditGeraeteEinfacheDaten": "Urządzenia Zmień proste dane",
    "Permission.AuftraegeBearbeiten": "Edytuj zamówienia",
    "Permission.AuftraegeLoeschen": "Usuń zamówienia",
    "Permission.DokumenteAnzeigen": "Pokaż dokumenty",
    "Permission.Dashboard": "Przegląd (pulpit nawigacyjny)",
    "Permission.GastzugangAnzeigen": "Pokaż dostęp gościa",
    "Permission.GastzugangBearbeiten": "Edycja dostępu gościa",
    "Permission.StammtourAnzeigen": "Pokaż regularną trasę",
    "Permission.StammtourBearbeiten": "Edytuj regularną trasę",
    "Permission.StoerzeitAnzeigen": "Wyświetlanie czasu usterki",
    "Permission.StoerzeitBearbeiten": "Edytuj czas błędu",
    "Permission.TourenAnzeigen": "Pokaż wycieczki",
    "Permission.TourenBearbeiten": "Edycja wycieczek",
    "Permission.Tourenplanung": "Planowanie podróży",
    "Anmelden mit Personalnummer": "Zaloguj się za pomocą numeru personalnego",
    "TourWiegung1": "1. Ważenie",
    "TourWiegung2": "2. Ważenie",
    "BitteWiegung1Durchfuehren": "Należy przeprowadzić pierwsze ważenie",
    "BitteWiegung2Durchfuehren": "Prosimy o przeprowadzenie drugiego ważenia",
    "Permission.AbfahrtskontrolleBearbeiten": "Edycja kontroli odlotów",
    "Permission.AbfahrtskontrolleAnzeigen": "Pokaż kontrolę odlotów",
    "Permission.Auswertungen": "Analizy",
    "Permission.TexteAnzeigen": "Pokaż teksty",
    "Permission.TexteBearbeiten": "Edycja tekstów",
    "AuftragWiegung1": "1. Ważenie",
    "AuftragWiegung2": "2. Ważenie",
    "Beladung": "Ładowanie",
    "Auftrag scannen": "Kolejność skanowania",
    "Tour": "Wycieczka",
    "Home_Anmelden": "Zaloguj się za pomocą numeru personalnego",
    "Home_TourStarten": "Rozpoczęcie wycieczki",
    "Home_TourBeenden": "Koniec wycieczki",
    "Home_AuftragScannen": "Kolejność skanowania",
    "Home_Beladung": "Ładowanie",
    "Home_Hofauftraege": "Nakazy sądowe",
    "Wareneingang": "Przychodzące towary",
    "Glas-Analyse": "Analiza szkła",
    "Home_Uebersicht": "Przegląd",
    "Home_Kunden": "Klienci",
    "NagivationHome": "Strona główna",
    "UVV-Prüfungen": "Inspekcje UVV",
    "Dokumente": "Dokumenty",
    "Abmelden": "Wylogowanie",
    "Smartwatch": "Smartwatch",
    "ProGlove": "ProGlove",
    "Home_System": "System",
    "Permission.VertraegeAnzeigen": "Pokaż umowy",
    "Permission.VertraegeBearbeiten": "Edycja umów",
    "Save": "Zapisz",
    "Cancel": "Anuluj",
    "NeuenTransportauftragAnlegen": "Utworzyć nowe żądanie transportu?",
    "NeuenWareneingangAnlegen": "Wprowadzić nowy paragon?",
    "NeuenHofauftragAnlegen": "Utworzyć nowe zamówienie na placu?",
    "Vertrag": "Umowa",
    "Neuer Auftrag": "Nowe zamówienie",
    "Abbrechen": "Anuluj",
    "Home_Zeiterfassung": "Rejestrowanie czasu",
    "SchreibgeschuetztVorStatusmeldung": "Zamówienie jest chronione przed zapisem do czasu pierwszego komunikatu o stanie",
    "NavigationErlaubenWennSchreibgeschuetzt": "Zezwalaj na nawigację, jeśli zabezpieczone przed zapisem",
    "TransportauftragLeerePositionenAusblenden": "Ukryj elementy z ilością 0",
    "Auswertungen": "Analizy",
    "Abfahrtskontrolle": "Kontrola odlotów",
    "UVV-Gegenstände": "Obiekty UVV",
    "UVV-Katalog": "Katalog UVV",
    "Einträge": "Wpisy",
    "Name": "Nazwa",
    "Beschreibung": "Opis",
    "REST-Schnittstelle": "Interfejs REST",
    "Abrechnung aktiv": "Rozliczenia aktywne",
    "API-Token": "Token API",
    "Angelegt am": "Utworzono dnia",
    "Vorname": "Imię",
    "Nachname": "Nazwisko",
    "Email": "E-mail",
    "Roles": "Role użytkowników",
    "Field is required": "Pole jest wymagane",
    "E-Mail": "E-mail",
    "Zugangsdaten ändern": "Zmiana danych dostępu",
    "Passwort": "Hasło",
    "Passwort (bestätigen)": "Hasło (potwierdź)",
    "Benutzer bearbeiten": "Edytuj użytkownika",
    "Key": "Klucz",
    "Checkliste": "Lista kontrolna",
    "Mandant": "Klient",
    "ApiToken": "Token API",
    "Latitude": "Szerokość geograficzna",
    "Longitude": "Długość geograficzna",
    "Max. Entfernung": "Maks. Odległość",
    "Timeout": "Limit czasu",
    "Icon": "Ikona",
    "Nummer": "Liczba",
    "Bezeichnung": "Oznaczenie",
    "Gruppe": "Grupa",
    "App Version": "Wersja aplikacji",
    "Traffic aktueller Monat": "Ruch w bieżącym miesiącu",
    "Personalnr.": "Personel nr.",
    "Personal": "Personel",
    "Zuletzt online": "Ostatni online",
    "Fahrzeug": "Pojazd",
    "Anhänger": "Zwiastun",
    "Letzte Position": "Ostatnia pozycja",
    "Farbe": "Kolor",
    "Letzte Anmeldung": "Ostatnia rejestracja",
    "Letzte Abmeldung": "Ostatnie wyrejestrowanie",
    "Angemeldet": "Zalogowany",
    "Telefon": "Telefon",
    "Freitext": "Dowolny tekst",
    "Platform": "Platforma",
    "Version": "Wersja",
    "Hersteller": "Producent",
    "Model": "Model",
    "Alert Berechtigung": "Autoryzacja alertu",
    "Erste Verwendung": "Pierwsze użycie",
    "Letzte Verwendung": "Ostatnie użycie",
    "Abrechnung ab": "Rozliczenie od",
    "Abrechnung bis": "Rozliczenie do",
    "Preis / Monat": "Cena / miesiąc",
    "Einmaliger Preis ": "Cena jednorazowa",
    "Geräte (Systemansicht)": "Urządzenia (widok systemu)",
    "RoleName": "RoleName",
    "Symbol": "Symbol",
    "App-Version": "Wersja aplikacji",
    "Verfügbare Waagen": "Dostępne wagi",
    "Importieren": "Import",
    "Gerätegruppe bearbeiten": "Edycja grupy urządzeń",
    "Kopieren": "Kopia",
    "Exportieren": "Eksport",
    "Zeit (h)": "Czas (h)",
    "Intervall (m)": "Interwał (m)",
    "MeldungText": "MessageText",
    "Standard-Dauer": "Standardowy czas trwania",
    "Typ": "Typ",
    "Datum": "Data",
    "Verlauf": "Kurs",
    "Auftragsnr.": "Nr zamówienia.",
    "Gerätenr.": "Nr urządzenia.",
    "Gerät": "Urządzenie",
    "Status": "Status",
    "PushStatus": "PushStatus",
    "Abholdatum": "Data odbioru",
    "Abholzeit": "Czas odbioru",
    "Erfasser": "Kolekcjoner",
    "Adress Nr.": "Adres nr.",
    "Name1": "Nazwa1",
    "Name2": "Nazwa2",
    "Strasse": "Ul",
    "PLZ": "KOD POCZTOWY",
    "Ort": "Lokalizacja",
    "Kunde Nr.": "Nr klienta.",
    "Kunde Name1": "Nazwa klienta1",
    "Kunde Name2": "Nazwa klienta2",
    "Kunde Strasse": "Ulica klienta",
    "Kunde PLZ": "Kod pocztowy klienta",
    "Kunde Ort": "Lokalizacja klienta",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "DetailInfo1",
    "DetailInfo2": "DetailInfo2",
    "DetailInfo3": "DetailInfo3",
    "Workflow": "Przepływ pracy",
    "Statusmeldung": "Komunikat o stanie",
    "Statuszeit": "Czas statusu",
    "Reihenfolge": "Sekwencja",
    "CreationDate": "CreationDate",
    "ModificationDate": "ModificationDate",
    "Lieferpositionen": "Elementy dostawy",
    "Auftrag": "Zamówienie",
    "RememberMe": "Pozostań zalogowany",
    "Username": "Nazwa użytkownika",
    "Geräte": "Urządzenia",
    "Stammdaten": "Dane podstawowe",
    "Adressen": "Adresy",
    "Artikelgruppen": "Grupy artykułów",
    "Artikel": "Artykuł",
    "Checklisten": "Listy kontrolne",
    "Fahrer (Personal)": "Kierowca (personel)",
    "Fahrzeuge": "Pojazdy",
    "Fahrzeuggruppen": "Grupy pojazdów",
    "Konfiguration": "Konfiguracja",
    "Benutzer": "Użytkownicy",
    "Benutzerrollen": "Role użytkowników",
    "Druckformulare": "Drukowanie formularzy",
    "Einstellungen": "Ustawienia",
    "Formulare": "Formularze",
    "Gerätegruppen": "Grupy urządzeń",
    "Waagen": "Wagi",
    "Workflows": "Przepływy pracy",
    "Statuszusatzinfo": "Dodatkowe informacje o stanie",
    "Texte": "Teksty",
    "Import / Export": "Import / Eksport",
    "Benutzername": "Nazwa użytkownika",
    "E-Mail-Adresse": "Adres e-mail",
    "Passwort ändern": "Zmiana hasła",
    "Permission.Benachrichtigungen": "Powiadomienia",
    "Permission.ZeiterfassungAnzeigen": "Wyświetlanie nagrywania czasu",
    "Permission.ZeiterfassungBearbeiten": "Edycja nagrywania czasu",
    "Nachtmodus": "Tryb nocny",
    "Nachmodus": "Tryb nocny",
    "KeineAuftraegeGefunden": "Nie znaleziono żadnych zamówień",
    "KeineAuftraegeVorhanden": "Brak dostępnych zamówień. Pociągnij w dół, aby odświeżyć.",
    "TourStartenAlertButtonText": "Rozpocznij wycieczkę!",
    "Aktuelle Aufträge anzeigen": "Pokaż bieżące zamówienia",
    "Archiv": "Archiwum",
    "weitere Aufträge vorhanden": "dostępne są dalsze zamówienia",
    "weiterer Auftrag vorhanden": "dostępne są dalsze zamówienia",
    "Anmerkungen": "Uwagi",
    "AnmerkungenHierEingeben": "Wpisz komentarz tutaj..",
    "AuftragDarfNichtGeaendertWerden": "Kolejność nie może zostać zmieniona",
    "AuftragBereitsAbgeschlossen": "Zamówienie zostało już zrealizowane. Zmiany nie są już możliwe.",
    "Start": "Start",
    "System": "System",
    "Transportaufträge": "Zlecenia transportowe",
    "Hofaufträge": "Nakazy sądowe",
    "Entladeort": "Punkt rozładunku",
    "Bitte Entladeort wählen": "Wybierz miejsce rozładunku",
    "TourStart_Wiegen": "Ważenie",
    "TourEnde_StartWiegung": "Ważenie na początku trasy",
    "TourEnde_EndeWiegung": "Ważenie (cała ciężarówka)",
    "Geplante Reihenfolge anzeigen": "Pokaż zaplanowaną sekwencję",
    "Permission.GlasAnalyseAnzeigen": "Pokaż analizę szkła",
    "Permission.GlasAnalyseBearbeiten": "Edycja analizy szkła",
    "BitteAuswaehlenPlaceholder": "Wybierz",
    "BitteAnlageWaehlen": "Wybierz system",
    "Permission.GlasAnalyseKonfiguration": "Konfiguracja analizy szkła",
    "UVV Prüfung": "Kontrola UVV",
    "Auftrag_Abholadresse": "Adres",
    "Auftrag_Erzeugeradresse": "Klient",
    "Auftrag_Verwerteradresse": "Recykler",
    "Auftrag_Fahrzeug": "Pojazd",
    "Auftrag_Abholdatum": "Data odbioru",
    "Auftrag_Abholzeit": "Czas odbioru",
    "Permission.BerichteAnzeigen": "Pokaż raporty",
    "Permission.BerichteBearbeiten": "Edycja raportów",
    "Permission.Kalender": "Kalendarz",
    "Permission.NVEAnzeigen": "Pokaż NVE",
    "Permission.NVEBearbeiten": "Edytuj NVE",
    "Permission.RegelAnzeigen": "Zasady pokazu",
    "Permission.RegelBearbeiten": "Edytuj zasady",
    "ExportMessageStatus_0": "Początkowy",
    "ExportMessageStatus_1": "Wysłany",
    "ExportMessageStatus_2": "Przetworzone",
    "ExportMessageStatus_3": "Błąd",
    "ExportMessageStatus_4": "Oczekiwanie na ACK",
    "Gerätegruppe": "Grupa urządzeń",
    "Sonstiges": "Różne",
    "Sprache": "Język",
    "APP Version": "Wersja APP",
    "Local storage": "Lokalna pamięć masowa",
    "Advanced HTTP": "Zaawansowany HTTP",
    "System Alert Berechtigung": "Autoryzacja alertu systemowego",
    "Navigations-App": "Aplikacja nawigacyjna",
    "Zurücksetzen": "Reset",
    "WebSocket": "WebSocket",
    "Push-Status": "Stan naciśnięcia",
    "Push-ID": "Push ID",
    "Push-Type": "Typ push",
    "Anzahl Artikelgruppen": "Liczba grup artykułów",
    "Anzahl Artikel": "Liczba artykułów",
    "Anzahl Workflows": "Liczba przepływów pracy",
    "GPS Dienst läuft": "Uruchomiona usługa GPS",
    "GPS Dienst aktiv": "Aktywna usługa GPS",
    "GPS Auth-Status": "Status autoryzacji GPS",
    "GPS-Positionen (Puffer)": "Pozycje GPS (bufor)",
    "Zugangsdaten": "Dane dostępu",
    "Geräte-Nummer": "Numer urządzenia",
    "Host": "Gospodarz",
    "Speichern": "Zapisz",
    "Stammdaten neu laden": "Przeładuj dane podstawowe",
    "Lokale Daten löschen": "Usuwanie danych lokalnych",
    "Diagnosedaten senden": "Wysyłanie danych diagnostycznych",
    "Testdatei senden": "Wyślij plik testowy",
    "Update prüfen": "Sprawdź aktualizację",
    "Dunkler Modus": "Tryb ciemny",
    "Aktivieren": "Aktywuj",
    "Anzeigen": "Wyświetlacze",
    "Anmelden": "Zaloguj się",
    "Personalnummer": "Numer personelu",
    "Kennwort": "Hasło",
    "Mit NFC anmelden": "Logowanie za pomocą NFC",
    "Bitte eingeben": "Wprowadź",
    "Passwort eingeben": "Wprowadź hasło",
    "Anmelden mit NFC-Chip": "Logowanie za pomocą chipu NFC",
    "Zur Anmeldung NFC-Chip scannen": "Zeskanuj chip NFC, aby się zalogować",
    "Mit Personalnummer anmelden": "Zaloguj się przy użyciu numeru personalnego",
    "Ablaufdatum": "Data ważności",
    "Kein Fahrer für RFID-Chip gefunden": "Nie znaleziono sterownika dla chipa RFID",
    "Nachrichten": "Aktualności",
    "Berichte": "Raporty",
    "Urlaubsanträge": "Prośby o urlop",
    "Unfallberichte": "Raporty z wypadków",
    "Tätigkeitsberichte": "Raporty z działalności",
    "an": "na",
    "aus": "off",
    "KeineEintraegeVorhanden": "Brak dostępnych wpisów",
    "StoerzeitFuerAuftrag": "Czasy awarii dla zamówienia",
    "StoerzeitFuerTour": "Czasy awarii dla trasy",
    "Minuten": "Minuty",
    "Sekunden": "Sekundy",
    "Minute": "Minuta",
    "TourNichtGestartetLoeschen": "Wycieczka nie została rozpoczęta. Usunięcie niemożliwe.",
    "ZeiterfassungOhneTourFehler": "Rejestracji czasu nie można uruchomić bez trasy",
    "Tour start": "Początek wycieczki",
    "Kilometerstand": "Przebieg",
    "Fahrer": "Kierowca",
    "Beifahrer": "Pasażer",
    "Bitte wählen": "Wybierz",
    "Beifahrer 2": "Pasażer 2",
    "Abfahrtskontrolle Anhänger": "Kontrola odjazdu przyczepy",
    "Foto aufnehmen": "Zrób zdjęcie",
    "Zum Bearbeiten hier tippen": "Stuknij tutaj, aby edytować",
    "Eingeben": "Enter",
    "Uhrzeit": "Pora dnia",
    "Driver": "Kierowca",
    "Passenger": "Pasażer",
    "Passenger 2": "Pasażer 2",
    "Trailer": "Zwiastun",
    "Vehicle": "Pojazd",
    "BitteEingabePruefen": "Sprawdź wprowadzone dane!",
    "RFID scannen": "Skanowanie RFID",
    "Tour scannen": "Skanowanie trasy",
    "Tour starten": "Rozpoczęcie wycieczki",
    "Tour laden": "Ładowanie trasy",
    "Tour entladen": "Wycieczka rozładunkowa",
    "Schreiben": "Pisanie",
    "Alle Nachrichten löschen?": "Usunąć wszystkie wiadomości?",
    "Löschen": "Usuń",
    "Ja": "Tak",
    "Nein": "Nie",
    "Nächste Prüfung": "Następny test",
    "alle anzeigen": "pokaż wszystko",
    "Bitte KM eingeben": "Wprowadź KM",
    "NFCErkennungLaeuft": "Rozpoznawanie NFC działa..",
    "RFIDWirdGescannt": "RFID jest skanowany..",
    "OK": "OK",
    "Fehlerbeschreibung": "Opis błędu",
    "Bild wirklich löschen?": "Naprawdę usunąć obraz?",
    "Frage": "Pytanie",
    "Bitte Kilometerstand angeben": "Prosimy o podanie przebiegu",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Prosimy o pełne wypełnienie formularza przybycia",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Prosimy o pełne wypełnienie karty kontroli przybycia",
    "Bitte Unterschrift erfassen": "Wprowadź podpis",
    "Bitte Namen für die Unterschrift erfassen": "Wprowadź nazwy dla podpisu",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Prosimy o zapewnienie wystarczającej ilości czasu na sprawdzenie przybycia!",
    "AnkunftskontrolleDauerFrage1": "Określony czas kontroli przybycia nie został dotrzymany. Mimo to zakończyć wycieczkę?",
    "Tour beenden?": "Zakończyć wycieczkę?",
    "AnkunftskontrolleDauerFrage2": "Określony czas kontroli przybycia nie był przestrzegany. Czy mimo to zakończyć wycieczkę? <br /><br />Wiadomość zostanie wysłana!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Prosimy o kompletne wypełnienie czeku wyjazdu",
    "AbfahrtskontrolleMeldung1": "Prosimy o pozostawienie wystarczającej ilości czasu na odprawę wyjazdową!",
    "AbfahrtskontrolleMeldung2": "Określony czas kontroli odlotu nie został dotrzymany. Mimo to rozpocząć wycieczkę?",
    "AbfahrtskontrolleMeldung3": "Określona godzina odprawy nie została dotrzymana. Czy mimo to rozpocząć wycieczkę? <br /><br />Wiadomość zostanie wysłana!",
    "KeineWiegungTourTrotzdemStarten": "Nie przeprowadzono ważenia. Mimo to rozpocząć trasę?",
    "Wiegung": "Ważenie",
    "WiegungErfolgreich": "Wymagane ważenie!",
    "Tour start?": "Początek wycieczki?",
    "Tour aktiv seit": "Trasa aktywna od",
    "Gestartet um": "Rozpoczęty o godz",
    "Gestartet gestern": "Zaczęło się wczoraj",
    "Gestartet": "Rozpoczęty",
    "Keine gültige Auftragsnummer": "Brak prawidłowego numeru zamówienia",
    "Heute offene Aufträge": "Otwarte zamówienia już dziś",
    "Heute erledigt Aufträge": "Zamówienia zrealizowane dzisiaj",
    "Morgen": "Jutro",
    "Keine Transportaufträge": "Brak zleceń transportowych",
    "1 Transportauftrag": "1 zlecenie transportowe",
    "aktuelle Aufträge": "aktualne zamówienia",
    "Statusmeldung428": "Komunikat o stanie nie jest możliwy. Ważenie już się rozpoczęło. Zakończ trasę i w razie potrzeby uruchom ją ponownie.",
    "Meldung429": "<p> Komunikat o stanie nie jest możliwy. Wycieczka jeszcze się nie rozpoczęła.</p><p>Rozpocznij wycieczkę teraz?</p>",
    "Meldung430": "Status niedozwolony. Zgłoś jeden z następujących statusów",
    "Meldung431": "Nie wszystkie elementy zostały zgłoszone jako kompletne. Czy paleta jest na pewno gotowa?",
    "Meldung432": "Komunikat o stanie nie jest możliwy. Najpierw wprowadź powód rejestracji czasu \"{{NAME}}\".",
    "Es muss mindestens ein Foto gemacht werden!": "Przynajmniej jedno zdjęcie musi zostać zrobione!",
    "Alle Aufträge": "Wszystkie zamówienia",
    "Kommissionierung": "Kompletacja zamówień",
    "Wiegungen": "Ważenie",
    "Gekoppelte Waagen": "Skale sprzężone",
    "Waage suchen...": "Wyszukiwanie wag...",
    "Keine Wiegedaten vorhanden": "Brak dostępnych danych ważenia",
    "Keine Waagen konfiguriert": "Brak skonfigurowanych wag",
    "Waage": "Wagi",
    "MAC Adresse": "Adres MAC",
    "Aktiv": "Aktywny",
    "Uhr synchronisieren": "Synchronizacja zegara",
    "Wiegen 1": "Kołyska 1",
    "Wiegen 2": "Cradle 2",
    "Tarieren": "Taring",
    "Keine neue Waage gefunden": "Nie znaleziono nowych wag",
    "TourAktivBeendenMeldung449": "Trasa jest nadal aktywna. Zakończyć trasę teraz?",
    "WirklichAbmelden": "Naprawdę się wyrejestrowałeś?",
    "Aktuelle Tour": "Aktualna trasa",
    "Tour beenden": "Koniec wycieczki",
    "Zeiterfassung": "Rejestrowanie czasu",
    "Zeiterfassung starten": "Rozpoczęcie nagrywania czasu",
    "Tour Ende": "Koniec wycieczki",
    "Art": "Rodzaj",
    "Arbeitszeit bearbeiten": "Edycja czasu pracy",
    "Wiegen": "Ważenie",
    "Tätigkeitsbericht": "Raport z działalności",
    "Personaldaten": "Dane osobowe",
    "Tätigkeit": "Aktywność",
    "Übernachtung": "Nocleg",
    "Beschreibung der Tätigkeit": "Opis działania",
    "Neuer Urlaubsantrag": "Nowy wniosek o urlop",
    "Abteilung": "Dział",
    "Urlaub": "Wakacje",
    "Angemeldete Beifahrer": "Zarejestrowani pasażerowie",
    "Beifahrer hinzufügen": "Dodaj współkierowcę",
    "Beifahrer NFC scannen": "Skanowanie pasażerów NFC",
    "BeifahrerListeNichtGeladen": "Nie można załadować listy pasażerów. Sprawdź połączenie internetowe.",
    "Beifahrer wurde gescannnt": "Pasażer został przeskanowany",
    "NfcKeinBeifahrerGefunden": "Nie znaleziono pasażera dla chipa RFID",
    "BeifahrerAlsFahrerMeldung473": "Jesteś już zarejestrowany jako kierowca na tę wycieczkę. Nie możesz zarejestrować się ponownie jako pasażer.",
    "BeifahrerBereitsAngemeldet": "Jesteś już zarejestrowany jako pasażer.",
    "MaxZweiBeifahrerMoeglich": "Można zarejestrować maksymalnie 2 pilotów",
    "BeifahrerNichtGefunden": "Nie znaleziono pasażera",
    "BeifahrerWurdeHinzugefuegt": "Pasażer został dodany",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Przyczepa nie może być skanowana jako pojazd",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Samochód ciężarowy nie może być skanowany jako przyczepa",
    "AngemeldetSeit": "Zarejestrowany od",
    "Hinzufügen": "Dodaj",
    "NFC scannen": "Skanowanie NFC",
    "Beifahrer abmelden": "Wyloguj współkierowcę",
    "Hallo": "Witam",
    "FuehrerscheinkontrolleText1": "kontrola prawa jazdy jest wymagana.",
    "FuehrerscheinkontrolleTextFoto": "Prosimy o zrobienie zdjęcia przedniej i tylnej strony prawa jazdy.",
    "Foto Vorderseite": "Zdjęcie z przodu",
    "Foto Rückseite": "Zdjęcie z tyłu",
    "FuehrerscheinkontrolleTextNFC": "Zeskanuj chip NFC na swoim prawie jazdy.",
    "FuehrerscheinkontrolleNfcFalsch": "Nieprawidłowy chip NFC",
    "Fahrerkarten": "Karty kierowcy",
    "Führerscheinkontrolle": "Kontrola prawa jazdy",
    "Später": "Później",
    "Führerschein erfolgreich gescannt": "Prawo jazdy zostało pomyślnie zeskanowane",
    "Bitte Ablaufdatum erfassen": "Wprowadź datę wygaśnięcia",
    "Führerscheinprüfung wirklich verschieben?": "Czy naprawdę mogę przełożyć egzamin na prawo jazdy?",
    "Abmelden?": "Wylogować się?",
    "Bitte NFC-Chip scannen": "Zeskanuj chip NFC",
    "Suchen": "Wyszukiwanie",
    "Archiv anzeigen": "Pokaż archiwum",
    "Übersicht": "Przegląd",
    "Bitte Entladeort auswählen": "Wybierz miejsce rozładunku",
    "Von": "Od",
    "Bis": "Do",
    "Zeitausgleich": "Wyrównanie czasu",
    "Urlaub 2": "Holiday 2",
    "Urlaub 3": "Holiday 3",
    "Urlaub 4": "Wakacje 4",
    "Unterschrift erforderlich": "Wymagany podpis",
    "Zum unterschreiben hier tippen": "Wpisz tutaj, aby podpisać",
    "Unterschrift": "Podpis",
    "Wird geladen...": "Ładowanie...",
    "Funktion im Browser nicht verfügbar": "Funkcja niedostępna w przeglądarce",
    "GETRENNT": "ODDZIELONY",
    "FormValidationError": "Prosimy o sprawdzenie zgłoszeń. Formularz nie został wypełniony w całości.",
    "Permission.ListTouren": "Pokaż wycieczki",
    "Permission.EditTouren": "Edycja wycieczek",
    "Protokoll": "Protokół",
    "Werkstatt": "Warsztat",
    "Kostenstellen": "Centra kosztów",
    "Benachrichtigungen": "Powiadomienia",
    "Externe Systeme": "Systemy zewnętrzne",
    "Regeln": "Zasady",
    "Masterdata1": "Centrum kosztów",
    "Feld ist erforderlich": "Pole jest wymagane",
    "FormularfehlerText": "Prosimy o sprawdzenie zgłoszeń. Formularz nie został wypełniony w całości.",
    "Eintrag wirklich löschen?": "Naprawdę usunąć wpis?",
    "MasterdataList1": "Centra kosztów",
    "EintragWirklichLoeschen": "Czy na pewno chcesz usunąć ten wpis?",
    "Loeschen": "Usuń",
    "AusgewaehlteZeilenWirklichLoeschen": "Naprawdę usunąć wybrane linie?",
    "Gerätegruppe einschränken": "Ogranicz grupę urządzeń",
    "Fahrer-Namen nicht anzeigen": "Nie wyświetlaj nazw kierowców",
    "Rolle bearbeiten": "Edytuj rolę",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Edycja grup urządzeń (proste dane)",
    "Permission.Werkstattuebersicht": "Przegląd warsztatów",
    "Permission.Kostenstellen": "Centra kosztów",
    "Permission.EinstellungenKunde": "Ustawienia (proste)",
    "Design": "Projekt",
    "Benutzeranmeldung": "Logowanie użytkownika",
    "Fotos": "Zdjęcia",
    "Tour E-Mails": "Wiadomości e-mail dotyczące wycieczek",
    "Sicherheitshinweis": "Uwaga dotycząca bezpieczeństwa",
    "Pellets": "Pelety",
    "Allgemein": "Ogólne",
    "Custom CSS": "Niestandardowy CSS",
    "Barcodes": "Kody kreskowe",
    "Datenherkunft": "Pochodzenie danych",
    "Freigabeprozess": "Proces zwalniania",
    "Kontakte": "Kontakty",
    "Menü": "Menu",
    "Preise": "Ceny",
    "Verträge": "Umowy",
    "Tour-Start": "Początek wycieczki",
    "Tour-Ende": "Koniec wycieczki",
    "GPS": "GPS",
    "GPS-Positionen": "Pozycje GPS",
    "Position senden": "Wyślij pozycję",
    "Navigation": "Nawigacja",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Pojemnik",
    "Peripherie": "Urządzenia peryferyjne",
    "Drucker": "Drukarka",
    "Mobile Waagen": "Wagi przenośne",
    "Stationäre Waagen": "Wagi stacjonarne",
    "Proglove": "Proglove",
    "LKW-Beladung": "Załadunek ciężarówki",
    "Web": "Sieć",
    "Tourenplanung": "Planowanie podróży",
    "Sondermodule": "Moduły specjalne",
    "Sprachen": "Języki",
    "Datenbereinigung": "Czyszczenie danych",
    "Daten-Export": "Eksport danych",
    "Fehlerdiagnose": "Diagnostyka błędów",
    "Untermandanten": "Podklienci",
    "WebSocket-Verbindung": "Połączenie WebSocket",
    "Aufträge": "Zlecenia",
    "Karte": "Mapa",
    "ExtNummer": "Zewn. numer zlecenia",
    "ExtNummerHierEingeben": "Wpisz tutaj zewn. numer zlecenia..",
    "Foto aus Galerie auswählen": "Wybierz zdjęcie z galerii"
  },
  "HU": {
    "Permissions": "Jogosultságok",
    "Permission.ShowUsers": "Felhasználók megjelenítése",
    "Permission.EditUsers": "Felhasználók kezelése",
    "Permission.ShowProjects": "Projektek megjelenítése",
    "Permission.EditProjects": "Projektek kezelése",
    "Permission.ShowApplications": "Kérelmek megjelenítése",
    "Permission.EditApplications": "Kérelmek kezelése",
    "Permission.ShowDemandRequest": "Igénykérések megjelenítése",
    "Permission.EditDemandRequest": "Igénykérések kezelése",
    "Permission.CreateDemandRequest": "Igénybejelentések létrehozása",
    "Permission.ShowUserRoles": "Felhasználói szerepkörök megjelenítése",
    "Permission.EditUserRoles": "Felhasználói szerepkörök kezelése",
    "Permission.ShowGeraete": "Készülékek megjelenítése",
    "Permission.EditGeraete": "Eszközök kezelése",
    "Permission.ReadGeraete": "Készülékek leolvasása",
    "Permission.Administration": "Adminisztráció",
    "Permission.ReadAuftrag": "A megbízások elolvasása",
    "Permission.ListAuftraege": "Megrendelések megjelenítése",
    "Permission.ShowKarte": "Térkép megjelenítése",
    "Permission.ProtokollAnzeigen": "Napló megtekintése",
    "Permission.ProtokollBearbeiten": "Napló szerkesztése",
    "Permission.KarteAnzeigen": "Térkép megjelenítése",
    "Permission.WorkflowsAnzeigen": "Munkamenetek megjelenítése",
    "Permission.WorkflowsBearbeiten": "Munkafolyamatok szerkesztése",
    "Permission.FahrerBearbeiten": "Sofőr szerkesztése",
    "Permission.FahrerAnzeigen": "Sofőrök megjelenítése",
    "Permission.FahrzeugBearbeiten": "Járművek szerkesztése",
    "Permission.FahrzeugAnzeigen": "Járművek megjelenítése",
    "Permission.ArtikelAnzeigen": "Cikk megtekintése",
    "Permission.ArtikelBearbeiten": "Cikk szerkesztése",
    "Permission.UvvKatalogAnzeigen": "Az UVV-katalógus megtekintése",
    "Permission.UvvKatalogBearbeiten": "Az UVV-katalógus szerkesztése",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Indulási ellenőrzés – Katalógus megtekintése",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "A kiindulási ellenőrzés katalógusának szerkesztése",
    "Permission.FormulareBearbeiten": "Űrlapok szerkesztése",
    "Permission.UvvPruefungenAnzeigen": "UVV-vizsgálatok megjelenítése",
    "Permission.UvvPruefungenBearbeiten": "UVV-vizsgálatok feldolgozása",
    "Permission.UvvPruefGegenstaendeAnzeigen": "UVV-tárgyak megjelenítése",
    "Permission.UvvPruefGegenstaendeBearbeiten": "UVV-tételek szerkesztése",
    "Permission.ChecklisteBearbeiten": "Ellenőrzőlisták szerkesztése",
    "Permission.ChecklisteAnzeigen": "Ellenőrzőlisták megjelenítése",
    "Permission.AdresseAnzeigen": "Címek megjelenítése",
    "Permission.DokumenteBearbeiten": "Dokumentumok szerkesztése",
    "Permission.DruckformulareAnzeigen": "Nyomtatványok megjelenítése",
    "Permission.DruckformulareBearbeiten": "Nyomtatványok szerkesztése",
    "Permission.ArtikelgruppenAnzeigen": "Termékcsoportok megjelenítése",
    "Permission.ArtikelgruppenBearbeiten": "Cikksoportok szerkesztése",
    "Permission.Sysadmin": "Rendszergazda",
    "Permission.FahrzeuggruppenAnzeigen": "Járműcsoportok megjelenítése",
    "Permission.FahrzeuggruppenBearbeiten": "Járműcsoportok szerkesztése",
    "Permission.GeraetegruppenAnzeigen": "Készülékcsoportok megjelenítése",
    "Permission.GeraetegruppenBearbeiten": "Készülékcsoportok szerkesztése",
    "Permission.StatuszusatzinfoAnzeigen": "Állapotra vonatkozó kiegészítő információk megjelenítése",
    "Permission.StatuszusatzinfoBearbeiten": "Állapot-kiegészítő információk szerkesztése",
    "Permission.Nachrichten": "Hírek",
    "Permission.AdresseBearbeiten": "Címek szerkesztése",
    "Permission.WaageAnzeigen": "Mérlegek megjelenítése",
    "Permission.WaageBearbeiten": "Mérlegek szerkesztése",
    "Permission.Tabellenkonfiguration": "Táblázatkonfiguráció",
    "Permission.EditGeraeteEinfacheDaten": "Egyszerű adatmódosítás az eszközökön",
    "Permission.AuftraegeBearbeiten": "Megrendelések feldolgozása",
    "Permission.AuftraegeLoeschen": "Megrendelések törlése",
    "Permission.DokumenteAnzeigen": "Dokumentumok megjelenítése",
    "Permission.Dashboard": "Áttekintés (Dashboard)",
    "Permission.GastzugangAnzeigen": "Vendégfiók megjelenítése",
    "Permission.GastzugangBearbeiten": "Vendégfiók szerkesztése",
    "Permission.StammtourAnzeigen": "Rendszeres túra megtekintése",
    "Permission.StammtourBearbeiten": "A rendszeres túra szerkesztése",
    "Permission.StoerzeitAnzeigen": "Zavaridő megjelenítése",
    "Permission.StoerzeitBearbeiten": "A zavar idejének szerkesztése",
    "Permission.TourenAnzeigen": "Túrák megjelenítése",
    "Permission.TourenBearbeiten": "Túrák szerkesztése",
    "Permission.Tourenplanung": "Útvonaltervezés",
    "Anmelden mit Personalnummer": "Bejelentkezés személyi számmal",
    "TourWiegung1": "1. Mérlegelés",
    "TourWiegung2": "2. Mérlegelés",
    "BitteWiegung1Durchfuehren": "Kérjük, végezze el az első mérést",
    "BitteWiegung2Durchfuehren": "Kérjük, végezze el a második mérést!",
    "Permission.AbfahrtskontrolleBearbeiten": "Indulási ellenőrzés szerkesztése",
    "Permission.AbfahrtskontrolleAnzeigen": "Indulási ellenőrzés megjelenítése",
    "Permission.Auswertungen": "Elemzések",
    "Permission.TexteAnzeigen": "Szövegek megjelenítése",
    "Permission.TexteBearbeiten": "Szövegek szerkesztése",
    "AuftragWiegung1": "1. Mérlegelés",
    "AuftragWiegung2": "2. Mérlegelés",
    "Beladung": "Rakodás",
    "Auftrag scannen": "Megbízás beolvasása",
    "Tour": "Túra",
    "Home_Anmelden": "Bejelentkezés személyi számmal",
    "Home_TourStarten": "Indítsd el a túrát",
    "Home_TourBeenden": "A túra befejezése",
    "Home_AuftragScannen": "Megbízás beolvasása",
    "Home_Beladung": "Rakodás",
    "Home_Hofauftraege": "Udvari megbízások",
    "Wareneingang": "Áruátvétel",
    "Glas-Analyse": "Üvegelemzés",
    "Home_Uebersicht": "Áttekintés",
    "Home_Kunden": "Ügyfelek",
    "NagivationHome": "Főoldal",
    "UVV-Prüfungen": "UVV-vizsgálatok",
    "Dokumente": "Dokumentumok",
    "Abmelden": "Kijelentkezés",
    "Smartwatch": "Okosóra",
    "ProGlove": "ProGlove",
    "Home_System": "Rendszer",
    "Permission.VertraegeAnzeigen": "Szerződések megtekintése",
    "Permission.VertraegeBearbeiten": "Szerződések szerkesztése",
    "Save": "Mentés",
    "Cancel": "Mégse",
    "NeuenTransportauftragAnlegen": "Új szállítási megbízást szeretne létrehozni?",
    "NeuenWareneingangAnlegen": "Új áruérkezést szeretne rögzíteni?",
    "NeuenHofauftragAnlegen": "Új gazdasági megbízást szeretne létrehozni?",
    "Vertrag": "Szerződés",
    "Neuer Auftrag": "Új megbízás",
    "Abbrechen": "Mégse",
    "Home_Zeiterfassung": "Munkaidő-nyilvántartás",
    "SchreibgeschuetztVorStatusmeldung": "A megbízás az első állapotjelentésig írásvédett",
    "NavigationErlaubenWennSchreibgeschuetzt": "Navigáció engedélyezése írásvédett állapotban",
    "TransportauftragLeerePositionenAusblenden": "A 0 darabos tételek elrejtése",
    "Auswertungen": "Elemzések",
    "Abfahrtskontrolle": "Indulási ellenőrzés",
    "UVV-Gegenstände": "UVV-tárgyak",
    "UVV-Katalog": "UVV-katalógus",
    "Einträge": "Bejegyzések",
    "Name": "Név",
    "Beschreibung": "Leírás",
    "REST-Schnittstelle": "REST-interfész",
    "Abrechnung aktiv": "Elszámolás aktív",
    "API-Token": "API-token",
    "Angelegt am": "Létrehozva:",
    "Vorname": "Keresztnév",
    "Nachname": "Vezetéknév",
    "Email": "E-mail",
    "Roles": "Felhasználói szerepkörök",
    "Field is required": "A mező kitöltése kötelező",
    "E-Mail": "E-mail",
    "Zugangsdaten ändern": "A bejelentkezési adatok módosítása",
    "Passwort": "Jelszó",
    "Passwort (bestätigen)": "Jelszó (megerősítés)",
    "Benutzer bearbeiten": "Felhasználó szerkesztése",
    "Key": "Key",
    "Checkliste": "Ellenőrzőlista",
    "Mandant": "Ügyfél",
    "ApiToken": "API-token",
    "Latitude": "Szélesség",
    "Longitude": "Hosszúsági kör",
    "Max. Entfernung": "Max. távolság",
    "Timeout": "Időkorlát",
    "Icon": "Ikon",
    "Nummer": "Szám",
    "Bezeichnung": "Megnevezés",
    "Gruppe": "Csoport",
    "App Version": "Az alkalmazás verziója",
    "Traffic aktueller Monat": "A jelenlegi hónap forgalma",
    "Personalnr.": "Személyi szám",
    "Personal": "Személyzet",
    "Zuletzt online": "Legutóbb online",
    "Fahrzeug": "Jármű",
    "Anhänger": "pótkocsi",
    "Letzte Position": "Utolsó pozíció",
    "Farbe": "Szín",
    "Letzte Anmeldung": "Utolsó regisztráció",
    "Letzte Abmeldung": "Utolsó kijelentkezés",
    "Angemeldet": "Bejelentkezett",
    "Telefon": "Telefon",
    "Freitext": "Szabad szöveg",
    "Platform": "Platform",
    "Version": "Verzió",
    "Hersteller": "Gyártó",
    "Model": "Modell",
    "Alert Berechtigung": "Riasztási jogosultság",
    "Erste Verwendung": "Első használat",
    "Letzte Verwendung": "Utolsó felhasználás",
    "Abrechnung ab": "Elszámolás kezdete",
    "Abrechnung bis": "Elszámolásig",
    "Preis / Monat": "Ár / hónap",
    "Einmaliger Preis ": "Egyszeri ár ",
    "Geräte (Systemansicht)": "Eszközök (rendszer nézet)",
    "RoleName": "RoleName",
    "Symbol": "Szimbólum",
    "App-Version": "Az alkalmazás verziója",
    "Verfügbare Waagen": "Elérhető mérlegek",
    "Importieren": "Importálás",
    "Gerätegruppe bearbeiten": "Készülékcsoport szerkesztése",
    "Kopieren": "Másolás",
    "Exportieren": "Exportálás",
    "Zeit (h)": "Idő (h)",
    "Intervall (m)": "Intervallum (m)",
    "MeldungText": "Hírszöveg",
    "Standard-Dauer": "Alapértelmezett időtartam",
    "Typ": "Típus",
    "Datum": "Dátum",
    "Verlauf": "Történet",
    "Auftragsnr.": "Megrendelés száma",
    "Gerätenr.": "Készülékszám",
    "Gerät": "Készülék",
    "Status": "Állapot",
    "PushStatus": "PushStatus",
    "Abholdatum": "Átvételi dátum",
    "Abholzeit": "Átvételi időpont",
    "Erfasser": "Feljegyző",
    "Adress Nr.": "Cím száma",
    "Name1": "1. név",
    "Name2": "2. név",
    "Strasse": "Utca",
    "PLZ": "irányítószám",
    "Ort": "Hely",
    "Kunde Nr.": "Ügyfélszám:",
    "Kunde Name1": "Ügyfél neve1",
    "Kunde Name2": "Ügyfél neve2",
    "Kunde Strasse": "Ügyfél utca",
    "Kunde PLZ": "Ügyfél irányítószáma",
    "Kunde Ort": "Ügyfél Helyszín",
    "Info1": "1. információ",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "Részletes információk 1",
    "DetailInfo2": "Részletes információk 2",
    "DetailInfo3": "Részletes információk 3",
    "Workflow": "Munkafolyamat",
    "Statusmeldung": "Állapotjelentés",
    "Statuszeit": "Állapotidő",
    "Reihenfolge": "Sorrend",
    "CreationDate": "Létrehozás dátuma",
    "ModificationDate": "Módosítás dátuma",
    "Lieferpositionen": "Szállítási tételek",
    "Auftrag": "Megbízás",
    "RememberMe": "Bejelentkezve maradni",
    "Username": "Felhasználónév",
    "Geräte": "Készülékek",
    "Stammdaten": "Alapadatok",
    "Adressen": "Címek",
    "Artikelgruppen": "Termékcsoportok",
    "Artikel": "Cikk",
    "Checklisten": "Ellenőrzőlisták",
    "Fahrer (Personal)": "Sofőr (személyzet)",
    "Fahrzeuge": "Járművek",
    "Fahrzeuggruppen": "Járműcsoportok",
    "Konfiguration": "Konfiguráció",
    "Benutzer": "Felhasználó",
    "Benutzerrollen": "Felhasználói szerepkörök",
    "Druckformulare": "Nyomtatványok",
    "Einstellungen": "Beállítások",
    "Formulare": "Űrlapok",
    "Gerätegruppen": "Készülékcsoportok",
    "Waagen": "Mérlegek",
    "Workflows": "Munkafolyamatok",
    "Statuszusatzinfo": "Állapotra vonatkozó kiegészítő információ",
    "Texte": "Szövegek",
    "Import / Export": "Import / Export",
    "Benutzername": "Felhasználónév",
    "E-Mail-Adresse": "E-mail-cím",
    "Passwort ändern": "Jelszó módosítása",
    "Permission.Benachrichtigungen": "Értesítések",
    "Permission.ZeiterfassungAnzeigen": "Munkaidő-nyilvántartás megtekintése",
    "Permission.ZeiterfassungBearbeiten": "A munkaidő-nyilvántartás szerkesztése",
    "Nachtmodus": "Éjszakai mód",
    "Nachmodus": "Éjszakai mód",
    "KeineAuftraegeGefunden": "Nem találtak megbízásokat",
    "KeineAuftraegeVorhanden": "Nincsenek megrendelések. A frissítéshez húzza lefelé.",
    "TourStartenAlertButtonText": "Induljon a túra!",
    "Aktuelle Aufträge anzeigen": "Aktuális megrendelések megjelenítése",
    "Archiv": "Archívum",
    "weitere Aufträge vorhanden": "további megbízások állnak rendelkezésre",
    "weiterer Auftrag vorhanden": "van még egy megbízás",
    "Anmerkungen": "Megjegyzések",
    "AnmerkungenHierEingeben": "Itt írja be a megjegyzéseket…",
    "AuftragDarfNichtGeaendertWerden": "A megrendelést nem szabad módosítani",
    "AuftragBereitsAbgeschlossen": "A megrendelés már lezárult. Módosítások már nem lehetségesek.",
    "Start": "Kezdés",
    "System": "Rendszer",
    "Transportaufträge": "Szállítási megbízások",
    "Hofaufträge": "Udvari megbízások",
    "Entladeort": "Kirakodási hely",
    "Bitte Entladeort wählen": "Kérjük, válassza ki a kirakodási helyet",
    "TourStart_Wiegen": "Mérés",
    "TourEnde_StartWiegung": "Súlymérés a túra kezdetén",
    "TourEnde_EndeWiegung": "Mérés (teljes rakományú teherautó)",
    "Geplante Reihenfolge anzeigen": "A tervezett sorrend megjelenítése",
    "Permission.GlasAnalyseAnzeigen": "Üvegelemzés megtekintése",
    "Permission.GlasAnalyseBearbeiten": "Üvegelemzés szerkesztése",
    "BitteAuswaehlenPlaceholder": "Kérjük, válasszon",
    "BitteAnlageWaehlen": "Kérjük, válasszon mellékletet",
    "Permission.GlasAnalyseKonfiguration": "Üveg-elemzés konfigurációja",
    "UVV Prüfung": "UVV-ellenőrzés",
    "Auftrag_Abholadresse": "Cím",
    "Auftrag_Erzeugeradresse": "Ügyfél",
    "Auftrag_Verwerteradresse": "Feldolgozó",
    "Auftrag_Fahrzeug": "Jármű",
    "Auftrag_Abholdatum": "Átvételi dátum",
    "Auftrag_Abholzeit": "Átvételi időpont",
    "Permission.BerichteAnzeigen": "Jelentések megtekintése",
    "Permission.BerichteBearbeiten": "Jelentések szerkesztése",
    "Permission.Kalender": "Naptár",
    "Permission.NVEAnzeigen": "NVE megjelenítése",
    "Permission.NVEBearbeiten": "NVE szerkesztése",
    "Permission.RegelAnzeigen": "Szabályok megjelenítése",
    "Permission.RegelBearbeiten": "Szabályok szerkesztése",
    "ExportMessageStatus_0": "Kezdőbetű",
    "ExportMessageStatus_1": "Elküldve",
    "ExportMessageStatus_2": "Feldolgozva",
    "ExportMessageStatus_3": "Hiba",
    "ExportMessageStatus_4": "Várj az ACK-ra",
    "Gerätegruppe": "Készülékcsoport",
    "Sonstiges": "Egyéb",
    "Sprache": "Nyelv",
    "APP Version": "Az alkalmazás verziója",
    "Local storage": "Helyi tároló",
    "Advanced HTTP": "Fejlett HTTP",
    "System Alert Berechtigung": "Rendszerriasztási jogosultság",
    "Navigations-App": "Navigációs alkalmazás",
    "Zurücksetzen": "Visszaállítás",
    "WebSocket": "WebSocket",
    "Push-Status": "Push-állapot",
    "Push-ID": "Push-ID",
    "Push-Type": "Push-típusú",
    "Anzahl Artikelgruppen": "Termékcsoportok száma",
    "Anzahl Artikel": "Termékek száma",
    "Anzahl Workflows": "A munkafolyamatok száma",
    "GPS Dienst läuft": "A GPS-szolgáltatás működik",
    "GPS Dienst aktiv": "GPS-szolgáltatás aktív",
    "GPS Auth-Status": "GPS-hitelesítési állapot",
    "GPS-Positionen (Puffer)": "GPS-koordináták (puffer)",
    "Zugangsdaten": "Bejelentkezési adatok",
    "Geräte-Nummer": "Készülékszám",
    "Host": "Házigazda",
    "Speichern": "Mentés",
    "Stammdaten neu laden": "Alapadatok újratöltése",
    "Lokale Daten löschen": "Helyi adatok törlése",
    "Diagnosedaten senden": "Diagnosztikai adatok elküldése",
    "Testdatei senden": "Tesztfájl elküldése",
    "Update prüfen": "Frissítés ellenőrzése",
    "Dunkler Modus": "Sötét mód",
    "Aktivieren": "Aktiválás",
    "Anzeigen": "Hirdetések",
    "Anmelden": "Bejelentkezés",
    "Personalnummer": "Személyi azonosítószám",
    "Kennwort": "Jelszó",
    "Mit NFC anmelden": "Bejelentkezés NFC-vel",
    "Bitte eingeben": "Kérjük, írja be",
    "Passwort eingeben": "Jelszó megadása",
    "Anmelden mit NFC-Chip": "Bejelentkezés NFC-chip segítségével",
    "Zur Anmeldung NFC-Chip scannen": "A regisztrációhoz olvassa be az NFC-chipet",
    "Mit Personalnummer anmelden": "Bejelentkezés személyi számmal",
    "Ablaufdatum": "Lejárati dátum",
    "Kein Fahrer für RFID-Chip gefunden": "Nem található illesztőprogram az RFID-chiphez",
    "Nachrichten": "Hírek",
    "Berichte": "Jelentések",
    "Urlaubsanträge": "Szabadságkérelmek",
    "Unfallberichte": "Baleseti jelentések",
    "Tätigkeitsberichte": "Tevékenységi jelentések",
    "an": "-hoz",
    "aus": "-ból",
    "KeineEintraegeVorhanden": "Nincs bejegyzés",
    "StoerzeitFuerAuftrag": "A megrendelés feldolgozásának szünetei",
    "StoerzeitFuerTour": "A túra zavaró időszakai",
    "Minuten": "perc",
    "Sekunden": "másodpercek",
    "Minute": "perc",
    "TourNichtGestartetLoeschen": "A túra nem indult el. Törlés nem lehetséges.",
    "ZeiterfassungOhneTourFehler": "Az időnyilvántartás nem indítható el útvonal nélkül",
    "Tour start": "A túra kezdete",
    "Kilometerstand": "Kilométerállás",
    "Fahrer": "Sofőr",
    "Beifahrer": "utas",
    "Bitte wählen": "Kérjük, válasszon",
    "Beifahrer 2": "2. utas",
    "Abfahrtskontrolle Anhänger": "Indulási ellenőrzés pótkocsi",
    "Foto aufnehmen": "Fénykép készítése",
    "Zum Bearbeiten hier tippen": "A szerkesztéshez érintse meg ezt a helyet",
    "Eingeben": "Beírás",
    "Uhrzeit": "Időpont",
    "Driver": "Illesztőprogram",
    "Passenger": "Utas",
    "Passenger 2": "2. utas",
    "Trailer": "Előzetes",
    "Vehicle": "Jármű",
    "BitteEingabePruefen": "Kérjük, ellenőrizze a bevitt adatokat!",
    "RFID scannen": "RFID-leolvasás",
    "Tour scannen": "Túra beolvasása",
    "Tour starten": "Indítsd el a túrát",
    "Tour laden": "Túra betöltése",
    "Tour entladen": "Túra letöltése",
    "Schreiben": "Levél",
    "Alle Nachrichten löschen?": "Törölni szeretné az összes üzenetet?",
    "Löschen": "Törlés",
    "Ja": "Igen",
    "Nein": "Nem",
    "Nächste Prüfung": "Következő vizsga",
    "alle anzeigen": "mindet megjeleníteni",
    "Bitte KM eingeben": "Kérjük, adja meg a KM-értéket",
    "NFCErkennungLaeuft": "Az NFC-felismerés folyamatban van…",
    "RFIDWirdGescannt": "Az RFID-t beolvassák…",
    "OK": "OK",
    "Fehlerbeschreibung": "A hiba leírása",
    "Bild wirklich löschen?": "Tényleg törölni szeretné a képet?",
    "Frage": "Kérdés",
    "Bitte Kilometerstand angeben": "Kérjük, adja meg a kilométerállást!",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Kérjük, töltse ki teljes körűen az érkezési űrlapot!",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Kérjük, töltse ki teljes körűen az érkezési ellenőrző lapot!",
    "Bitte Unterschrift erfassen": "Kérjük, írja alá!",
    "Bitte Namen für die Unterschrift erfassen": "Kérjük, adja meg az aláíráshoz szükséges nevet",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Kérjük, szánjon elegendő időt az érkezési ellenőrzésre!",
    "AnkunftskontrolleDauerFrage1": "A beérkezési ellenőrzésre előírt időt nem tartották be. Akkor is befejezzük a túrát?",
    "Tour beenden?": "Befejezni a túrát?",
    "AnkunftskontrolleDauerFrage2": "Az érkezési ellenőrzésre előírt időt nem tartották be. Akarod mégis befejezni a túrát?<br /><br />Üzenet küldésre kerül!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Kérjük, töltse ki teljes egészében az indulási ellenőrzőlapot!",
    "AbfahrtskontrolleMeldung1": "Kérjük, szánjon elegendő időt az indulás előtti ellenőrzésre!",
    "AbfahrtskontrolleMeldung2": "A kilépési ellenőrzésre előírt időt nem tartották be. Akkor is elinduljon az út?",
    "AbfahrtskontrolleMeldung3": "A kilépés ellenőrzésére előírt időt nem tartották be. Akkor is elinduljon az út?<br /><br />Üzenet küldésre kerül!",
    "KeineWiegungTourTrotzdemStarten": "Nem történt súlymérés. Akkor is elinduljon az út?",
    "Wiegung": "Mérés",
    "WiegungErfolgreich": "Mérés szükséges!",
    "Tour start?": "A túra kezdete?",
    "Tour aktiv seit": "A túra kezdete:",
    "Gestartet um": "Kezdés:",
    "Gestartet gestern": "Tegnap indult",
    "Gestartet": "Elindult",
    "Keine gültige Auftragsnummer": "Nincs érvényes megrendelési szám",
    "Heute offene Aufträge": "A mai nyitott megbízások",
    "Heute erledigt Aufträge": "Ma teljesített megbízások",
    "Morgen": "Holnap",
    "Keine Transportaufträge": "Nincsenek szállítási megbízások",
    "1 Transportauftrag": "1 szállítási megbízás",
    "aktuelle Aufträge": "folyamatban lévő megbízások",
    "Statusmeldung428": "Állapotjelentés nem lehetséges. A mérés már elindult. Kérjük, fejezze be a körutat, és szükség esetén indítsa újra.",
    "Meldung429": "<p>Állapotjelentés nem lehetséges. Az út még nem indult el.</p><p>Most elindítja az utat?</p>",
    "Meldung430": "Ez az állapot nem megengedett. Kérjük, jelentsd az alábbi állapotok egyikét",
    "Meldung431": "Nem minden pozíciót jelentettek be véglegesen. Tényleg véglegesen be akarja jelenteni a raklapot?",
    "Meldung432": "Állapotjelentés nem lehetséges. Kérjük, először adja meg az „{{NAME}}” időrögzítés indokát.",
    "Es muss mindestens ein Foto gemacht werden!": "Legalább egy fotót kell készíteni!",
    "Alle Aufträge": "Minden megrendelés",
    "Kommissionierung": "Áruösszeállítás",
    "Wiegungen": "Mérlegelések",
    "Gekoppelte Waagen": "Összekapcsolt mérlegek",
    "Waage suchen...": "Mérleg keresése...",
    "Keine Wiegedaten vorhanden": "Nincsenek mérési adatok",
    "Keine Waagen konfiguriert": "Nincs beállított mérleg",
    "Waage": "Mérleg",
    "MAC Adresse": "MAC-cím",
    "Aktiv": "Aktív",
    "Uhr synchronisieren": "Óra szinkronizálása",
    "Wiegen 1": "Mérlegelés 1",
    "Wiegen 2": "Mérleg 2",
    "Tarieren": "Tárálás",
    "Keine neue Waage gefunden": "Nem találtam új mérleget",
    "TourAktivBeendenMeldung449": "A túra még folyamatban van. Befejezzük a túrát?",
    "WirklichAbmelden": "Tényleg le szeretne iratkozni?",
    "Aktuelle Tour": "Aktuális turné",
    "Tour beenden": "A túra befejezése",
    "Zeiterfassung": "Munkaidő-nyilvántartás",
    "Zeiterfassung starten": "A munkaidő-nyilvántartás elindítása",
    "Tour Ende": "A túra vége",
    "Art": "Faj",
    "Arbeitszeit bearbeiten": "A munkaidő szerkesztése",
    "Wiegen": "Mérés",
    "Tätigkeitsbericht": "Tevékenységi jelentés",
    "Personaldaten": "Személyes adatok",
    "Tätigkeit": "Tevékenység",
    "Übernachtung": "Szállás",
    "Beschreibung der Tätigkeit": "A munkakör leírása",
    "Neuer Urlaubsantrag": "Új szabadságkérelem",
    "Abteilung": "Osztály",
    "Urlaub": "Szabadság",
    "Angemeldete Beifahrer": "Regisztrált utasok",
    "Beifahrer hinzufügen": "Utas hozzáadása",
    "Beifahrer NFC scannen": "Az utas NFC-kódjának beolvasása",
    "BeifahrerListeNichtGeladen": "Az utasok listája nem töltődött be. Kérjük, ellenőrizze az internetkapcsolatát.",
    "Beifahrer wurde gescannnt": "Az utas átvizsgálásra került",
    "NfcKeinBeifahrerGefunden": "Nem találtak társalkodót az RFID-chiphez",
    "BeifahrerAlsFahrerMeldung473": "Ön már sofőrként regisztrált erre a túrára. Nem regisztrálhat újra utasként.",
    "BeifahrerBereitsAngemeldet": "Ön már utasként van regisztrálva.",
    "MaxZweiBeifahrerMoeglich": "Legfeljebb 2 utas regisztrálható",
    "BeifahrerNichtGefunden": "Az utas nem található",
    "BeifahrerWurdeHinzugefuegt": "Hozzáadva lett az utas",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Egy pótkocsit nem lehet járműként beolvasni",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Egy teherautót nem lehet pótkocsiként beolvasni",
    "AngemeldetSeit": "Regisztrált:",
    "Hinzufügen": "Hozzáadás",
    "NFC scannen": "NFC-beolvasás",
    "Beifahrer abmelden": "Az utas kijelentkezése",
    "Hallo": "Szia",
    "FuehrerscheinkontrolleText1": "Itt az ideje a vezetői engedély ellenőrzésének.",
    "FuehrerscheinkontrolleTextFoto": "Kérjük, készítsen fényképet a vezetői engedélye elülső és hátsó oldaláról.",
    "Foto Vorderseite": "Elülső oldal fotója",
    "Foto Rückseite": "A hátoldal képe",
    "FuehrerscheinkontrolleTextNFC": "Kérjük, olvassa be a vezetői engedélyén található NFC-chipet.",
    "FuehrerscheinkontrolleNfcFalsch": "Érvénytelen NFC-chip",
    "Fahrerkarten": "Járművezetői kártyák",
    "Führerscheinkontrolle": "Jogosítvány-ellenőrzés",
    "Später": "Később",
    "Führerschein erfolgreich gescannt": "A vezetői engedély beolvasása sikeresen megtörtént",
    "Bitte Ablaufdatum erfassen": "Kérjük, adja meg a lejárati dátumot",
    "Führerscheinprüfung wirklich verschieben?": "Tényleg el kell halasztani a vezetői vizsgát?",
    "Abmelden?": "Kijelentkezés?",
    "Bitte NFC-Chip scannen": "Kérjük, olvassa be az NFC-chipet!",
    "Suchen": "Keresés",
    "Archiv anzeigen": "Archívum megtekintése",
    "Übersicht": "Áttekintés",
    "Bitte Entladeort auswählen": "Kérjük, válassza ki a kirakodási helyet",
    "Von": "Szerző:",
    "Bis": "-ig",
    "Zeitausgleich": "Időkompenzáció",
    "Urlaub 2": "Nyaralás 2",
    "Urlaub 3": "Nyaralás 3",
    "Urlaub 4": "Nyaralás 4",
    "Unterschrift erforderlich": "Aláírás szükséges",
    "Zum unterschreiben hier tippen": "Az aláíráshoz ide érintse meg a képernyőt",
    "Unterschrift": "Aláírás",
    "Wird geladen...": "Betöltés folyamatban...",
    "Funktion im Browser nicht verfügbar": "A funkció a böngészőben nem érhető el",
    "GETRENNT": "KÜLÖN",
    "FormValidationError": "Kérjük, ellenőrizze az adatokat. Az űrlapot nem töltötte ki teljesen.",
    "Permission.ListTouren": "Túrák megjelenítése",
    "Permission.EditTouren": "Túrák szerkesztése",
    "Protokoll": "Jegyzőkönyv",
    "Werkstatt": "Műhely",
    "Kostenstellen": "Költségközpontok",
    "Benachrichtigungen": "Értesítések",
    "Externe Systeme": "Külső rendszerek",
    "Regeln": "Szabályok",
    "Masterdata1": "Költségközpont",
    "Feld ist erforderlich": "A mező kitöltése kötelező",
    "FormularfehlerText": "Kérjük, ellenőrizze az adatokat. Az űrlapot nem töltötte ki teljesen.",
    "Eintrag wirklich löschen?": "Tényleg törölni szeretné a bejegyzést?",
    "MasterdataList1": "Költségközpontok",
    "EintragWirklichLoeschen": "Tényleg törölni szeretné ezt a bejegyzést?",
    "Loeschen": "Törlés",
    "AusgewaehlteZeilenWirklichLoeschen": "Tényleg törölni szeretné a kijelölt sorokat?",
    "Gerätegruppe einschränken": "Készülékcsoport szűrése",
    "Fahrer-Namen nicht anzeigen": "A játékosok nevét ne mutassa meg",
    "Rolle bearbeiten": "Szerepkör szerkesztése",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Készülékcsoportok szerkesztése (egyszerű adatok)",
    "Permission.Werkstattuebersicht": "Műhelyek áttekintése",
    "Permission.Kostenstellen": "Költségközpontok",
    "Permission.EinstellungenKunde": "Beállítások (egyszerű)",
    "Design": "Tervezés",
    "Benutzeranmeldung": "Felhasználói bejelentkezés",
    "Fotos": "Fotók",
    "Tour E-Mails": "Túra-e-mailek",
    "Sicherheitshinweis": "Biztonsági figyelmeztetés",
    "Pellets": "Pellet",
    "Allgemein": "Általános információk",
    "Custom CSS": "Egyéni CSS",
    "Barcodes": "Vonalkódok",
    "Datenherkunft": "Az adatok forrása",
    "Freigabeprozess": "Jóváhagyási folyamat",
    "Kontakte": "Kapcsolatok",
    "Menü": "Menü",
    "Preise": "Árak",
    "Verträge": "Szerződések",
    "Tour-Start": "A túra kezdete",
    "Tour-Ende": "A túra vége",
    "GPS": "GPS",
    "GPS-Positionen": "GPS-koordináták",
    "Position senden": "Helymeghatározás elküldése",
    "Navigation": "Navigáció",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Tartály",
    "Peripherie": "Periféria",
    "Drucker": "Nyomtató",
    "Mobile Waagen": "Hordozható mérlegek",
    "Stationäre Waagen": "Helyhez kötött mérlegek",
    "Proglove": "Proglove",
    "LKW-Beladung": "Teherautó-rakodás",
    "Web": "Web",
    "Tourenplanung": "Útvonaltervezés",
    "Sondermodule": "Kiegészítő modulok",
    "Sprachen": "Nyelvek",
    "Datenbereinigung": "Adattisztítás",
    "Daten-Export": "Adatexport",
    "Fehlerdiagnose": "Hibadiagnosztika",
    "Untermandanten": "Almegbízottak",
    "WebSocket-Verbindung": "WebSocket-kapcsolat",
    "Aufträge": "Megrendelések",
    "Karte": "Térkép",
    "ExtNummer": "Külső megrendelésszám",
    "ExtNummerHierEingeben": "Írja be ide a külső megrendelésszámot…",
    "Foto aus Galerie auswählen": "Fénykép kiválasztása a galériából"
  },
  "RO": {
    "Permissions": "Drepturi",
    "Permission.ShowUsers": "Afișează utilizatorii",
    "Permission.EditUsers": "Gestionarea utilizatorilor",
    "Permission.ShowProjects": "Afișează proiectele",
    "Permission.EditProjects": "Gestionarea proiectelor",
    "Permission.ShowApplications": "Afișează cererile",
    "Permission.EditApplications": "Gestionarea cererilor",
    "Permission.ShowDemandRequest": "Afișează cererile de ofertă",
    "Permission.EditDemandRequest": "Gestionarea cererilor de ofertă",
    "Permission.CreateDemandRequest": "Crearea cererilor de ofertă",
    "Permission.ShowUserRoles": "Afișare roluri de utilizator",
    "Permission.EditUserRoles": "Gestionarea rolurilor utilizatorilor",
    "Permission.ShowGeraete": "Afișează dispozitivele",
    "Permission.EditGeraete": "Gestionarea dispozitivelor",
    "Permission.ReadGeraete": "Citirea dispozitivelor",
    "Permission.Administration": "Administrare",
    "Permission.ReadAuftrag": "Citirea comenzilor",
    "Permission.ListAuftraege": "Afișează comenzile",
    "Permission.ShowKarte": "Afișează harta",
    "Permission.ProtokollAnzeigen": "Afișează jurnalul",
    "Permission.ProtokollBearbeiten": "Editare proces-verbal",
    "Permission.KarteAnzeigen": "Afișează harta",
    "Permission.WorkflowsAnzeigen": "Afișare fluxuri de lucru",
    "Permission.WorkflowsBearbeiten": "Editarea fluxurilor de lucru",
    "Permission.FahrerBearbeiten": "Editare șofer",
    "Permission.FahrerAnzeigen": "Afișează șoferii",
    "Permission.FahrzeugBearbeiten": "Editare vehicule",
    "Permission.FahrzeugAnzeigen": "Afișează vehiculele",
    "Permission.ArtikelAnzeigen": "Afișează articolul",
    "Permission.ArtikelBearbeiten": "Editează articolul",
    "Permission.UvvKatalogAnzeigen": "Afișează catalogul UVV",
    "Permission.UvvKatalogBearbeiten": "Editare catalog UVV",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Afișează catalogul punctelor de control la plecare",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Editare catalog control la plecare",
    "Permission.FormulareBearbeiten": "Editare formulare",
    "Permission.UvvPruefungenAnzeigen": "Afișează verificările UVV",
    "Permission.UvvPruefungenBearbeiten": "Prelucrarea verificărilor UVV",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Afișează elementele UVV",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Editarea elementelor din UVV",
    "Permission.ChecklisteBearbeiten": "Editarea listelor de verificare",
    "Permission.ChecklisteAnzeigen": "Afișează listele de verificare",
    "Permission.AdresseAnzeigen": "Afișează adresele",
    "Permission.DokumenteBearbeiten": "Editarea documentelor",
    "Permission.DruckformulareAnzeigen": "Afișare formulare tipărite",
    "Permission.DruckformulareBearbeiten": "Editarea formularelor tipărite",
    "Permission.ArtikelgruppenAnzeigen": "Afișează grupurile de articole",
    "Permission.ArtikelgruppenBearbeiten": "Editare grupuri de articole",
    "Permission.Sysadmin": "Administrator de sistem",
    "Permission.FahrzeuggruppenAnzeigen": "Afișează grupurile de vehicule",
    "Permission.FahrzeuggruppenBearbeiten": "Modificarea grupurilor de vehicule",
    "Permission.GeraetegruppenAnzeigen": "Afișează grupurile de aparate",
    "Permission.GeraetegruppenBearbeiten": "Modificarea grupurilor de dispozitive",
    "Permission.StatuszusatzinfoAnzeigen": "Afișează informații suplimentare despre stare",
    "Permission.StatuszusatzinfoBearbeiten": "Editare informații suplimentare privind starea",
    "Permission.Nachrichten": "Știri",
    "Permission.AdresseBearbeiten": "Modificarea adreselor",
    "Permission.WaageAnzeigen": "Afișare cântare",
    "Permission.WaageBearbeiten": "Editarea cântarelor",
    "Permission.Tabellenkonfiguration": "Configurarea tabelului",
    "Permission.EditGeraeteEinfacheDaten": "Modificarea datelor simple din dispozitive",
    "Permission.AuftraegeBearbeiten": "Prelucrarea comenzilor",
    "Permission.AuftraegeLoeschen": "Ștergerea comenzilor",
    "Permission.DokumenteAnzeigen": "Afișare documente",
    "Permission.Dashboard": "Prezentare generală (Tablou de bord)",
    "Permission.GastzugangAnzeigen": "Afișează accesul pentru oaspeți",
    "Permission.GastzugangBearbeiten": "Editare acces pentru oaspeți",
    "Permission.StammtourAnzeigen": "Afișează traseul obișnuit",
    "Permission.StammtourBearbeiten": "Editează traseul obișnuit",
    "Permission.StoerzeitAnzeigen": "Afișează ora de întrerupere",
    "Permission.StoerzeitBearbeiten": "Editare interval de întrerupere",
    "Permission.TourenAnzeigen": "Afișează traseele",
    "Permission.TourenBearbeiten": "Editare trasee",
    "Permission.Tourenplanung": "Planificarea traseelor",
    "Anmelden mit Personalnummer": "Autentificare cu numărul personal",
    "TourWiegung1": "1. Cântărire",
    "TourWiegung2": "2. Cântărire",
    "BitteWiegung1Durchfuehren": "Vă rugăm să efectuați prima cântărire",
    "BitteWiegung2Durchfuehren": "Vă rugăm să efectuați a doua cântărire",
    "Permission.AbfahrtskontrolleBearbeiten": "Editare control la plecare",
    "Permission.AbfahrtskontrolleAnzeigen": "Afișează punctul de control la plecare",
    "Permission.Auswertungen": "Analize",
    "Permission.TexteAnzeigen": "Afișează textele",
    "Permission.TexteBearbeiten": "Editare texte",
    "AuftragWiegung1": "1. Cântărire",
    "AuftragWiegung2": "2. Cântărire",
    "Beladung": "Încărcare",
    "Auftrag scannen": "Scanarea comenzii",
    "Tour": "Tur",
    "Home_Anmelden": "Autentificare cu numărul personal",
    "Home_TourStarten": "Începe turul",
    "Home_TourBeenden": "A termina turul",
    "Home_AuftragScannen": "Scanarea comenzii",
    "Home_Beladung": "Încărcare",
    "Home_Hofauftraege": "Comenzi interne",
    "Wareneingang": "Recepția mărfurilor",
    "Glas-Analyse": "Analiza sticlei",
    "Home_Uebersicht": "Prezentare generală",
    "Home_Kunden": "Clienți",
    "NagivationHome": "Acasă",
    "UVV-Prüfungen": "Verificări UVV",
    "Dokumente": "Documente",
    "Abmelden": "Deconectare",
    "Smartwatch": "Ceas inteligent",
    "ProGlove": "ProGlove",
    "Home_System": "Sistem",
    "Permission.VertraegeAnzeigen": "Afișare contracte",
    "Permission.VertraegeBearbeiten": "Editarea contractelor",
    "Save": "Salvare",
    "Cancel": "Anulare",
    "NeuenTransportauftragAnlegen": "Să creezi o nouă comandă de transport?",
    "NeuenWareneingangAnlegen": "Să înregistrezi o nouă intrare de marfă?",
    "NeuenHofauftragAnlegen": "Să creezi o nouă comandă pentru fermă?",
    "Vertrag": "Contract",
    "Neuer Auftrag": "O nouă comandă",
    "Abbrechen": "Anulare",
    "Home_Zeiterfassung": "Înregistrarea timpului de lucru",
    "SchreibgeschuetztVorStatusmeldung": "Comanda este în regim „doar citire” până la primul mesaj de stare",
    "NavigationErlaubenWennSchreibgeschuetzt": "Permite navigarea atunci când este în modul numai citire",
    "TransportauftragLeerePositionenAusblenden": "Ascunde pozițiile cu cantitatea 0",
    "Auswertungen": "Analize",
    "Abfahrtskontrolle": "Controlul la plecare",
    "UVV-Gegenstände": "Elemente prevăzute de normele de securitate la muncă",
    "UVV-Katalog": "Catalogul UVV",
    "Einträge": "Intrări",
    "Name": "Nume",
    "Beschreibung": "Descriere",
    "REST-Schnittstelle": "Interfață REST",
    "Abrechnung aktiv": "Decontare activă",
    "API-Token": "Token API",
    "Angelegt am": "Creat la data de",
    "Vorname": "Prenume",
    "Nachname": "Prenume",
    "Email": "E-mail",
    "Roles": "Roluri de utilizator",
    "Field is required": "Câmpul este obligatoriu",
    "E-Mail": "E-mail",
    "Zugangsdaten ändern": "Modificarea datelor de acces",
    "Passwort": "Parolă",
    "Passwort (bestätigen)": "Parolă (confirmare)",
    "Benutzer bearbeiten": "Editare utilizator",
    "Key": "Cheie",
    "Checkliste": "Listă de verificare",
    "Mandant": "Client",
    "ApiToken": "Token API",
    "Latitude": "Latitudine",
    "Longitude": "Longitudine",
    "Max. Entfernung": "Distanța maximă",
    "Timeout": "Timeout",
    "Icon": "Icoană",
    "Nummer": "Număr",
    "Bezeichnung": "Denumire",
    "Gruppe": "Grup",
    "App Version": "Versiunea aplicației",
    "Traffic aktueller Monat": "Trafic în luna curentă",
    "Personalnr.": "Nr. personal",
    "Personal": "Personal",
    "Zuletzt online": "Ultima conectare",
    "Fahrzeug": "Vehicul",
    "Anhänger": "Remorcă",
    "Letzte Position": "Ultima poziție",
    "Farbe": "Culoare",
    "Letzte Anmeldung": "Ultima înscriere",
    "Letzte Abmeldung": "Ultima deconectare",
    "Angemeldet": "Autentificat",
    "Telefon": "Telefon",
    "Freitext": "Text liber",
    "Platform": "Platformă",
    "Version": "Versiune",
    "Hersteller": "Producător",
    "Model": "Model",
    "Alert Berechtigung": "Autorizație de alertă",
    "Erste Verwendung": "Prima utilizare",
    "Letzte Verwendung": "Ultima utilizare",
    "Abrechnung ab": "Decontare începând cu",
    "Abrechnung bis": "Decontare până la",
    "Preis / Monat": "Preț / lună",
    "Einmaliger Preis ": "Preț unic ",
    "Geräte (Systemansicht)": "Dispozitive (Vizualizare sistem)",
    "RoleName": "RoleName",
    "Symbol": "Simbol",
    "App-Version": "Versiunea aplicației",
    "Verfügbare Waagen": "Cântare disponibile",
    "Importieren": "Import",
    "Gerätegruppe bearbeiten": "Editare grup de dispozitive",
    "Kopieren": "Copiere",
    "Exportieren": "Exportare",
    "Zeit (h)": "Timp (h)",
    "Intervall (m)": "Interval (m)",
    "MeldungText": "Textul știrii",
    "Standard-Dauer": "Durată standard",
    "Typ": "Tip",
    "Datum": "Data",
    "Verlauf": "Istoric",
    "Auftragsnr.": "Nr. comandă",
    "Gerätenr.": "Nr. aparat",
    "Gerät": "Aparat",
    "Status": "Stare",
    "PushStatus": "PushStatus",
    "Abholdatum": "Data preluării",
    "Abholzeit": "Ora de ridicare",
    "Erfasser": "Autor",
    "Adress Nr.": "Nr. adresă",
    "Name1": "Nume1",
    "Name2": "Nume2",
    "Strasse": "Stradă",
    "PLZ": "Cod poștal",
    "Ort": "Localitate",
    "Kunde Nr.": "Client nr.",
    "Kunde Name1": "Clientul „Nume1”",
    "Kunde Name2": "Clientul „Nume2”",
    "Kunde Strasse": "Client Strada",
    "Kunde PLZ": "Codul poștal al clientului",
    "Kunde Ort": "Client Localitate",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "Informații detaliate 1",
    "DetailInfo2": "Informații detaliate 2",
    "DetailInfo3": "Informații detaliate 3",
    "Workflow": "Flux de lucru",
    "Statusmeldung": "Mesaj de stare",
    "Statuszeit": "Durata stării",
    "Reihenfolge": "Ordine",
    "CreationDate": "Data creării",
    "ModificationDate": "Data modificării",
    "Lieferpositionen": "Poziții de livrare",
    "Auftrag": "Comandă",
    "RememberMe": "Rămâi conectat",
    "Username": "Numele de utilizator",
    "Geräte": "Aparate",
    "Stammdaten": "Date de bază",
    "Adressen": "Adrese",
    "Artikelgruppen": "Grupuri de articole",
    "Artikel": "Articol",
    "Checklisten": "Liste de verificare",
    "Fahrer (Personal)": "Șofer (personal)",
    "Fahrzeuge": "Vehicule",
    "Fahrzeuggruppen": "Grupuri de vehicule",
    "Konfiguration": "Configurare",
    "Benutzer": "Utilizator",
    "Benutzerrollen": "Roluri de utilizator",
    "Druckformulare": "Formulare tipărite",
    "Einstellungen": "Setări",
    "Formulare": "Formulare",
    "Gerätegruppen": "Grupuri de aparate",
    "Waagen": "Cântare",
    "Workflows": "Fluxuri de lucru",
    "Statuszusatzinfo": "Informații suplimentare privind starea",
    "Texte": "Texte",
    "Import / Export": "Import / Export",
    "Benutzername": "Numele de utilizator",
    "E-Mail-Adresse": "Adresă de e-mail",
    "Passwort ändern": "Schimbă parola",
    "Permission.Benachrichtigungen": "Notificări",
    "Permission.ZeiterfassungAnzeigen": "Afișare înregistrare timp",
    "Permission.ZeiterfassungBearbeiten": "Editare înregistrare timp",
    "Nachtmodus": "Modul nocturn",
    "Nachmodus": "Modul nocturn",
    "KeineAuftraegeGefunden": "Nu s-au găsit comenzi",
    "KeineAuftraegeVorhanden": "Nu există comenzi. Trageți în jos pentru a actualiza.",
    "TourStartenAlertButtonText": "Începe turul!",
    "Aktuelle Aufträge anzeigen": "Afișează comenzile curente",
    "Archiv": "Arhivă",
    "weitere Aufträge vorhanden": "sunt disponibile și alte comenzi",
    "weiterer Auftrag vorhanden": "există o altă comandă",
    "Anmerkungen": "Observații",
    "AnmerkungenHierEingeben": "Introduceți aici observațiile…",
    "AuftragDarfNichtGeaendertWerden": "Comanda nu poate fi modificată",
    "AuftragBereitsAbgeschlossen": "Comanda a fost deja finalizată. Nu se mai pot face modificări.",
    "Start": "Start",
    "System": "Sistem",
    "Transportaufträge": "Comenzi de transport",
    "Hofaufträge": "Comenzi pentru curte",
    "Entladeort": "Locul de descărcare",
    "Bitte Entladeort wählen": "Vă rugăm să selectați locul de descărcare",
    "TourStart_Wiegen": "Cântărire",
    "TourEnde_StartWiegung": "Cântărirea la începutul turului",
    "TourEnde_EndeWiegung": "Cântărire (camion încărcat)",
    "Geplante Reihenfolge anzeigen": "Afișează ordinea planificată",
    "Permission.GlasAnalyseAnzeigen": "Afișează analiza sticlei",
    "Permission.GlasAnalyseBearbeiten": "Editare analiză sticlă",
    "BitteAuswaehlenPlaceholder": "Vă rugăm să selectați",
    "BitteAnlageWaehlen": "Vă rugăm să selectați o anexă",
    "Permission.GlasAnalyseKonfiguration": "Configurația analizei sticlei",
    "UVV Prüfung": "Verificarea conformității cu normele de securitate la locul de muncă",
    "Auftrag_Abholadresse": "Adresă",
    "Auftrag_Erzeugeradresse": "Client",
    "Auftrag_Verwerteradresse": "Operator",
    "Auftrag_Fahrzeug": "Vehicul",
    "Auftrag_Abholdatum": "Data preluării",
    "Auftrag_Abholzeit": "Ora de ridicare",
    "Permission.BerichteAnzeigen": "Afișează rapoartele",
    "Permission.BerichteBearbeiten": "Editare rapoarte",
    "Permission.Kalender": "Calendar",
    "Permission.NVEAnzeigen": "Afișează NVE",
    "Permission.NVEBearbeiten": "Editare NVE",
    "Permission.RegelAnzeigen": "Afișează regulile",
    "Permission.RegelBearbeiten": "Editare reguli",
    "ExportMessageStatus_0": "Inițial",
    "ExportMessageStatus_1": "Trimis",
    "ExportMessageStatus_2": "Prelucrat",
    "ExportMessageStatus_3": "Eroare",
    "ExportMessageStatus_4": "Așteaptă confirmarea (ACK)",
    "Gerätegruppe": "Grup de aparate",
    "Sonstiges": "Diverse",
    "Sprache": "Limba",
    "APP Version": "Versiunea aplicației",
    "Local storage": "Stocare locală",
    "Advanced HTTP": "HTTP avansat",
    "System Alert Berechtigung": "Autorizație pentru alerte de sistem",
    "Navigations-App": "Aplicație de navigație",
    "Zurücksetzen": "Resetare",
    "WebSocket": "WebSocket",
    "Push-Status": "Starea notificărilor push",
    "Push-ID": "ID-ul Push",
    "Push-Type": "De tip push",
    "Anzahl Artikelgruppen": "Numărul de grupe de articole",
    "Anzahl Artikel": "Numărul de articole",
    "Anzahl Workflows": "Numărul de fluxuri de lucru",
    "GPS Dienst läuft": "Serviciul GPS este activ",
    "GPS Dienst aktiv": "Serviciul GPS este activ",
    "GPS Auth-Status": "Starea autentificării GPS",
    "GPS-Positionen (Puffer)": "Poziții GPS (zonă tampon)",
    "Zugangsdaten": "Datele de acces",
    "Geräte-Nummer": "Numărul aparatului",
    "Host": "Gazdă",
    "Speichern": "Salvare",
    "Stammdaten neu laden": "Reîncărcare date de bază",
    "Lokale Daten löschen": "Ștergerea datelor locale",
    "Diagnosedaten senden": "Trimiterea datelor de diagnosticare",
    "Testdatei senden": "Trimite fișierul de testare",
    "Update prüfen": "Verifică actualizările",
    "Dunkler Modus": "Modul întunecat",
    "Aktivieren": "Activați",
    "Anzeigen": "Anunțuri",
    "Anmelden": "Autentificare",
    "Personalnummer": "Număr de personal",
    "Kennwort": "Parolă",
    "Mit NFC anmelden": "Autentificare prin NFC",
    "Bitte eingeben": "Vă rugăm să introduceți",
    "Passwort eingeben": "Introduceți parola",
    "Anmelden mit NFC-Chip": "Autentificare cu cipul NFC",
    "Zur Anmeldung NFC-Chip scannen": "Pentru înregistrare, scanați cipul NFC",
    "Mit Personalnummer anmelden": "Autentificare cu numărul de personal",
    "Ablaufdatum": "Data expirării",
    "Kein Fahrer für RFID-Chip gefunden": "Nu s-a găsit niciun driver pentru cipul RFID",
    "Nachrichten": "Știri",
    "Berichte": "Rapoarte",
    "Urlaubsanträge": "Cererile de concediu",
    "Unfallberichte": "Rapoarte privind accidentele",
    "Tätigkeitsberichte": "Rapoarte de activitate",
    "an": "la",
    "aus": "din",
    "KeineEintraegeVorhanden": "Nu există înregistrări",
    "StoerzeitFuerAuftrag": "Intervale de întrerupere pentru comandă",
    "StoerzeitFuerTour": "Intervale de întrerupere pentru tur",
    "Minuten": "minute",
    "Sekunden": "secunde",
    "Minute": "Minut",
    "TourNichtGestartetLoeschen": "Turul nu a început. Ștergerea nu este posibilă.",
    "ZeiterfassungOhneTourFehler": "Înregistrarea timpului nu poate fi pornită fără un traseu",
    "Tour start": "Începutul turului",
    "Kilometerstand": "Kilometraj",
    "Fahrer": "Șofer",
    "Beifahrer": "Pasagerul din dreapta",
    "Bitte wählen": "Vă rugăm să selectați",
    "Beifahrer 2": "Pasagerul 2",
    "Abfahrtskontrolle Anhänger": "Controlul la plecare al remorcilor",
    "Foto aufnehmen": "A face o fotografie",
    "Zum Bearbeiten hier tippen": "Atingeți aici pentru a edita",
    "Eingeben": "Introduceți",
    "Uhrzeit": "Ora",
    "Driver": "Driver",
    "Passenger": "Pasager",
    "Passenger 2": "Pasagerul 2",
    "Trailer": "Trailer",
    "Vehicle": "Vehicul",
    "BitteEingabePruefen": "Vă rugăm să verificați datele introduse!",
    "RFID scannen": "Scanare RFID",
    "Tour scannen": "Scanează traseul",
    "Tour starten": "Începe turul",
    "Tour laden": "Încărcare tur",
    "Tour entladen": "Descărcare tur",
    "Schreiben": "Scrisoare",
    "Alle Nachrichten löschen?": "Vrei să ștergi toate mesajele?",
    "Löschen": "Ștergere",
    "Ja": "Da",
    "Nein": "Nu",
    "Nächste Prüfung": "Următorul examen",
    "alle anzeigen": "Afișează toate",
    "Bitte KM eingeben": "Vă rugăm să introduceți KM",
    "NFCErkennungLaeuft": "Se efectuează recunoașterea NFC…",
    "RFIDWirdGescannt": "Se scanează RFID…",
    "OK": "OK",
    "Fehlerbeschreibung": "Descrierea erorii",
    "Bild wirklich löschen?": "Vrei să ștergi definitiv imaginea?",
    "Frage": "Întrebare",
    "Bitte Kilometerstand angeben": "Vă rugăm să indicați kilometrajul",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Vă rugăm să completați integral formularul de înregistrare la sosire",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Vă rugăm să completați integral formularul de control la sosire pentru remorci",
    "Bitte Unterschrift erfassen": "Vă rugăm să introduceți semnătura",
    "Bitte Namen für die Unterschrift erfassen": "Vă rugăm să introduceți numele pentru semnătură",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Vă rugăm să vă rezervați suficient timp pentru controlul la sosire!",
    "AnkunftskontrolleDauerFrage1": "Nu s-a respectat timpul stabilit pentru controlul la sosire. Să încheiem totuși turul?",
    "Tour beenden?": "Vrei să închei turul?",
    "AnkunftskontrolleDauerFrage2": "Nu s-a respectat timpul stabilit pentru controlul la sosire. Doriți să încheiați totuși turul?<br /><br />Se va trimite un mesaj!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Vă rugăm să completați integral formularul de control la plecare",
    "AbfahrtskontrolleMeldung1": "Vă rugăm să vă alocați suficient timp pentru controlul de plecare!",
    "AbfahrtskontrolleMeldung2": "Nu s-a respectat timpul alocat pentru controlul la plecare. Să începem totuși turul?",
    "AbfahrtskontrolleMeldung3": "Nu a fost respectat timpul alocat pentru controlul la plecare. Doriți să începeți totuși turul?<br /><br />Se va trimite un mesaj!",
    "KeineWiegungTourTrotzdemStarten": "Nu s-a efectuat cântărirea. Doriți să începeți totuși turul?",
    "Wiegung": "Cântărire",
    "WiegungErfolgreich": "Este necesară cântărirea!",
    "Tour start?": "Începutul turului?",
    "Tour aktiv seit": "Turul este activ din",
    "Gestartet um": "A început la",
    "Gestartet gestern": "A început ieri",
    "Gestartet": "A început",
    "Keine gültige Auftragsnummer": "Număr de comandă nevalid",
    "Heute offene Aufträge": "Comenzile deschise astăzi",
    "Heute erledigt Aufträge": "Comenzi procesate astăzi",
    "Morgen": "Mâine",
    "Keine Transportaufträge": "Nu există comenzi de transport",
    "1 Transportauftrag": "1 Ordin de transport",
    "aktuelle Aufträge": "comenzi curente",
    "Statusmeldung428": "Nu se poate transmite mesajul de stare. Cântărirea a fost deja inițiată. Vă rugăm să încheiați ciclul și, dacă este necesar, să îl reporniți.",
    "Meldung429": "<p>Nu se poate afișa starea. Turul nu a început încă.</p><p>Vrei să începi turul acum?</p>",
    "Meldung430": "Stare nepermisă. Vă rugăm să raportați una dintre următoarele stări",
    "Meldung431": "Nu au fost declarate toate pozițiile ca fiind finalizate. Doriți să declarați cu adevărat paleta ca fiind finalizată?",
    "Meldung432": "Nu se poate transmite mesajul de stare. Vă rugăm să introduceți mai întâi un motiv pentru înregistrarea orelor „{{NAME}}”.",
    "Es muss mindestens ein Foto gemacht werden!": "Trebuie să se facă cel puțin o fotografie!",
    "Alle Aufträge": "Toate comenzile",
    "Kommissionierung": "Pregătirea comenzilor",
    "Wiegungen": "Cântăriri",
    "Gekoppelte Waagen": "Cântare cuplate",
    "Waage suchen...": "Căutarea balanței...",
    "Keine Wiegedaten vorhanden": "Nu există date privind cântărirea",
    "Keine Waagen konfiguriert": "Nu sunt configurate cântare",
    "Waage": "Balanță",
    "MAC Adresse": "Adresă MAC",
    "Aktiv": "Activ",
    "Uhr synchronisieren": "Sincronizarea ceasului",
    "Wiegen 1": "Cântărire 1",
    "Wiegen 2": "Cântărirea 2",
    "Tarieren": "Tarare",
    "Keine neue Waage gefunden": "Nu s-a găsit niciun cântar nou",
    "TourAktivBeendenMeldung449": "Turul este încă activ. Vrei să închei turul acum?",
    "WirklichAbmelden": "Chiar vrei să te dezabonezi?",
    "Aktuelle Tour": "Turul actual",
    "Tour beenden": "A termina turul",
    "Zeiterfassung": "Înregistrarea timpului de lucru",
    "Zeiterfassung starten": "Începe înregistrarea timpului",
    "Tour Ende": "Sfârșitul turului",
    "Art": "Artă",
    "Arbeitszeit bearbeiten": "Modificarea programului de lucru",
    "Wiegen": "Cântărire",
    "Tätigkeitsbericht": "Raport de activitate",
    "Personaldaten": "Date personale",
    "Tätigkeit": "Activitate",
    "Übernachtung": "Cazare",
    "Beschreibung der Tätigkeit": "Descrierea activității",
    "Neuer Urlaubsantrag": "O nouă cerere de concediu",
    "Abteilung": "Departament",
    "Urlaub": "Vacanță",
    "Angemeldete Beifahrer": "Pasageri înregistrați",
    "Beifahrer hinzufügen": "Adăugare pasager",
    "Beifahrer NFC scannen": "Scanarea codului NFC al pasagerului",
    "BeifahrerListeNichtGeladen": "Nu s-a putut încărca lista pasagerilor. Vă rugăm să verificați conexiunea la internet.",
    "Beifahrer wurde gescannnt": "Pasagerul din dreapta a fost scanat",
    "NfcKeinBeifahrerGefunden": "Nu s-a găsit niciun pasager pentru cipul RFID",
    "BeifahrerAlsFahrerMeldung473": "Sunteți deja înscris ca șofer pentru acest tur. Nu vă puteți înscrie din nou ca pasager.",
    "BeifahrerBereitsAngemeldet": "Sunteți deja înregistrat ca pasager.",
    "MaxZweiBeifahrerMoeglich": "Se pot înregistra cel mult 2 pasageri",
    "BeifahrerNichtGefunden": "Nu s-a găsit pasagerul din dreapta",
    "BeifahrerWurdeHinzugefuegt": "A fost adăugat pasagerul din dreapta",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "O remorcă nu poate fi scanată ca vehicul",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Un camion nu poate fi scanat ca remorcă",
    "AngemeldetSeit": "Înregistrat din",
    "Hinzufügen": "Adăugare",
    "NFC scannen": "Scanare NFC",
    "Beifahrer abmelden": "Dezactivarea pasagerului",
    "Hallo": "Bună ziua",
    "FuehrerscheinkontrolleText1": "A venit momentul verificării permisului de conducere.",
    "FuehrerscheinkontrolleTextFoto": "Vă rugăm să fotografiați fața și spatele permisului dumneavoastră de conducere.",
    "Foto Vorderseite": "Fotografie față",
    "Foto Rückseite": "Fotografie pe verso",
    "FuehrerscheinkontrolleTextNFC": "Vă rugăm să scanați cipul NFC de pe permisul dumneavoastră de conducere.",
    "FuehrerscheinkontrolleNfcFalsch": "Cip NFC nevalid",
    "Fahrerkarten": "Carduri de șofer",
    "Führerscheinkontrolle": "Verificarea permisului de conducere",
    "Später": "Mai târziu",
    "Führerschein erfolgreich gescannt": "Permisul de conducere a fost scanat cu succes",
    "Bitte Ablaufdatum erfassen": "Vă rugăm să introduceți data de expirare",
    "Führerscheinprüfung wirklich verschieben?": "Chiar să amân examenul pentru permisul de conducere?",
    "Abmelden?": "Vrei să te deconectezi?",
    "Bitte NFC-Chip scannen": "Vă rugăm să scanați cipul NFC",
    "Suchen": "Căutare",
    "Archiv anzeigen": "Afișează arhiva",
    "Übersicht": "Prezentare generală",
    "Bitte Entladeort auswählen": "Vă rugăm să selectați locul de descărcare",
    "Von": "De la",
    "Bis": "Până la",
    "Zeitausgleich": "Compensare de timp",
    "Urlaub 2": "Vacanță 2",
    "Urlaub 3": "Vacanță 3",
    "Urlaub 4": "Vacanță 4",
    "Unterschrift erforderlich": "Este necesară semnătura",
    "Zum unterschreiben hier tippen": "Atingeți aici pentru a semna",
    "Unterschrift": "Semnătură",
    "Wird geladen...": "Se încarcă...",
    "Funktion im Browser nicht verfügbar": "Funcția nu este disponibilă în browser",
    "GETRENNT": "SEPARAT",
    "FormValidationError": "Vă rugăm să verificați datele introduse. Formularul nu a fost completat în întregime.",
    "Permission.ListTouren": "Afișează traseele",
    "Permission.EditTouren": "Editare trasee",
    "Protokoll": "Proces-verbal",
    "Werkstatt": "Atelier",
    "Kostenstellen": "Centre de cost",
    "Benachrichtigungen": "Notificări",
    "Externe Systeme": "Sisteme externe",
    "Regeln": "Reguli",
    "Masterdata1": "Centru de cost",
    "Feld ist erforderlich": "Câmpul este obligatoriu",
    "FormularfehlerText": "Vă rugăm să verificați datele introduse. Formularul nu a fost completat în întregime.",
    "Eintrag wirklich löschen?": "Vrei să ștergi cu adevărat această intrare?",
    "MasterdataList1": "Centre de cost",
    "EintragWirklichLoeschen": "Chiar vrei să ștergi această intrare?",
    "Loeschen": "Ștergere",
    "AusgewaehlteZeilenWirklichLoeschen": "Doriți să ștergeți cu adevărat rândurile selectate?",
    "Gerätegruppe einschränken": "Limitați grupul de dispozitive",
    "Fahrer-Namen nicht anzeigen": "Nu afișa numele șoferilor",
    "Rolle bearbeiten": "Editare rol",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Editarea grupurilor de echipamente (date simple)",
    "Permission.Werkstattuebersicht": "Prezentare generală a atelierului",
    "Permission.Kostenstellen": "Centre de cost",
    "Permission.EinstellungenKunde": "Setări (simplu)",
    "Design": "Design",
    "Benutzeranmeldung": "Autentificare utilizator",
    "Fotos": "Fotografii",
    "Tour E-Mails": "E-mailuri legate de tur",
    "Sicherheitshinweis": "Instrucțiuni de siguranță",
    "Pellets": "Peleți",
    "Allgemein": "În general",
    "Custom CSS": "CSS personalizat",
    "Barcodes": "Coduri de bare",
    "Datenherkunft": "Sursa datelor",
    "Freigabeprozess": "Procesul de aprobare",
    "Kontakte": "Contacte",
    "Menü": "Meniu",
    "Preise": "Prețuri",
    "Verträge": "Contracte",
    "Tour-Start": "Începutul turului",
    "Tour-Ende": "Sfârșitul turului",
    "GPS": "GPS",
    "GPS-Positionen": "Coordonate GPS",
    "Position senden": "Trimite poziția",
    "Navigation": "Navigare",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Recipient",
    "Peripherie": "Periferie",
    "Drucker": "Imprimantă",
    "Mobile Waagen": "Cântare portabile",
    "Stationäre Waagen": "Cântare staționare",
    "Proglove": "Proglove",
    "LKW-Beladung": "Încărcarea camioanelor",
    "Web": "Web",
    "Tourenplanung": "Planificarea traseelor",
    "Sondermodule": "Module speciale",
    "Sprachen": "Limbi",
    "Datenbereinigung": "Curățarea datelor",
    "Daten-Export": "Exportul datelor",
    "Fehlerdiagnose": "Diagnosticul defectelor",
    "Untermandanten": "Submandatari",
    "WebSocket-Verbindung": "Conexiune WebSocket",
    "Aufträge": "Comenzi",
    "Karte": "Harta",
    "ExtNummer": "Nr. extern al comenzii",
    "ExtNummerHierEingeben": "Introduceți aici nr. extern al comenzii…",
    "Foto aus Galerie auswählen": "Selectați fotografia din galerie"
  },
  "RU": {
    "Permissions": "Права доступа",
    "Permission.ShowUsers": "Показать пользователей",
    "Permission.EditUsers": "Управление пользователями",
    "Permission.ShowProjects": "Показать проекты",
    "Permission.EditProjects": "Управление проектами",
    "Permission.ShowApplications": "Показать заявки",
    "Permission.EditApplications": "Управление заявками",
    "Permission.ShowDemandRequest": "Просмотреть запросы на поставку",
    "Permission.EditDemandRequest": "Управление запросами на поставку",
    "Permission.CreateDemandRequest": "Создание запросов на поставку",
    "Permission.ShowUserRoles": "Просмотреть роли пользователей",
    "Permission.EditUserRoles": "Управление ролями пользователей",
    "Permission.ShowGeraete": "Показать устройства",
    "Permission.EditGeraete": "Управление устройствами",
    "Permission.ReadGeraete": "Считывание данных с устройств",
    "Permission.Administration": "Администрация",
    "Permission.ReadAuftrag": "Просмотр заказов",
    "Permission.ListAuftraege": "Просмотреть заказы",
    "Permission.ShowKarte": "Показать карту",
    "Permission.ProtokollAnzeigen": "Показать протокол",
    "Permission.ProtokollBearbeiten": "Редактировать протокол",
    "Permission.KarteAnzeigen": "Показать карту",
    "Permission.WorkflowsAnzeigen": "Просмотр рабочих процессов",
    "Permission.WorkflowsBearbeiten": "Редактирование рабочих процессов",
    "Permission.FahrerBearbeiten": "Редактировать водителя",
    "Permission.FahrerAnzeigen": "Показать водителей",
    "Permission.FahrzeugBearbeiten": "Редактировать транспортные средства",
    "Permission.FahrzeugAnzeigen": "Показать автомобили",
    "Permission.ArtikelAnzeigen": "Показать статью",
    "Permission.ArtikelBearbeiten": "Редактировать статью",
    "Permission.UvvKatalogAnzeigen": "Просмотреть каталог UVV",
    "Permission.UvvKatalogBearbeiten": "Редактировать каталог правил техники безопасности",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Просмотреть каталог средств контроля на выезде",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Редактировать каталог контрольных точек на трассе",
    "Permission.FormulareBearbeiten": "Редактировать формы",
    "Permission.UvvPruefungenAnzeigen": "Просмотреть проверки по правилам техники безопасности",
    "Permission.UvvPruefungenBearbeiten": "Обработка проверок по правилам техники безопасности",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Показать объекты, подпадающие под действие правил техники безопасности",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Редактировать объекты UVV",
    "Permission.ChecklisteBearbeiten": "Редактировать контрольные списки",
    "Permission.ChecklisteAnzeigen": "Показать контрольные списки",
    "Permission.AdresseAnzeigen": "Показать адреса",
    "Permission.DokumenteBearbeiten": "Редактирование документов",
    "Permission.DruckformulareAnzeigen": "Показать бланки для печати",
    "Permission.DruckformulareBearbeiten": "Редактирование бланков для печати",
    "Permission.ArtikelgruppenAnzeigen": "Показать группы товаров",
    "Permission.ArtikelgruppenBearbeiten": "Редактировать группы товаров",
    "Permission.Sysadmin": "Системный администратор",
    "Permission.FahrzeuggruppenAnzeigen": "Показать группы автомобилей",
    "Permission.FahrzeuggruppenBearbeiten": "Редактировать группы транспортных средств",
    "Permission.GeraetegruppenAnzeigen": "Показать группы устройств",
    "Permission.GeraetegruppenBearbeiten": "Редактирование групп устройств",
    "Permission.StatuszusatzinfoAnzeigen": "Показать дополнительную информацию о статусе",
    "Permission.StatuszusatzinfoBearbeiten": "Редактировать дополнительную информацию о статусе",
    "Permission.Nachrichten": "Новости",
    "Permission.AdresseBearbeiten": "Редактировать адреса",
    "Permission.WaageAnzeigen": "Показать весы",
    "Permission.WaageBearbeiten": "Редактирование весов",
    "Permission.Tabellenkonfiguration": "Настройка таблицы",
    "Permission.EditGeraeteEinfacheDaten": "Изменение простых данных в устройствах",
    "Permission.AuftraegeBearbeiten": "Обработка заказов",
    "Permission.AuftraegeLoeschen": "Удаление заказов",
    "Permission.DokumenteAnzeigen": "Просмотреть документы",
    "Permission.Dashboard": "Обзор (панель управления)",
    "Permission.GastzugangAnzeigen": "Показать гостевой доступ",
    "Permission.GastzugangBearbeiten": "Редактировать гостевой доступ",
    "Permission.StammtourAnzeigen": "Показать маршрут «Stammtour»",
    "Permission.StammtourBearbeiten": "Редактировать маршрут для постоянных участников",
    "Permission.StoerzeitAnzeigen": "Показать время сбоя",
    "Permission.StoerzeitBearbeiten": "Редактировать время сбоя",
    "Permission.TourenAnzeigen": "Показать маршруты",
    "Permission.TourenBearbeiten": "Редактировать маршруты",
    "Permission.Tourenplanung": "Планирование маршрутов",
    "Anmelden mit Personalnummer": "Войти с помощью личного номера",
    "TourWiegung1": "1. Взвешивание",
    "TourWiegung2": "2. Взвешивание",
    "BitteWiegung1Durchfuehren": "Пожалуйста, проведите 1-е взвешивание",
    "BitteWiegung2Durchfuehren": "Пожалуйста, проведите второе взвешивание",
    "Permission.AbfahrtskontrolleBearbeiten": "Редактировать контроль отправления",
    "Permission.AbfahrtskontrolleAnzeigen": "Показать пункт контроля на выезде",
    "Permission.Auswertungen": "Аналитические отчеты",
    "Permission.TexteAnzeigen": "Показать тексты",
    "Permission.TexteBearbeiten": "Редактировать тексты",
    "AuftragWiegung1": "1. Взвешивание",
    "AuftragWiegung2": "2. Взвешивание",
    "Beladung": "Загрузка",
    "Auftrag scannen": "Отсканировать заказ",
    "Tour": "Тур",
    "Home_Anmelden": "Войти с помощью личного номера",
    "Home_TourStarten": "Начать тур",
    "Home_TourBeenden": "Завершить тур",
    "Home_AuftragScannen": "Отсканировать заказ",
    "Home_Beladung": "Загрузка",
    "Home_Hofauftraege": "Дворцовые заказы",
    "Wareneingang": "Поступление товаров",
    "Glas-Analyse": "Анализ стекла",
    "Home_Uebersicht": "Обзор",
    "Home_Kunden": "Клиенты",
    "NagivationHome": "Главная",
    "UVV-Prüfungen": "Проверки в соответствии с правилами техники безопасности (UVV)",
    "Dokumente": "Документы",
    "Abmelden": "Выйти",
    "Smartwatch": "Умные часы",
    "ProGlove": "ProGlove",
    "Home_System": "Система",
    "Permission.VertraegeAnzeigen": "Просмотреть договоры",
    "Permission.VertraegeBearbeiten": "Редактировать договоры",
    "Save": "Сохранить",
    "Cancel": "Отмена",
    "NeuenTransportauftragAnlegen": "Создать новый транспортный заказ?",
    "NeuenWareneingangAnlegen": "Зарегистрировать новый приход товара?",
    "NeuenHofauftragAnlegen": "Создать новый заказ для хозяйства?",
    "Vertrag": "Договор",
    "Neuer Auftrag": "Новый заказ",
    "Abbrechen": "Отмена",
    "Home_Zeiterfassung": "Учет рабочего времени",
    "SchreibgeschuetztVorStatusmeldung": "Заказ находится в режиме «только для чтения» до появления первого сообщения о статусе",
    "NavigationErlaubenWennSchreibgeschuetzt": "Разрешить навигацию, если файл защищен от записи",
    "TransportauftragLeerePositionenAusblenden": "Скрыть позиции с количеством 0",
    "Auswertungen": "Аналитические отчеты",
    "Abfahrtskontrolle": "Контроль отправления",
    "UVV-Gegenstände": "Объекты, подпадающие под действие правил техники безопасности",
    "UVV-Katalog": "Каталог правил техники безопасности",
    "Einträge": "Записи",
    "Name": "Имя",
    "Beschreibung": "Описание",
    "REST-Schnittstelle": "REST-интерфейс",
    "Abrechnung aktiv": "Расчет активен",
    "API-Token": "Токен API",
    "Angelegt am": "Создано",
    "Vorname": "Имя",
    "Nachname": "Фамилия",
    "Email": "Электронная почта",
    "Roles": "Роли пользователей",
    "Field is required": "Это поле обязательно для заполнения",
    "E-Mail": "Электронная почта",
    "Zugangsdaten ändern": "Изменить данные для входа",
    "Passwort": "Пароль",
    "Passwort (bestätigen)": "Пароль (подтвердить)",
    "Benutzer bearbeiten": "Редактировать пользователя",
    "Key": "Ключ",
    "Checkliste": "Контрольный список",
    "Mandant": "Клиент",
    "ApiToken": "Токен API",
    "Latitude": "Широта",
    "Longitude": "Долгота",
    "Max. Entfernung": "Максимальное расстояние",
    "Timeout": "Таймаут",
    "Icon": "Значок",
    "Nummer": "Номер",
    "Bezeichnung": "Наименование",
    "Gruppe": "Группа",
    "App Version": "Версия приложения",
    "Traffic aktueller Monat": "Посещаемость за текущий месяц",
    "Personalnr.": "Личный номер",
    "Personal": "Персонал",
    "Zuletzt online": "Последнее посещение",
    "Fahrzeug": "Автомобиль",
    "Anhänger": "Прицеп",
    "Letzte Position": "Последнее положение",
    "Farbe": "Цвет",
    "Letzte Anmeldung": "Последнее вхождение в систему",
    "Letzte Abmeldung": "Последний выход из системы",
    "Angemeldet": "Вошел в систему",
    "Telefon": "Телефон",
    "Freitext": "Свободный текст",
    "Platform": "Платформа",
    "Version": "Версия",
    "Hersteller": "Производитель",
    "Model": "Модель",
    "Alert Berechtigung": "Права доступа к оповещениям",
    "Erste Verwendung": "Первое использование",
    "Letzte Verwendung": "Последнее использование",
    "Abrechnung ab": "Расчет начиная с",
    "Abrechnung bis": "Расчет до",
    "Preis / Monat": "Цена в месяц",
    "Einmaliger Preis ": "Единовременная оплата ",
    "Geräte (Systemansicht)": "Устройства (обзор системы)",
    "RoleName": "RoleName",
    "Symbol": "Символ",
    "App-Version": "Версия приложения",
    "Verfügbare Waagen": "Доступные весы",
    "Importieren": "Импорт",
    "Gerätegruppe bearbeiten": "Редактировать группу устройств",
    "Kopieren": "Копировать",
    "Exportieren": "Экспорт",
    "Zeit (h)": "Время (ч)",
    "Intervall (m)": "Интервал (м)",
    "MeldungText": "Текст сообщения",
    "Standard-Dauer": "Стандартная продолжительность",
    "Typ": "Тип",
    "Datum": "Дата",
    "Verlauf": "Ход событий",
    "Auftragsnr.": "Номер заказа",
    "Gerätenr.": "Номер устройства",
    "Gerät": "Устройство",
    "Status": "Статус",
    "PushStatus": "PushStatus",
    "Abholdatum": "Дата получения",
    "Abholzeit": "Время получения",
    "Erfasser": "Составитель",
    "Adress Nr.": "Адрес №",
    "Name1": "Имя1",
    "Name2": "Имя2",
    "Strasse": "Улица",
    "PLZ": "почтовый индекс",
    "Ort": "Место",
    "Kunde Nr.": "Клиент №",
    "Kunde Name1": "Клиент Имя1",
    "Kunde Name2": "Имя клиента 2",
    "Kunde Strasse": "Клиент Улица",
    "Kunde PLZ": "Почтовый индекс клиента",
    "Kunde Ort": "Клиент Город",
    "Info1": "Информация 1",
    "Info2": "Информация 2",
    "Info3": "Информация 3",
    "DetailInfo1": "Подробная информация 1",
    "DetailInfo2": "Подробная информация 2",
    "DetailInfo3": "Подробная информация 3",
    "Workflow": "Рабочий процесс",
    "Statusmeldung": "Сообщение о состоянии",
    "Statuszeit": "Время статуса",
    "Reihenfolge": "Порядок",
    "CreationDate": "Дата создания",
    "ModificationDate": "Дата изменения",
    "Lieferpositionen": "Позиции поставки",
    "Auftrag": "Заказ",
    "RememberMe": "Остаться в системе",
    "Username": "Имя пользователя",
    "Geräte": "Устройства",
    "Stammdaten": "Основные данные",
    "Adressen": "Адреса",
    "Artikelgruppen": "Группы товаров",
    "Artikel": "Статья",
    "Checklisten": "Контрольные списки",
    "Fahrer (Personal)": "Водитель (персонал)",
    "Fahrzeuge": "Транспортные средства",
    "Fahrzeuggruppen": "Группы транспортных средств",
    "Konfiguration": "Конфигурация",
    "Benutzer": "Пользователь",
    "Benutzerrollen": "Роли пользователей",
    "Druckformulare": "Формы для печати",
    "Einstellungen": "Настройки",
    "Formulare": "Формы",
    "Gerätegruppen": "Группы устройств",
    "Waagen": "Весы",
    "Workflows": "Рабочие процессы",
    "Statuszusatzinfo": "Дополнительная информация о статусе",
    "Texte": "Тексты",
    "Import / Export": "Импорт / Экспорт",
    "Benutzername": "Имя пользователя",
    "E-Mail-Adresse": "Адрес электронной почты",
    "Passwort ändern": "Изменить пароль",
    "Permission.Benachrichtigungen": "Уведомления",
    "Permission.ZeiterfassungAnzeigen": "Просмотреть отчеты об учете рабочего времени",
    "Permission.ZeiterfassungBearbeiten": "Редактировать учет рабочего времени",
    "Nachtmodus": "Ночной режим",
    "Nachmodus": "Ночной режим",
    "KeineAuftraegeGefunden": "Заказы не найдены",
    "KeineAuftraegeVorhanden": "Заказов нет. Прокрутите вниз, чтобы обновить страницу.",
    "TourStartenAlertButtonText": "Начать тур!",
    "Aktuelle Aufträge anzeigen": "Показать текущие заказы",
    "Archiv": "Архив",
    "weitere Aufträge vorhanden": "есть другие заказы",
    "weiterer Auftrag vorhanden": "имеется еще один заказ",
    "Anmerkungen": "Примечания",
    "AnmerkungenHierEingeben": "Введите здесь свои замечания…",
    "AuftragDarfNichtGeaendertWerden": "Заказ не подлежит изменению",
    "AuftragBereitsAbgeschlossen": "Заказ уже выполнен. Внести изменения больше невозможно.",
    "Start": "Начало",
    "System": "Система",
    "Transportaufträge": "Заказы на перевозку",
    "Hofaufträge": "Дворцовые заказы",
    "Entladeort": "Место разгрузки",
    "Bitte Entladeort wählen": "Пожалуйста, выберите место разгрузки",
    "TourStart_Wiegen": "Взвешивание",
    "TourEnde_StartWiegung": "Взвешивание перед стартом тура",
    "TourEnde_EndeWiegung": "Взвешивание (полнозагруженный грузовик)",
    "Geplante Reihenfolge anzeigen": "Показать запланированную последовательность",
    "Permission.GlasAnalyseAnzeigen": "Показать анализ стекла",
    "Permission.GlasAnalyseBearbeiten": "Редактировать анализ стекла",
    "BitteAuswaehlenPlaceholder": "Пожалуйста, выберите",
    "BitteAnlageWaehlen": "Пожалуйста, выберите приложение",
    "Permission.GlasAnalyseKonfiguration": "Конфигурация анализа стекла",
    "UVV Prüfung": "Проверка в соответствии с правилами техники безопасности (UVV)",
    "Auftrag_Abholadresse": "Адрес",
    "Auftrag_Erzeugeradresse": "Клиент",
    "Auftrag_Verwerteradresse": "переработчик",
    "Auftrag_Fahrzeug": "Автомобиль",
    "Auftrag_Abholdatum": "Дата получения",
    "Auftrag_Abholzeit": "Время получения",
    "Permission.BerichteAnzeigen": "Просмотреть отчеты",
    "Permission.BerichteBearbeiten": "Редактировать отчеты",
    "Permission.Kalender": "Календарь",
    "Permission.NVEAnzeigen": "Показать NVE",
    "Permission.NVEBearbeiten": "Редактировать NVE",
    "Permission.RegelAnzeigen": "Показать правила",
    "Permission.RegelBearbeiten": "Редактировать правила",
    "ExportMessageStatus_0": "Начальная буква",
    "ExportMessageStatus_1": "Отправлено",
    "ExportMessageStatus_2": "Обработано",
    "ExportMessageStatus_3": "Ошибка",
    "ExportMessageStatus_4": "Ожидание подтверждения (ACK)",
    "Gerätegruppe": "Группа устройств",
    "Sonstiges": "Прочее",
    "Sprache": "Язык",
    "APP Version": "Версия приложения",
    "Local storage": "Локальное хранилище",
    "Advanced HTTP": "Расширенный HTTP",
    "System Alert Berechtigung": "Права доступа к системным оповещениям",
    "Navigations-App": "Приложение для навигации",
    "Zurücksetzen": "Сброс",
    "WebSocket": "WebSocket",
    "Push-Status": "Статус push-уведомления",
    "Push-ID": "Push-ID",
    "Push-Type": "Тип «Push»",
    "Anzahl Artikelgruppen": "Количество групп товаров",
    "Anzahl Artikel": "Количество товаров",
    "Anzahl Workflows": "Количество рабочих процессов",
    "GPS Dienst läuft": "Служба GPS работает",
    "GPS Dienst aktiv": "Служба GPS включена",
    "GPS Auth-Status": "Статус аутентификации GPS",
    "GPS-Positionen (Puffer)": "Координаты GPS (буфер)",
    "Zugangsdaten": "Учетные данные",
    "Geräte-Nummer": "Номер устройства",
    "Host": "Хост",
    "Speichern": "Сохранить",
    "Stammdaten neu laden": "Перезагрузить основные данные",
    "Lokale Daten löschen": "Удаление локальных данных",
    "Diagnosedaten senden": "Отправить диагностические данные",
    "Testdatei senden": "Отправить тестовый файл",
    "Update prüfen": "Проверить наличие обновлений",
    "Dunkler Modus": "Темный режим",
    "Aktivieren": "Активировать",
    "Anzeigen": "Объявления",
    "Anmelden": "Войти",
    "Personalnummer": "Личный номер",
    "Kennwort": "Пароль",
    "Mit NFC anmelden": "Войти с помощью NFC",
    "Bitte eingeben": "Введите, пожалуйста",
    "Passwort eingeben": "Введите пароль",
    "Anmelden mit NFC-Chip": "Вход с помощью чипа NFC",
    "Zur Anmeldung NFC-Chip scannen": "Для входа отсканируйте чип NFC",
    "Mit Personalnummer anmelden": "Войти с помощью личного номера",
    "Ablaufdatum": "Срок годности",
    "Kein Fahrer für RFID-Chip gefunden": "Не найден драйвер для RFID-чипа",
    "Nachrichten": "Новости",
    "Berichte": "Отчеты",
    "Urlaubsanträge": "Заявления об отпуске",
    "Unfallberichte": "Отчеты о ДТП",
    "Tätigkeitsberichte": "Отчеты о деятельности",
    "an": "в",
    "aus": "из",
    "KeineEintraegeVorhanden": "Записей нет",
    "StoerzeitFuerAuftrag": "Время простоя для заказа",
    "StoerzeitFuerTour": "Время, когда экскурсия не проводится",
    "Minuten": "минуты",
    "Sekunden": "секунды",
    "Minute": "минута",
    "TourNichtGestartetLoeschen": "Тур не запущен. Удалить невозможно.",
    "ZeiterfassungOhneTourFehler": "Учет рабочего времени невозможно запустить без маршрута",
    "Tour start": "Начало тура",
    "Kilometerstand": "пробег",
    "Fahrer": "Водитель",
    "Beifahrer": "пассажир",
    "Bitte wählen": "Пожалуйста, выберите",
    "Beifahrer 2": "Пассажир 2",
    "Abfahrtskontrolle Anhänger": "Контроль отправки прицепов",
    "Foto aufnehmen": "Сделать фото",
    "Zum Bearbeiten hier tippen": "Нажмите здесь, чтобы отредактировать",
    "Eingeben": "Ввести",
    "Uhrzeit": "Время",
    "Driver": "Драйвер",
    "Passenger": "Пассажир",
    "Passenger 2": "Пассажир 2",
    "Trailer": "Трейлер",
    "Vehicle": "Транспортное средство",
    "BitteEingabePruefen": "Пожалуйста, проверьте введенные данные!",
    "RFID scannen": "Сканирование RFID",
    "Tour scannen": "Отсканировать маршрут",
    "Tour starten": "Начать тур",
    "Tour laden": "Загрузить маршрут",
    "Tour entladen": "Скачать маршрут",
    "Schreiben": "Письмо",
    "Alle Nachrichten löschen?": "Удалить все сообщения?",
    "Löschen": "Удалить",
    "Ja": "Да",
    "Nein": "Нет",
    "Nächste Prüfung": "Следующий экзамен",
    "alle anzeigen": "показать все",
    "Bitte KM eingeben": "Пожалуйста, введите KM",
    "NFCErkennungLaeuft": "Осуществляется распознавание NFC…",
    "RFIDWirdGescannt": "Происходит считывание RFID…",
    "OK": "ОК",
    "Fehlerbeschreibung": "Описание ошибки",
    "Bild wirklich löschen?": "Действительно удалить изображение?",
    "Frage": "Вопрос",
    "Bitte Kilometerstand angeben": "Пожалуйста, укажите показания одометра",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Пожалуйста, полностью заполните форму регистрации по прибытии",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Пожалуйста, полностью заполните бланк регистрации прибытия для прицепов",
    "Bitte Unterschrift erfassen": "Пожалуйста, введите подпись",
    "Bitte Namen für die Unterschrift erfassen": "Пожалуйста, введите имя для подписи",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Пожалуйста, запасите достаточно времени на прохождение паспортного контроля по прибытии!",
    "AnkunftskontrolleDauerFrage1": "Установленное время прохождения паспортного контроля не было соблюдено. Все равно завершить тур?",
    "Tour beenden?": "Завершить тур?",
    "AnkunftskontrolleDauerFrage2": "Установленное время прохождения контроля по прибытии не было соблюдено. Все равно завершить тур?<br /><br />Сообщение отправлено!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Пожалуйста, полностью заполните форму контроля при отправлении",
    "AbfahrtskontrolleMeldung1": "Пожалуйста, заранее приезжайте, чтобы успеть пройти контроль перед вылетом!",
    "AbfahrtskontrolleMeldung2": "Установленное время прохождения контроля перед отправлением не было соблюдено. Все равно начать тур?",
    "AbfahrtskontrolleMeldung3": "Установленное время прохождения контроля отправления не соблюдено. Все равно начать тур?<br /><br />Сообщение отправлено!",
    "KeineWiegungTourTrotzdemStarten": "Взвешивание не выполнено. Все равно начать маршрут?",
    "Wiegung": "Взвешивание",
    "WiegungErfolgreich": "Требуется взвешивание!",
    "Tour start?": "Начало тура?",
    "Tour aktiv seit": "Тур проводится с",
    "Gestartet um": "Началось в",
    "Gestartet gestern": "Началось вчера",
    "Gestartet": "Запущено",
    "Keine gültige Auftragsnummer": "Неверный номер заказа",
    "Heute offene Aufträge": "Открытые заказы на сегодня",
    "Heute erledigt Aufträge": "Заказы, выполненные сегодня",
    "Morgen": "Завтра",
    "Keine Transportaufträge": "Нет заказов на перевозку",
    "1 Transportauftrag": "1 транспортное поручение",
    "aktuelle Aufträge": "текущие заказы",
    "Statusmeldung428": "Сообщение о статусе невозможно. Процесс взвешивания уже запущен. Пожалуйста, завершите цикл и, при необходимости, запустите его заново.",
    "Meldung429": "<p>Сообщение о статусе невозможно. Маршрут ещё не начался.</p><p>Начать маршрут сейчас?</p>",
    "Meldung430": "Статус не допускается. Пожалуйста, укажите один из следующих статусов",
    "Meldung431": "Не все позиции были окончательно зарегистрированы. Действительно ли вы хотите окончательно зарегистрировать паллету?",
    "Meldung432": "Сообщение о статусе не может быть отправлено. Пожалуйста, сначала введите обоснование для записи времени «{{NAME}}».",
    "Es muss mindestens ein Foto gemacht werden!": "Нужно сделать хотя бы одну фотографию!",
    "Alle Aufträge": "Все заказы",
    "Kommissionierung": "Формирование заказов",
    "Wiegungen": "Взвешивания",
    "Gekoppelte Waagen": "Связанные весы",
    "Waage suchen...": "Найти весы...",
    "Keine Wiegedaten vorhanden": "Данные о весе отсутствуют",
    "Keine Waagen konfiguriert": "Весы не настроены",
    "Waage": "Весы",
    "MAC Adresse": "MAC-адрес",
    "Aktiv": "Активный",
    "Uhr synchronisieren": "Синхронизировать часы",
    "Wiegen 1": "Взвешивание 1",
    "Wiegen 2": "Взвешивание 2",
    "Tarieren": "Тара",
    "Keine neue Waage gefunden": "Новые весы не найдены",
    "TourAktivBeendenMeldung449": "Тур ещё продолжается. Завершить тур сейчас?",
    "WirklichAbmelden": "Действительно удалить аккаунт?",
    "Aktuelle Tour": "Текущий тур",
    "Tour beenden": "Завершить тур",
    "Zeiterfassung": "Учет рабочего времени",
    "Zeiterfassung starten": "Начать учет рабочего времени",
    "Tour Ende": "Конец тура",
    "Art": "Вид",
    "Arbeitszeit bearbeiten": "Редактировать рабочее время",
    "Wiegen": "Взвешивание",
    "Tätigkeitsbericht": "Отчет о деятельности",
    "Personaldaten": "Данные о персонале",
    "Tätigkeit": "Деятельность",
    "Übernachtung": "Ночлег",
    "Beschreibung der Tätigkeit": "Описание должностных обязанностей",
    "Neuer Urlaubsantrag": "Новое заявление на отпуск",
    "Abteilung": "Отдел",
    "Urlaub": "Отпуск",
    "Angemeldete Beifahrer": "Зарегистрированные пассажиры",
    "Beifahrer hinzufügen": "Добавить пассажира",
    "Beifahrer NFC scannen": "Отсканировать NFC пассажира",
    "BeifahrerListeNichtGeladen": "Не удалось загрузить список пассажиров. Проверьте подключение к Интернету.",
    "Beifahrer wurde gescannnt": "Пассажир прошел сканирование",
    "NfcKeinBeifahrerGefunden": "Не найден сопроводительный файл для RFID-чипа",
    "BeifahrerAlsFahrerMeldung473": "Вы уже зарегистрированы в качестве водителя для этого тура. Вы не можете повторно зарегистрироваться в качестве пассажира.",
    "BeifahrerBereitsAngemeldet": "Вы уже зарегистрированы в качестве пассажира.",
    "MaxZweiBeifahrerMoeglich": "Можно зарегистрировать не более 2 пассажиров",
    "BeifahrerNichtGefunden": "Пассажир не найден",
    "BeifahrerWurdeHinzugefuegt": "Добавлен пассажир",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Прицеп нельзя сканировать как транспортное средство",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Грузовик нельзя сканировать как прицеп",
    "AngemeldetSeit": "Зарегистрирован с",
    "Hinzufügen": "Добавить",
    "NFC scannen": "Сканировать NFC",
    "Beifahrer abmelden": "Отписать пассажира",
    "Hallo": "Здравствуйте",
    "FuehrerscheinkontrolleText1": "Пришло время пройти проверку водительских прав.",
    "FuehrerscheinkontrolleTextFoto": "Пожалуйста, сфотографируйте лицевую и оборотную сторону вашего водительского удостоверения.",
    "Foto Vorderseite": "Фото на лицевой стороне",
    "Foto Rückseite": "Фото с обратной стороны",
    "FuehrerscheinkontrolleTextNFC": "Пожалуйста, просканируйте чип NFC на вашем водительском удостоверении.",
    "FuehrerscheinkontrolleNfcFalsch": "Неисправный чип NFC",
    "Fahrerkarten": "Карты водителя",
    "Führerscheinkontrolle": "Проверка водительских прав",
    "Später": "Позже",
    "Führerschein erfolgreich gescannt": "Водительское удостоверение успешно отсканировано",
    "Bitte Ablaufdatum erfassen": "Пожалуйста, укажите дату истечения срока действия",
    "Führerscheinprüfung wirklich verschieben?": "Действительно ли стоит перенести экзамен на получение водительских прав?",
    "Abmelden?": "Выйти?",
    "Bitte NFC-Chip scannen": "Пожалуйста, отсканируйте чип NFC",
    "Suchen": "Поиск",
    "Archiv anzeigen": "Показать архив",
    "Übersicht": "Обзор",
    "Bitte Entladeort auswählen": "Пожалуйста, выберите место разгрузки",
    "Von": "От",
    "Bis": "До",
    "Zeitausgleich": "Компенсация рабочего времени",
    "Urlaub 2": "Отпуск 2",
    "Urlaub 3": "Отпуск 3",
    "Urlaub 4": "Отпуск 4",
    "Unterschrift erforderlich": "Требуется подпись",
    "Zum unterschreiben hier tippen": "Нажмите здесь, чтобы подписать",
    "Unterschrift": "Подпись",
    "Wird geladen...": "Загрузка...",
    "Funktion im Browser nicht verfügbar": "Функция недоступна в браузере",
    "GETRENNT": "РАЗДЕЛЬНО",
    "FormValidationError": "Пожалуйста, проверьте введенные данные. Форма заполнена не полностью.",
    "Permission.ListTouren": "Показать маршруты",
    "Permission.EditTouren": "Редактировать маршруты",
    "Protokoll": "Протокол",
    "Werkstatt": "Мастерская",
    "Kostenstellen": "Центры затрат",
    "Benachrichtigungen": "Уведомления",
    "Externe Systeme": "Внешние системы",
    "Regeln": "Правила",
    "Masterdata1": "центр затрат",
    "Feld ist erforderlich": "Это поле обязательно для заполнения",
    "FormularfehlerText": "Пожалуйста, проверьте введенные данные. Форма заполнена не полностью.",
    "Eintrag wirklich löschen?": "Действительно удалить запись?",
    "MasterdataList1": "Центры затрат",
    "EintragWirklichLoeschen": "Действительно удалить эту запись?",
    "Loeschen": "Удалить",
    "AusgewaehlteZeilenWirklichLoeschen": "Действительно удалить выбранные строки?",
    "Gerätegruppe einschränken": "Ограничить группу устройств",
    "Fahrer-Namen nicht anzeigen": "Не отображать имена водителей",
    "Rolle bearbeiten": "Редактировать роль",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Редактирование групп устройств (простые данные)",
    "Permission.Werkstattuebersicht": "Обзор мастерских",
    "Permission.Kostenstellen": "Центры затрат",
    "Permission.EinstellungenKunde": "Настройки (простые)",
    "Design": "Дизайн",
    "Benutzeranmeldung": "Вход в систему",
    "Fotos": "Фотографии",
    "Tour E-Mails": "Электронные письма о турах",
    "Sicherheitshinweis": "Предупреждение о безопасности",
    "Pellets": "Пеллеты",
    "Allgemein": "Общие сведения",
    "Custom CSS": "Пользовательский CSS",
    "Barcodes": "Штрих-коды",
    "Datenherkunft": "Источник данных",
    "Freigabeprozess": "Процесс утверждения",
    "Kontakte": "Контакты",
    "Menü": "Меню",
    "Preise": "Цены",
    "Verträge": "Договоры",
    "Tour-Start": "Начало тура",
    "Tour-Ende": "Конец тура",
    "GPS": "GPS",
    "GPS-Positionen": "Координаты GPS",
    "Position senden": "Отправить координаты",
    "Navigation": "Навигация",
    "NFC": "NFC",
    "UVV": "Правила техники безопасности",
    "Behälter": "Контейнер",
    "Peripherie": "Периферия",
    "Drucker": "Принтер",
    "Mobile Waagen": "Мобильные весы",
    "Stationäre Waagen": "Стационарные весы",
    "Proglove": "Proglove",
    "LKW-Beladung": "Погрузка грузовиков",
    "Web": "Веб",
    "Tourenplanung": "Планирование маршрутов",
    "Sondermodule": "Специальные модули",
    "Sprachen": "Языки",
    "Datenbereinigung": "Очистка данных",
    "Daten-Export": "Экспорт данных",
    "Fehlerdiagnose": "Диагностика неисправностей",
    "Untermandanten": "подподчиненные",
    "WebSocket-Verbindung": "Соединение WebSocket",
    "Aufträge": "Заказы",
    "Karte": "Карта",
    "ExtNummer": "Внешний номер заказа",
    "ExtNummerHierEingeben": "Введите здесь внешний номер заказа…",
    "Foto aus Galerie auswählen": "Выбрать фото из галереи"
  },
  "HR": {
    "Permissions": "Dozvole",
    "Permission.ShowUsers": "Prikaži korisnike",
    "Permission.EditUsers": "Upravljanje korisnicima",
    "Permission.ShowProjects": "Pregled projekata",
    "Permission.EditProjects": "Upravljaj projektima",
    "Permission.ShowApplications": "Pregledaj prijave",
    "Permission.EditApplications": "Upravljanje aplikacijama",
    "Permission.ShowDemandRequest": "Pregled zahtjeva za ponude",
    "Permission.EditDemandRequest": "Upravljanje zahtjevima za ponude",
    "Permission.CreateDemandRequest": "Izradite zahtjeve za ponudu",
    "Permission.ShowUserRoles": "Prikaži korisničke uloge",
    "Permission.EditUserRoles": "Upravljanje korisničkim ulogama",
    "Permission.ShowGeraete": "Prikaži uređaje",
    "Permission.EditGeraete": "Upravljanje uređajima",
    "Permission.ReadGeraete": "Čitaj uređaje",
    "Permission.Administration": "Administracija",
    "Permission.ReadAuftrag": "Pročitaj naredbe",
    "Permission.ListAuftraege": "Pregled narudžbi",
    "Permission.ShowKarte": "Prikaži kartu",
    "Permission.ProtokollAnzeigen": "Pregled dnevnika",
    "Permission.ProtokollBearbeiten": "Uredi zapisnik",
    "Permission.KarteAnzeigen": "Prikaži kartu",
    "Permission.WorkflowsAnzeigen": "Pregled tijekova rada",
    "Permission.WorkflowsBearbeiten": "Uređivanje tijekova rada",
    "Permission.FahrerBearbeiten": "Uredi upravljački program",
    "Permission.FahrerAnzeigen": "Prikaži vozače",
    "Permission.FahrzeugBearbeiten": "Uredi vozila",
    "Permission.FahrzeugAnzeigen": "Pregled vozila",
    "Permission.ArtikelAnzeigen": "Pogledaj članak",
    "Permission.ArtikelBearbeiten": "Uredi članak",
    "Permission.UvvKatalogAnzeigen": "Pregledajte UVV katalog",
    "Permission.UvvKatalogBearbeiten": "Uredi UVV katalog",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Pregledajte katalog kontrole polazaka",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Uredi katalog provjere polaska",
    "Permission.FormulareBearbeiten": "Uređivanje obrazaca",
    "Permission.UvvPruefungenAnzeigen": "Pregled UVV pregleda",
    "Permission.UvvPruefungenBearbeiten": "Obraditi UVV preglede",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Prikaži UVV stavke",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Uredi UVV stavke",
    "Permission.ChecklisteBearbeiten": "Uredi kontrolne liste",
    "Permission.ChecklisteAnzeigen": "Pregled kontrolnih popisa",
    "Permission.AdresseAnzeigen": "Prikaži adrese",
    "Permission.DokumenteBearbeiten": "Uređivanje dokumenata",
    "Permission.DruckformulareAnzeigen": "Pregledati obrasce za ispis",
    "Permission.DruckformulareBearbeiten": "Uređivanje obrazaca za ispis",
    "Permission.ArtikelgruppenAnzeigen": "Prikaži grupe proizvoda",
    "Permission.ArtikelgruppenBearbeiten": "Uređivanje grupa proizvoda",
    "Permission.Sysadmin": "Sistemski administrator",
    "Permission.FahrzeuggruppenAnzeigen": "Prikaži skupine vozila",
    "Permission.FahrzeuggruppenBearbeiten": "Uređivanje grupa vozila",
    "Permission.GeraetegruppenAnzeigen": "Prikaži grupe uređaja",
    "Permission.GeraetegruppenBearbeiten": "Uređivanje grupa uređaja",
    "Permission.StatuszusatzinfoAnzeigen": "Prikaži dodatne informacije o statusu",
    "Permission.StatuszusatzinfoBearbeiten": "Uredi dodatne informacije o statusu",
    "Permission.Nachrichten": "Vijesti",
    "Permission.AdresseBearbeiten": "Uredi adrese",
    "Permission.WaageAnzeigen": "Prikaži ljestvice",
    "Permission.WaageBearbeiten": "Uredi ljestvice",
    "Permission.Tabellenkonfiguration": "Konfiguracija stola",
    "Permission.EditGeraeteEinfacheDaten": "Promjena jednostavnih podataka za uređaje",
    "Permission.AuftraegeBearbeiten": "Obraditi narudžbe",
    "Permission.AuftraegeLoeschen": "Izbrisi narudžbe",
    "Permission.DokumenteAnzeigen": "Pregledaj dokumente",
    "Permission.Dashboard": "Pregled (nadzorna ploča)",
    "Permission.GastzugangAnzeigen": "Prikaži pristup gostiju",
    "Permission.GastzugangBearbeiten": "Uredi pristup gostiju",
    "Permission.StammtourAnzeigen": "Pregledajte obilazak stalnih posjetitelja",
    "Permission.StammtourBearbeiten": "Uredi noć redovnih",
    "Permission.StoerzeitAnzeigen": "Prikaži vrijeme neaktivnosti",
    "Permission.StoerzeitBearbeiten": "Uredi vrijeme neaktivnosti",
    "Permission.TourenAnzeigen": "Pregled tura",
    "Permission.TourenBearbeiten": "Uredi ture",
    "Permission.Tourenplanung": "Planiranje rute",
    "Anmelden mit Personalnummer": "Prijavite se svojim brojem zaposlenika",
    "TourWiegung1": "1. Teženje",
    "TourWiegung2": "2. Vaganje",
    "BitteWiegung1Durchfuehren": "Molimo izvedite prvo vaganje.",
    "BitteWiegung2Durchfuehren": "Molimo izvedite drugo vaganje.",
    "Permission.AbfahrtskontrolleBearbeiten": "Uredi provjeru odlaska",
    "Permission.AbfahrtskontrolleAnzeigen": "Prikaži prijavu za polazak",
    "Permission.Auswertungen": "Izvještaji",
    "Permission.TexteAnzeigen": "Prikaži tekst",
    "Permission.TexteBearbeiten": "Uredi tekst",
    "AuftragWiegung1": "1. Vaganje",
    "AuftragWiegung2": "2. Vaganje",
    "Beladung": "Učitavanje",
    "Auftrag scannen": "Skeneri po redu",
    "Tour": "Tura",
    "Home_Anmelden": "Prijavite se svojim brojem zaposlenika",
    "Home_TourStarten": "Započni obilazak",
    "Home_TourBeenden": "Kraj ture",
    "Home_AuftragScannen": "Skeneri po redu",
    "Home_Beladung": "Učitavanje",
    "Home_Hofauftraege": "Sudske komisije",
    "Wareneingang": "Primljena roba",
    "Glas-Analyse": "Analiza stakla",
    "Home_Uebersicht": "Pregled",
    "Home_Kunden": "Kupci",
    "NagivationHome": "Početna",
    "UVV-Prüfungen": "UVV pregledi",
    "Dokumente": "Dokumenti",
    "Abmelden": "Odjavi se",
    "Smartwatch": "Pametni sat",
    "ProGlove": "ProGlove",
    "Home_System": "Sustav",
    "Permission.VertraegeAnzeigen": "Pregled ugovora",
    "Permission.VertraegeBearbeiten": "Uređivanje ugovora",
    "Save": "Sačuvaj",
    "Cancel": "Otkaži",
    "NeuenTransportauftragAnlegen": "Izraditi novu transportnu naredbu?",
    "NeuenWareneingangAnlegen": "Unesite novi račun za robu?",
    "NeuenHofauftragAnlegen": "Stvoriti novi poljoprivredni nalog?",
    "Vertrag": "Ugovor",
    "Neuer Auftrag": "Novi nalog",
    "Abbrechen": "Otkaži",
    "Home_Zeiterfassung": "Bilježenje vremena",
    "SchreibgeschuetztVorStatusmeldung": "Naredba je samo za čitanje do prvog ažuriranja statusa.",
    "NavigationErlaubenWennSchreibgeschuetzt": "Omogućite navigaciju u načinu samo za čitanje",
    "TransportauftragLeerePositionenAusblenden": "Sakrij stavke s količinom 0",
    "Auswertungen": "Izvještaji",
    "Abfahrtskontrolle": "Provjera polaska",
    "UVV-Gegenstände": "Stavke obuhvaćene UVV-om",
    "UVV-Katalog": "UVV katalog",
    "Einträge": "Prijave",
    "Name": "Ime",
    "Beschreibung": "Opis",
    "REST-Schnittstelle": "REST sučelje",
    "Abrechnung aktiv": "Naplata je aktivna",
    "API-Token": "API token",
    "Angelegt am": "Stvoreno",
    "Vorname": "Prvo ime",
    "Nachname": "Prezime",
    "Email": "E-pošta",
    "Roles": "Uloge korisnika",
    "Field is required": "Ovo polje je obavezno",
    "E-Mail": "E-pošta",
    "Zugangsdaten ändern": "Promijeni podatke za prijavu",
    "Passwort": "Lozenka",
    "Passwort (bestätigen)": "Lozenka (potvrdi)",
    "Benutzer bearbeiten": "Uredi korisnika",
    "Key": "Ključ",
    "Checkliste": "Kontrolna lista",
    "Mandant": "Klijent",
    "ApiToken": "API token",
    "Latitude": "Latituda",
    "Longitude": "Dužina",
    "Max. Entfernung": "Maksimalna udaljenost",
    "Timeout": "Vrijeme isteklo",
    "Icon": "Ikona",
    "Nummer": "Broj",
    "Bezeichnung": "Opis",
    "Gruppe": "Grupa",
    "App Version": "Verzija aplikacije",
    "Traffic aktueller Monat": "Promet za tekući mjesec",
    "Personalnr.": "Broj osoblja",
    "Personal": "Osoblje",
    "Zuletzt online": "Posljednji online",
    "Fahrzeug": "Vozilo",
    "Anhänger": "Trailer",
    "Letzte Position": "Zadnja pozicija",
    "Farbe": "Boja",
    "Letzte Anmeldung": "Posljednja registracija",
    "Letzte Abmeldung": "Posljednja otkaz",
    "Angemeldet": "Prijavljeno",
    "Telefon": "Telefon",
    "Freitext": "Slobodan tekst",
    "Platform": "Platforma",
    "Version": "Verzija",
    "Hersteller": "Proizvođač",
    "Model": "Model",
    "Alert Berechtigung": "Obavijest o autorizaciji",
    "Erste Verwendung": "Prvo korištenje",
    "Letzte Verwendung": "Zadnja upotreba",
    "Abrechnung ab": "Naplata od",
    "Abrechnung bis": "Naplata do",
    "Preis / Monat": "Cijena mjesečno",
    "Einmaliger Preis ": "Jednokratna cijena ",
    "Geräte (Systemansicht)": "Uređaji (pregled sustava)",
    "RoleName": "Naziv uloge",
    "Symbol": "Simbol",
    "App-Version": "Verzija aplikacije",
    "Verfügbare Waagen": "Dostupne vage",
    "Importieren": "Uvoz",
    "Gerätegruppe bearbeiten": "Uredi grupu uređaja",
    "Kopieren": "Kopiraj",
    "Exportieren": "Izvoz",
    "Zeit (h)": "Vrijeme (h)",
    "Intervall (m)": "Interval (m)",
    "MeldungText": "Tekst poruke",
    "Standard-Dauer": "Standardno trajanje",
    "Typ": "vrsta",
    "Datum": "Datum",
    "Verlauf": "Povijest",
    "Auftragsnr.": "Narudžbeni broj",
    "Gerätenr.": "Oprema br.",
    "Gerät": "Uređaj",
    "Status": "Status",
    "PushStatus": "Stavak",
    "Abholdatum": "Datum prikupljanja",
    "Abholzeit": "Vrijeme za sakupljanje",
    "Erfasser": "Natjecatelj",
    "Adress Nr.": "Adresa br.",
    "Name1": "Ime1",
    "Name2": "Ime2",
    "Strasse": "Ulica",
    "PLZ": "Poštanski broj",
    "Ort": "Mjesto",
    "Kunde Nr.": "Kupac br.",
    "Kunde Name1": "Ime kupca1",
    "Kunde Name2": "Ime kupca2",
    "Kunde Strasse": "Ulica kupca",
    "Kunde PLZ": "Poštanski broj kupca",
    "Kunde Ort": "Lokacija kupca",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "Detaljne informacije 1",
    "DetailInfo2": "Detaljne informacije 2",
    "DetailInfo3": "Detaljne informacije 3",
    "Workflow": "Radni tok",
    "Statusmeldung": "Poruka o statusu",
    "Statuszeit": "Vrijeme statusa",
    "Reihenfolge": "Narudžba",
    "CreationDate": "Datum stvaranja",
    "ModificationDate": "Datum izmjene",
    "Lieferpositionen": "Artikli za dostavu",
    "Auftrag": "Narudžba",
    "RememberMe": "Ostanite prijavljeni",
    "Username": "Korisničko ime",
    "Geräte": "Oprema",
    "Stammdaten": "Osnovni podaci",
    "Adressen": "Adresi",
    "Artikelgruppen": "Grupe proizvoda",
    "Artikel": "Članak",
    "Checklisten": "Kontrolne liste",
    "Fahrer (Personal)": "Vozač (osoblje)",
    "Fahrzeuge": "Vozila",
    "Fahrzeuggruppen": "Kategorije vozila",
    "Konfiguration": "Konfiguracija",
    "Benutzer": "Korisnik",
    "Benutzerrollen": "Uloge korisnika",
    "Druckformulare": "Otisnivi obrasci",
    "Einstellungen": "Postavke",
    "Formulare": "Obrasci",
    "Gerätegruppen": "Grupe uređaja",
    "Waagen": "Ljestvice",
    "Workflows": "Radni tokovi",
    "Statuszusatzinfo": "Dodatne informacije o statusu",
    "Texte": "Tekstovi",
    "Import / Export": "Uvoz / Izvoz",
    "Benutzername": "Korisničko ime",
    "E-Mail-Adresse": "Adresa e-pošte",
    "Passwort ändern": "Promijeni lozinku",
    "Permission.Benachrichtigungen": "Obavijesti",
    "Permission.ZeiterfassungAnzeigen": "Pregled zapisa vremena",
    "Permission.ZeiterfassungBearbeiten": "Uređivanje zabilježavanja vremena",
    "Nachtmodus": "Noćni način",
    "Nachmodus": "Noćni način",
    "KeineAuftraegeGefunden": "Nije pronađen nijedan nalog",
    "KeineAuftraegeVorhanden": "Nema dostupnih narudžbi. Povucite prema dolje za osvježenje.",
    "TourStartenAlertButtonText": "Počnite turu!",
    "Aktuelle Aufträge anzeigen": "Pregledajte trenutne narudžbe",
    "Archiv": "Arhiva",
    "weitere Aufträge vorhanden": "Dostupne su daljnje narudžbe",
    "weiterer Auftrag vorhanden": "Dostupna je još jedna narudžba",
    "Anmerkungen": "Bilješke",
    "AnmerkungenHierEingeben": "Unesite svoje komentare ovdje…",
    "AuftragDarfNichtGeaendertWerden": "Nalog se ne smije mijenjati",
    "AuftragBereitsAbgeschlossen": "Narudžba je već dovršena. Daljnje promjene nisu moguće.",
    "Start": "Početna",
    "System": "Sustav",
    "Transportaufträge": "Prijevozne naloge",
    "Hofaufträge": "Sudske komisije",
    "Entladeort": "Mjesto istovara",
    "Bitte Entladeort wählen": "Molimo odaberite točku istovara.",
    "TourStart_Wiegen": "Težina",
    "TourEnde_StartWiegung": "Težanje na početku ture",
    "TourEnde_EndeWiegung": "Vaganje (cijeli kamion)",
    "Geplante Reihenfolge anzeigen": "Prikaži planirani redoslijed",
    "Permission.GlasAnalyseAnzeigen": "Pregled analize stakla",
    "Permission.GlasAnalyseBearbeiten": "Uredi analizu stakla",
    "BitteAuswaehlenPlaceholder": "Molimo odaberite",
    "BitteAnlageWaehlen": "Molimo odaberite privitak",
    "Permission.GlasAnalyseKonfiguration": "Konfiguracija analize stakla",
    "UVV Prüfung": "UVV pregled",
    "Auftrag_Abholadresse": "Adresa",
    "Auftrag_Erzeugeradresse": "Kupac",
    "Auftrag_Verwerteradresse": "Procesor",
    "Auftrag_Fahrzeug": "Vozilo",
    "Auftrag_Abholdatum": "Datum prikupljanja",
    "Auftrag_Abholzeit": "Vrijeme za sakupljanje",
    "Permission.BerichteAnzeigen": "Pregledaj izvještaje",
    "Permission.BerichteBearbeiten": "Uredi izvještaje",
    "Permission.Kalender": "Kalendar",
    "Permission.NVEAnzeigen": "Prikaži NVE",
    "Permission.NVEBearbeiten": "Uredi NVE",
    "Permission.RegelAnzeigen": "Prikaži pravila",
    "Permission.RegelBearbeiten": "Uredi pravila",
    "ExportMessageStatus_0": "Početni",
    "ExportMessageStatus_1": "Poslano",
    "ExportMessageStatus_2": "Obrđeno",
    "ExportMessageStatus_3": "Greška",
    "ExportMessageStatus_4": "Pričekajte ACK",
    "Gerätegruppe": "Grupa opreme",
    "Sonstiges": "Razno",
    "Sprache": "Jezik",
    "APP Version": "Verzija aplikacije",
    "Local storage": "Lokalno pohranjivanje",
    "Advanced HTTP": "Napredni HTTP",
    "System Alert Berechtigung": "Sistemsko upozorenje: dopuštenje",
    "Navigations-App": "Aplikacija za navigaciju",
    "Zurücksetzen": "Ponovno pokretanje",
    "WebSocket": "WebSocket",
    "Push-Status": "Status potiska",
    "Push-ID": "Push ID",
    "Push-Type": "tip guranja",
    "Anzahl Artikelgruppen": "Broj grupa proizvoda",
    "Anzahl Artikel": "Broj stavki",
    "Anzahl Workflows": "Broj tijekova rada",
    "GPS Dienst läuft": "GPS usluga radi",
    "GPS Dienst aktiv": "GPS usluga je aktivna",
    "GPS Auth-Status": "Status GPS autentifikacije",
    "GPS-Positionen (Puffer)": "GPS položaji (pufer)",
    "Zugangsdaten": "Podaci za prijavu",
    "Geräte-Nummer": "Broj opreme",
    "Host": "Domaćin",
    "Speichern": "Sačuvaj",
    "Stammdaten neu laden": "Ponovno učitaj glavne podatke",
    "Lokale Daten löschen": "Izbriši lokalne podatke",
    "Diagnosedaten senden": "Pošalji dijagnostičke podatke",
    "Testdatei senden": "Pošalji testnu datoteku",
    "Update prüfen": "Provjeri ažuriranja",
    "Dunkler Modus": "Tamni način",
    "Aktivieren": "Aktivirati",
    "Anzeigen": "Oglasi",
    "Anmelden": "Prijavite se",
    "Personalnummer": "Broj osoblja",
    "Kennwort": "lozinka",
    "Mit NFC anmelden": "Prijavite se pomoću NFC-a",
    "Bitte eingeben": "Molimo unesite",
    "Passwort eingeben": "Unesite svoju lozinku",
    "Anmelden mit NFC-Chip": "Prijavite se pomoću NFC čipa",
    "Zur Anmeldung NFC-Chip scannen": "Skenirajte NFC čip za prijavu",
    "Mit Personalnummer anmelden": "Prijavite se svojim brojem zaposlenika",
    "Ablaufdatum": "Rok trajanja",
    "Kein Fahrer für RFID-Chip gefunden": "Nije pronađen upravljački program za RFID čip.",
    "Nachrichten": "Vijesti",
    "Berichte": "Izvještaji",
    "Urlaubsanträge": "Zahtjevi za godišnji odmor",
    "Unfallberichte": "Izvještaji o nesrećama",
    "Tätigkeitsberichte": "Izvještaji o aktivnostima",
    "an": "k",
    "aus": "od",
    "KeineEintraegeVorhanden": "Nije pronađen nijedan unos",
    "StoerzeitFuerAuftrag": "Vremena prekida za redoslijed",
    "StoerzeitFuerTour": "Vremena prekida za turu",
    "Minuten": "minute",
    "Sekunden": "sekunde",
    "Minute": "minuta",
    "TourNichtGestartetLoeschen": "Tura nije započela. Ne može se izbrisati.",
    "ZeiterfassungOhneTourFehler": "Zabilježavanje vremena ne može se pokrenuti bez rute",
    "Tour start": "Početak ture",
    "Kilometerstand": "pređena kilometraža",
    "Fahrer": "Vozač",
    "Beifahrer": "Putnik",
    "Bitte wählen": "Molimo odaberite",
    "Beifahrer 2": "Putnik 2",
    "Abfahrtskontrolle Anhänger": "Provjera odstupanja prikolice",
    "Foto aufnehmen": "Uzmite fotografiju",
    "Zum Bearbeiten hier tippen": "Dodirnite ovdje za uređivanje",
    "Eingeben": "Uđi",
    "Uhrzeit": "Vrijeme",
    "Driver": "Vozač",
    "Passenger": "Putnik",
    "Passenger 2": "Putnik 2",
    "Trailer": "Trailer",
    "Vehicle": "Vozilo",
    "BitteEingabePruefen": "Molimo provjerite svoj unos!",
    "RFID scannen": "Skeniraj RFID",
    "Tour scannen": "Skener ture",
    "Tour starten": "Pokreni turu",
    "Tour laden": "Učitaj turu",
    "Tour entladen": "Isprazni turu",
    "Schreiben": "Pismo",
    "Alle Nachrichten löschen?": "Izbrisati sve poruke?",
    "Löschen": "Izbriši",
    "Ja": "Da",
    "Nein": "Ne",
    "Nächste Prüfung": "Sljedeći ispit",
    "alle anzeigen": "Prikaži sve",
    "Bitte KM eingeben": "Molimo unesite KM",
    "NFCErkennungLaeuft": "NFC detekcija u tijeku…",
    "RFIDWirdGescannt": "RFID se skenira…",
    "OK": "U redu",
    "Fehlerbeschreibung": "Opis pogreške",
    "Bild wirklich löschen?": "Želite li zaista izbrisati ovu sliku?",
    "Frage": "Pitanje",
    "Bitte Kilometerstand angeben": "Molimo navedite kilometražu.",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Molimo vas da u potpunosti ispunite obrazac o dolasku.",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Molimo vas da u potpunosti ispunite obrazac kontrolne liste za dolazak.",
    "Bitte Unterschrift erfassen": "Molimo unesite svoj potpis.",
    "Bitte Namen für die Unterschrift erfassen": "Molimo unesite ime koje će se koristiti za potpis.",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Molimo vas da na dolasku predvidite dovoljno vremena za imigracijske provjere!",
    "AnkunftskontrolleDauerFrage1": "Navedeno vrijeme za prijavu po dolasku nije ispoštovano. Trebamo li ipak nastaviti s turom?",
    "Tour beenden?": "Kraj ture?",
    "AnkunftskontrolleDauerFrage2": "Navedeno vrijeme za prijavu po dolasku nije ispoštovano. Želite li i dalje završiti turu?<br /><br />Poruka će biti poslana!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Molimo vas da u potpunosti ispunite kontrolnu listu za polazak.",
    "AbfahrtskontrolleMeldung1": "Molimo vas da predvidite dovoljno vremena za provjeru polaska!",
    "AbfahrtskontrolleMeldung2": "Navedeno vrijeme za provjeru polaska nije ispoštovano. Trebamo li ipak realizirati turu?",
    "AbfahrtskontrolleMeldung3": "Nije ispoštovan navedeni termin za provjeru polaska. Želite li i dalje započeti turu?<br /><br />Poruka će biti poslana!",
    "KeineWiegungTourTrotzdemStarten": "Težina nije izvršena. Želite li i dalje započeti turu?",
    "Wiegung": "Težina",
    "WiegungErfolgreich": "Potrebno je vaganje!",
    "Tour start?": "Gdje počinje tura?",
    "Tour aktiv seit": "Tura aktivna od",
    "Gestartet um": "Počeo je u",
    "Gestartet gestern": "Počelo jučer",
    "Gestartet": "Počelo",
    "Keine gültige Auftragsnummer": "Neispravan broj narudžbe",
    "Heute offene Aufträge": "Trenutne narudžbe",
    "Heute erledigt Aufträge": "Narudžbe dovršene danas",
    "Morgen": "Sutra",
    "Keine Transportaufträge": "Nema transportnih narudžbi",
    "1 Transportauftrag": "1 Transportni nalog",
    "aktuelle Aufträge": "Trenutne narudžbe",
    "Statusmeldung428": "Izvješće o statusu nije moguće. Vaganje je već započelo. Molimo završite rundu i po potrebi je ponovno pokrenite.",
    "Meldung429": "Poruka o statusu se ne može poslati. Tura još nije započela.Započeti turu sada?",
    "Meldung430": "Status nije dopušten. Molimo prijavite jedan od sljedećih statusa",
    "Meldung431": "Nisu svi predmeti označeni kao dovršeni. Jeste li sigurni da želite označiti ovu paletu kao dovršenu?",
    "Meldung432": "Ažuriranje statusa nije moguće. Molimo prvo unesite razlog za unos vremena '{{NAME}}'.",
    "Es muss mindestens ein Foto gemacht werden!": "Moraš napraviti barem jednu fotografiju!",
    "Alle Aufträge": "Sve narudžbe",
    "Kommissionierung": "Ubravanje narudžbi",
    "Wiegungen": "Teženja",
    "Gekoppelte Waagen": "Povezane vage",
    "Waage suchen...": "Pretraži vagu...",
    "Keine Wiegedaten vorhanden": "Nema dostupnih podataka o težini",
    "Keine Waagen konfiguriert": "Nijedne vage nisu konfigurirane",
    "Waage": "Ljestve",
    "MAC Adresse": "MAC adresa",
    "Aktiv": "Aktivno",
    "Uhr synchronisieren": "Sinkronizirajte sat",
    "Wiegen 1": "Težine 1",
    "Wiegen 2": "Težine 2",
    "Tarieren": "Tara",
    "Keine neue Waage gefunden": "Nije pronađena nova vaga",
    "TourAktivBeendenMeldung449": "Tura je još uvijek aktivna. Želite li sada završiti turu?",
    "WirklichAbmelden": "Jeste li sigurni da se želite odjaviti?",
    "Aktuelle Tour": "Trenutna turneja",
    "Tour beenden": "Kraj ture",
    "Zeiterfassung": "Bilježenje vremena",
    "Zeiterfassung starten": "Počni pratiti vrijeme",
    "Tour Ende": "Kraj ture",
    "Art": "vrsta",
    "Arbeitszeit bearbeiten": "Uredi radno vrijeme",
    "Wiegen": "Težina",
    "Tätigkeitsbericht": "Izvješće o aktivnostima",
    "Personaldaten": "Podaci o osoblju",
    "Tätigkeit": "Aktivnost",
    "Übernachtung": "Smještaj",
    "Beschreibung der Tätigkeit": "Opis posla",
    "Neuer Urlaubsantrag": "Novi zahtjev za odmor",
    "Abteilung": "Odjel",
    "Urlaub": "Praznici",
    "Angemeldete Beifahrer": "Prijavljeni putnici",
    "Beifahrer hinzufügen": "Dodaj putnika",
    "Beifahrer NFC scannen": "Putnik: Skeniraj NFC",
    "BeifahrerListeNichtGeladen": "Popis putnika nije uspio učitati. Molimo provjerite svoju internetsku vezu.",
    "Beifahrer wurde gescannnt": "Putnik na prednjem sjedalu je skeniran.",
    "NfcKeinBeifahrerGefunden": "Nije pronađen putnik za RFID čip",
    "BeifahrerAlsFahrerMeldung473": "Već ste registrirani kao vozač za ovu turu. Ne možete se ponovno registrirati kao putnik.",
    "BeifahrerBereitsAngemeldet": "Već ste registrirani kao putnik.",
    "MaxZweiBeifahrerMoeglich": "Maksimalno se mogu registrirati 2 putnika.",
    "BeifahrerNichtGefunden": "Putnik nije pronađen",
    "BeifahrerWurdeHinzugefuegt": "Putnik je dodan",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Prikolica se ne može skenirati kao vozilo.",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Kamion se ne može skenirati kao prikolica.",
    "AngemeldetSeit": "Registriran od",
    "Hinzufügen": "Dodaj",
    "NFC scannen": "Skeniraj NFC",
    "Beifahrer abmelden": "Odjaviti putnika",
    "Hallo": "Bok",
    "FuehrerscheinkontrolleText1": "Vrijeme je za obnavljanje moje vozačke dozvole.",
    "FuehrerscheinkontrolleTextFoto": "Molimo vas da fotografirate prednju i stražnju stranu svoje vozačke dozvole.",
    "Foto Vorderseite": "Fotografija s naslovnice",
    "Foto Rückseite": "Fotografija na poleđini",
    "FuehrerscheinkontrolleTextNFC": "Molimo skenirajte NFC čip na svojoj vozačkoj dozvoli.",
    "FuehrerscheinkontrolleNfcFalsch": "Neispravan NFC čip",
    "Fahrerkarten": "Vozačke kartice",
    "Führerscheinkontrolle": "Provjera vozačke dozvole",
    "Später": "Kasnije",
    "Führerschein erfolgreich gescannt": "Vozačka dozvola uspješno skenirana",
    "Bitte Ablaufdatum erfassen": "Molimo unesite datum isteka",
    "Führerscheinprüfung wirklich verschieben?": "Trebam li stvarno odgoditi vožnju?",
    "Abmelden?": "Odjavi se?",
    "Bitte NFC-Chip scannen": "Molimo skenirajte NFC čip.",
    "Suchen": "Pretraži",
    "Archiv anzeigen": "Pregledaj arhivu",
    "Übersicht": "Pregled",
    "Bitte Entladeort auswählen": "Molimo odaberite točku istovara.",
    "Von": "Od",
    "Bis": "do",
    "Zeitausgleich": "Naknadno slobodno vrijeme",
    "Urlaub 2": "Odmor 2",
    "Urlaub 3": "Holiday 3",
    "Urlaub 4": "Holiday 4",
    "Unterschrift erforderlich": "Potrebno je potpisati",
    "Zum unterschreiben hier tippen": "Dodirnite ovdje da potpišete",
    "Unterschrift": "Potpis",
    "Wird geladen...": "Učitavanje...",
    "Funktion im Browser nicht verfügbar": "Ova značajka nije dostupna u pregledniku.",
    "GETRENNT": "ODVOJITI",
    "FormValidationError": "Molimo provjerite svoje unose. Obrazac nije u potpunosti ispunjen.",
    "Permission.ListTouren": "Pregled tura",
    "Permission.EditTouren": "Uredi ture",
    "Protokoll": "Zapisnik",
    "Werkstatt": "Radionica",
    "Kostenstellen": "Centar troškova",
    "Benachrichtigungen": "Obavijesti",
    "Externe Systeme": "Vanjski sustavi",
    "Regeln": "Pravila",
    "Masterdata1": "Centar troškova",
    "Feld ist erforderlich": "Ovo polje je obavezno",
    "FormularfehlerText": "Molimo provjerite svoje unose. Obrazac nije u potpunosti ispunjen.",
    "Eintrag wirklich löschen?": "Jeste li sigurni da želite izbrisati ovaj unos?",
    "MasterdataList1": "Centar troškova",
    "EintragWirklichLoeschen": "Jeste li sigurni da želite izbrisati ovaj unos?",
    "Loeschen": "Izbriši",
    "AusgewaehlteZeilenWirklichLoeschen": "Želite li doista izbrisati odabrane retke?",
    "Gerätegruppe einschränken": "Ograniči grupu uređaja",
    "Fahrer-Namen nicht anzeigen": "Ne prikazuj imena jahača",
    "Rolle bearbeiten": "Uredi ulogu",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Uređivanje grupa uređaja (osnovni podaci)",
    "Permission.Werkstattuebersicht": "Pregled radionice",
    "Permission.Kostenstellen": "Centar troškova",
    "Permission.EinstellungenKunde": "Postavke (osnovne)",
    "Design": "Dizajn",
    "Benutzeranmeldung": "Prijava korisnika",
    "Fotos": "Fotografije",
    "Tour E-Mails": "Putnička e-pošta",
    "Sicherheitshinweis": "Obavijest o sigurnosti",
    "Pellets": "Peleti",
    "Allgemein": "Općenito",
    "Custom CSS": "Prilagođeni CSS",
    "Barcodes": "Barcode",
    "Datenherkunft": "Izvor podataka",
    "Freigabeprozess": "Proces odobrenja",
    "Kontakte": "Kontakt",
    "Menü": "Izbornik",
    "Preise": "Cijene",
    "Verträge": "Ugovori",
    "Tour-Start": "Početak ture",
    "Tour-Ende": "Kraj ture",
    "GPS": "GPS",
    "GPS-Positionen": "GPS koordinate",
    "Position senden": "Pošalji lokaciju",
    "Navigation": "Pregled",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Kontejner",
    "Peripherie": "Periferno",
    "Drucker": "Pisač",
    "Mobile Waagen": "Prijenosne vage",
    "Stationäre Waagen": "Stacionarne vage",
    "Proglove": "Proglove",
    "LKW-Beladung": "Učitavanje kamiona",
    "Web": "Web",
    "Tourenplanung": "Planiranje rute",
    "Sondermodule": "Posebni moduli",
    "Sprachen": "Jezici",
    "Datenbereinigung": "Čišćenje podataka",
    "Daten-Export": "Izvoz podataka",
    "Fehlerdiagnose": "Dijagnostika kvarova",
    "Untermandanten": "Podklijenti",
    "WebSocket-Verbindung": "WebSocket veza",
    "Aufträge": "Narudžbe",
    "Karte": "Karta",
    "ExtNummer": "Vanjski broj naloga",
    "ExtNummerHierEingeben": "Ovdje unesite vanjski broj naloga…",
    "Foto aus Galerie auswählen": "Odaberite fotografiju iz galerije"
  },
  "CS": {
    "Permissions": "Oprávnění",
    "Permission.ShowUsers": "Zobrazit uživatele",
    "Permission.EditUsers": "Správa uživatelů",
    "Permission.ShowProjects": "Zobrazit projekty",
    "Permission.EditProjects": "Správa projektů",
    "Permission.ShowApplications": "Zobrazit žádosti",
    "Permission.EditApplications": "Správa žádostí",
    "Permission.ShowDemandRequest": "Zobrazit poptávky",
    "Permission.EditDemandRequest": "Správa poptávek",
    "Permission.CreateDemandRequest": "Vytváření poptávek",
    "Permission.ShowUserRoles": "Zobrazit uživatelské role",
    "Permission.EditUserRoles": "Správa uživatelských rolí",
    "Permission.ShowGeraete": "Zobrazit zařízení",
    "Permission.EditGeraete": "Správa zařízení",
    "Permission.ReadGeraete": "Čtení zařízení",
    "Permission.Administration": "Správa",
    "Permission.ReadAuftrag": "Číst objednávky",
    "Permission.ListAuftraege": "Zobrazit zakázky",
    "Permission.ShowKarte": "Zobrazit mapu",
    "Permission.ProtokollAnzeigen": "Zobrazit protokol",
    "Permission.ProtokollBearbeiten": "Upravit protokol",
    "Permission.KarteAnzeigen": "Zobrazit mapu",
    "Permission.WorkflowsAnzeigen": "Zobrazit pracovní postupy",
    "Permission.WorkflowsBearbeiten": "Úprava pracovních postupů",
    "Permission.FahrerBearbeiten": "Upravit řidiče",
    "Permission.FahrerAnzeigen": "Zobrazit řidiče",
    "Permission.FahrzeugBearbeiten": "Upravit vozidla",
    "Permission.FahrzeugAnzeigen": "Zobrazit vozidla",
    "Permission.ArtikelAnzeigen": "Zobrazit článek",
    "Permission.ArtikelBearbeiten": "Upravit článek",
    "Permission.UvvKatalogAnzeigen": "Zobrazit katalog UVV",
    "Permission.UvvKatalogBearbeiten": "Upravit katalog UVV",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Zobrazit katalog kontrolních bodů na trase",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Upravit katalog kontrol při odjezdu",
    "Permission.FormulareBearbeiten": "Úprava formulářů",
    "Permission.UvvPruefungenAnzeigen": "Zobrazit kontroly podle UVV",
    "Permission.UvvPruefungenBearbeiten": "Zpracování kontrol podle UVV",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Zobrazit položky UVV",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Úprava položek UVV",
    "Permission.ChecklisteBearbeiten": "Úprava kontrolních seznamů",
    "Permission.ChecklisteAnzeigen": "Zobrazit kontrolní seznamy",
    "Permission.AdresseAnzeigen": "Zobrazit adresy",
    "Permission.DokumenteBearbeiten": "Úprava dokumentů",
    "Permission.DruckformulareAnzeigen": "Zobrazit tiskové formuláře",
    "Permission.DruckformulareBearbeiten": "Úprava tiskových formulářů",
    "Permission.ArtikelgruppenAnzeigen": "Zobrazit skupiny článků",
    "Permission.ArtikelgruppenBearbeiten": "Úprava skupin článků",
    "Permission.Sysadmin": "Správce systému",
    "Permission.FahrzeuggruppenAnzeigen": "Zobrazit skupiny vozidel",
    "Permission.FahrzeuggruppenBearbeiten": "Úprava skupin vozidel",
    "Permission.GeraetegruppenAnzeigen": "Zobrazit skupiny zařízení",
    "Permission.GeraetegruppenBearbeiten": "Úprava skupin zařízení",
    "Permission.StatuszusatzinfoAnzeigen": "Zobrazit doplňkové informace o stavu",
    "Permission.StatuszusatzinfoBearbeiten": "Upravit doplňkové informace o stavu",
    "Permission.Nachrichten": "Zprávy",
    "Permission.AdresseBearbeiten": "Úprava adres",
    "Permission.WaageAnzeigen": "Zobrazit váhy",
    "Permission.WaageBearbeiten": "Úprava vah",
    "Permission.Tabellenkonfiguration": "Konfigurace tabulky",
    "Permission.EditGeraeteEinfacheDaten": "Změna jednoduchých údajů v zařízeních",
    "Permission.AuftraegeBearbeiten": "Zpracovávat zakázky",
    "Permission.AuftraegeLoeschen": "Smazat zakázky",
    "Permission.DokumenteAnzeigen": "Zobrazit dokumenty",
    "Permission.Dashboard": "Přehled (Dashboard)",
    "Permission.GastzugangAnzeigen": "Zobrazit přístup pro hosty",
    "Permission.GastzugangBearbeiten": "Upravit přístup pro hosty",
    "Permission.StammtourAnzeigen": "Zobrazit pravidelnou túru",
    "Permission.StammtourBearbeiten": "Upravit pravidelnou trasu",
    "Permission.StoerzeitAnzeigen": "Zobrazit dobu výpadku",
    "Permission.StoerzeitBearbeiten": "Upravit dobu výpadku",
    "Permission.TourenAnzeigen": "Zobrazit trasy",
    "Permission.TourenBearbeiten": "Upravit trasy",
    "Permission.Tourenplanung": "Plánování tras",
    "Anmelden mit Personalnummer": "Přihlášení pomocí personálního čísla",
    "TourWiegung1": "1. Vážení",
    "TourWiegung2": "2. Vážení",
    "BitteWiegung1Durchfuehren": "Prosím, proveďte první vážení",
    "BitteWiegung2Durchfuehren": "Prosím, proveďte druhé vážení",
    "Permission.AbfahrtskontrolleBearbeiten": "Upravit kontrolu odjezdu",
    "Permission.AbfahrtskontrolleAnzeigen": "Zobrazit kontrolu odjezdu",
    "Permission.Auswertungen": "Vyhodnocení",
    "Permission.TexteAnzeigen": "Zobrazit texty",
    "Permission.TexteBearbeiten": "Úpravy textů",
    "AuftragWiegung1": "1. Vážení",
    "AuftragWiegung2": "2. Vážení",
    "Beladung": "Nakládka",
    "Auftrag scannen": "Naskenovat objednávku",
    "Tour": "Prohlídka",
    "Home_Anmelden": "Přihlášení pomocí personálního čísla",
    "Home_TourStarten": "Spustit prohlídku",
    "Home_TourBeenden": "Ukončit prohlídku",
    "Home_AuftragScannen": "Naskenovat objednávku",
    "Home_Beladung": "Nakládka",
    "Home_Hofauftraege": "Zakázky pro dvůr",
    "Wareneingang": "Příjem zboží",
    "Glas-Analyse": "Analýza skla",
    "Home_Uebersicht": "Přehled",
    "Home_Kunden": "Zákazníci",
    "NagivationHome": "Domů",
    "UVV-Prüfungen": "Kontroly v rámci UVV",
    "Dokumente": "Dokumenty",
    "Abmelden": "Odhlásit se",
    "Smartwatch": "Chytré hodinky",
    "ProGlove": "ProGlove",
    "Home_System": "Systém",
    "Permission.VertraegeAnzeigen": "Zobrazit smlouvy",
    "Permission.VertraegeBearbeiten": "Úprava smluv",
    "Save": "Uložit",
    "Cancel": "Zrušit",
    "NeuenTransportauftragAnlegen": "Vytvořit nový přepravní příkaz?",
    "NeuenWareneingangAnlegen": "Zaznamenat nový příjem zboží?",
    "NeuenHofauftragAnlegen": "Vytvořit novou zakázku pro statek?",
    "Vertrag": "Smlouva",
    "Neuer Auftrag": "Nová zakázka",
    "Abbrechen": "Zrušit",
    "Home_Zeiterfassung": "Evidence pracovní doby",
    "SchreibgeschuetztVorStatusmeldung": "Úloha je v režimu jen pro čtení až do první zprávy o stavu",
    "NavigationErlaubenWennSchreibgeschuetzt": "Povolit navigaci, pokud je soubor jen pro čtení",
    "TransportauftragLeerePositionenAusblenden": "Skrýt položky s množstvím 0",
    "Auswertungen": "Vyhodnocení",
    "Abfahrtskontrolle": "Odletová kontrola",
    "UVV-Gegenstände": "Předměty podle UVV",
    "UVV-Katalog": "Katalog UVV",
    "Einträge": "Záznamy",
    "Name": "Jméno",
    "Beschreibung": "Popis",
    "REST-Schnittstelle": "Rozhraní REST",
    "Abrechnung aktiv": "Aktivní vyúčtování",
    "API-Token": "API token",
    "Angelegt am": "Vytvořeno dne",
    "Vorname": "Křestní jméno",
    "Nachname": "Příjmení",
    "Email": "E-mail",
    "Roles": "Role uživatelů",
    "Field is required": "Toto pole je povinné",
    "E-Mail": "E-mail",
    "Zugangsdaten ändern": "Změnit přihlašovací údaje",
    "Passwort": "Heslo",
    "Passwort (bestätigen)": "Heslo (potvrdit)",
    "Benutzer bearbeiten": "Upravit uživatele",
    "Key": "Klíč",
    "Checkliste": "Kontrolní seznam",
    "Mandant": "Klient",
    "ApiToken": "API token",
    "Latitude": "Zeměpisná šířka",
    "Longitude": "Délka",
    "Max. Entfernung": "Max. vzdálenost",
    "Timeout": "Časový limit",
    "Icon": "Ikona",
    "Nummer": "Číslo",
    "Bezeichnung": "Název",
    "Gruppe": "Skupina",
    "App Version": "Verze aplikace",
    "Traffic aktueller Monat": "Návštěvnost v aktuálním měsíci",
    "Personalnr.": "Číslo zaměstnance",
    "Personal": "Personál",
    "Zuletzt online": "Naposledy online",
    "Fahrzeug": "Vozidlo",
    "Anhänger": "přívěs",
    "Letzte Position": "Poslední poloha",
    "Farbe": "Barva",
    "Letzte Anmeldung": "Poslední přihlášení",
    "Letzte Abmeldung": "Poslední odhlášení",
    "Angemeldet": "Přihlášen",
    "Telefon": "Telefon",
    "Freitext": "Volný text",
    "Platform": "Platforma",
    "Version": "Verze",
    "Hersteller": "Výrobce",
    "Model": "Model",
    "Alert Berechtigung": "Oprávnění k upozornění",
    "Erste Verwendung": "První použití",
    "Letzte Verwendung": "Poslední použití",
    "Abrechnung ab": "Vyúčtování od",
    "Abrechnung bis": "Vyúčtování do",
    "Preis / Monat": "Cena za měsíc",
    "Einmaliger Preis ": "Jednorázová cena ",
    "Geräte (Systemansicht)": "Zařízení (systémový přehled)",
    "RoleName": "Název role",
    "Symbol": "Symbol",
    "App-Version": "Verze aplikace",
    "Verfügbare Waagen": "Dostupné váhy",
    "Importieren": "Importovat",
    "Gerätegruppe bearbeiten": "Upravit skupinu zařízení",
    "Kopieren": "Kopírovat",
    "Exportieren": "Exportovat",
    "Zeit (h)": "Čas (h)",
    "Intervall (m)": "Interval (m)",
    "MeldungText": "Text zprávy",
    "Standard-Dauer": "Standardní doba trvání",
    "Typ": "Typ",
    "Datum": "Datum",
    "Verlauf": "Průběh",
    "Auftragsnr.": "Číslo zakázky",
    "Gerätenr.": "Číslo zařízení",
    "Gerät": "Zařízení",
    "Status": "Stav",
    "PushStatus": "PushStatus",
    "Abholdatum": "Datum vyzvednutí",
    "Abholzeit": "Čas vyzvednutí",
    "Erfasser": "Zadavatel",
    "Adress Nr.": "Číslo adresy",
    "Name1": "Jméno1",
    "Name2": "Jméno2",
    "Strasse": "Ulice",
    "PLZ": "PSČ",
    "Ort": "Místo",
    "Kunde Nr.": "Číslo zákazníka:",
    "Kunde Name1": "Zákazník Jméno1",
    "Kunde Name2": "Zákazník Jméno2",
    "Kunde Strasse": "Zákazník Ulice",
    "Kunde PLZ": "PSČ zákazníka",
    "Kunde Ort": "Zákazník Místo",
    "Info1": "Info1",
    "Info2": "Info2",
    "Info3": "Info3",
    "DetailInfo1": "Podrobné informace 1",
    "DetailInfo2": "Podrobné informace 2",
    "DetailInfo3": "Podrobné informace 3",
    "Workflow": "Pracovní postup",
    "Statusmeldung": "Stavová zpráva",
    "Statuszeit": "Doba trvání stavu",
    "Reihenfolge": "Pořadí",
    "CreationDate": "Datum vytvoření",
    "ModificationDate": "Datum úpravy",
    "Lieferpositionen": "Dodávané položky",
    "Auftrag": "Zakázka",
    "RememberMe": "Zůstat přihlášený",
    "Username": "Uživatelské jméno",
    "Geräte": "Zařízení",
    "Stammdaten": "Základní údaje",
    "Adressen": "Adresy",
    "Artikelgruppen": "Skupiny článků",
    "Artikel": "Článek",
    "Checklisten": "Kontrolní seznamy",
    "Fahrer (Personal)": "Řidič (zaměstnanec)",
    "Fahrzeuge": "Vozidla",
    "Fahrzeuggruppen": "Skupiny vozidel",
    "Konfiguration": "Konfigurace",
    "Benutzer": "Uživatel",
    "Benutzerrollen": "Role uživatelů",
    "Druckformulare": "Tiskové formuláře",
    "Einstellungen": "Nastavení",
    "Formulare": "Formuláře",
    "Gerätegruppen": "Skupiny zařízení",
    "Waagen": "Váhy",
    "Workflows": "Pracovní postupy",
    "Statuszusatzinfo": "Doplňkové informace o stavu",
    "Texte": "Texty",
    "Import / Export": "Import / Export",
    "Benutzername": "Uživatelské jméno",
    "E-Mail-Adresse": "E-mailová adresa",
    "Passwort ändern": "Změnit heslo",
    "Permission.Benachrichtigungen": "Oznámení",
    "Permission.ZeiterfassungAnzeigen": "Zobrazit evidenci pracovní doby",
    "Permission.ZeiterfassungBearbeiten": "Upravit záznam o odpracované době",
    "Nachtmodus": "Noční režim",
    "Nachmodus": "Noční režim",
    "KeineAuftraegeGefunden": "Nebyly nalezeny žádné zakázky",
    "KeineAuftraegeVorhanden": "Žádné úkoly. Pro aktualizaci přetáhněte dolů.",
    "TourStartenAlertButtonText": "Začít prohlídku!",
    "Aktuelle Aufträge anzeigen": "Zobrazit aktuální zakázky",
    "Archiv": "Archiv",
    "weitere Aufträge vorhanden": "k dispozici jsou další zakázky",
    "weiterer Auftrag vorhanden": "je k dispozici další zakázka",
    "Anmerkungen": "Poznámky",
    "AnmerkungenHierEingeben": "Zde zadejte poznámky…",
    "AuftragDarfNichtGeaendertWerden": "Zakázku nelze měnit",
    "AuftragBereitsAbgeschlossen": "Zakázka již byla dokončena. Změny již nejsou možné.",
    "Start": "Úvod",
    "System": "Systém",
    "Transportaufträge": "Přepravní zakázky",
    "Hofaufträge": "Zakázky pro dvůr",
    "Entladeort": "Místo vykládky",
    "Bitte Entladeort wählen": "Vyberte prosím místo vykládky",
    "TourStart_Wiegen": "Vážení",
    "TourEnde_StartWiegung": "Vážení při startu závodu",
    "TourEnde_EndeWiegung": "Vážení (plně naložený kamion)",
    "Geplante Reihenfolge anzeigen": "Zobrazit plánované pořadí",
    "Permission.GlasAnalyseAnzeigen": "Zobrazit analýzu skla",
    "Permission.GlasAnalyseBearbeiten": "Upravit analýzu skla",
    "BitteAuswaehlenPlaceholder": "Vyberte prosím",
    "BitteAnlageWaehlen": "Vyberte prosím přílohu",
    "Permission.GlasAnalyseKonfiguration": "Konfigurace analýzy skla",
    "UVV Prüfung": "Kontrola v souladu s předpisy o bezpečnosti práce",
    "Auftrag_Abholadresse": "Adresa",
    "Auftrag_Erzeugeradresse": "Zákazník",
    "Auftrag_Verwerteradresse": "Zpracovatel",
    "Auftrag_Fahrzeug": "Vozidlo",
    "Auftrag_Abholdatum": "Datum vyzvednutí",
    "Auftrag_Abholzeit": "Čas vyzvednutí",
    "Permission.BerichteAnzeigen": "Zobrazit zprávy",
    "Permission.BerichteBearbeiten": "Upravovat zprávy",
    "Permission.Kalender": "Kalendář",
    "Permission.NVEAnzeigen": "Zobrazit NVE",
    "Permission.NVEBearbeiten": "Upravit NVE",
    "Permission.RegelAnzeigen": "Zobrazit pravidla",
    "Permission.RegelBearbeiten": "Upravit pravidla",
    "ExportMessageStatus_0": "Počáteční",
    "ExportMessageStatus_1": "Odesláno",
    "ExportMessageStatus_2": "Zpracováno",
    "ExportMessageStatus_3": "Chyba",
    "ExportMessageStatus_4": "Čekej na ACK",
    "Gerätegruppe": "Skupina zařízení",
    "Sonstiges": "Ostatní",
    "Sprache": "Jazyk",
    "APP Version": "Verze aplikace",
    "Local storage": "Místní úložiště",
    "Advanced HTTP": "Pokročilé HTTP",
    "System Alert Berechtigung": "Oprávnění pro systémová upozornění",
    "Navigations-App": "Navigační aplikace",
    "Zurücksetzen": "Vynulovat",
    "WebSocket": "WebSocket",
    "Push-Status": "Stav push",
    "Push-ID": "Push-ID",
    "Push-Type": "Typ Push",
    "Anzahl Artikelgruppen": "Počet skupin položek",
    "Anzahl Artikel": "Počet položek",
    "Anzahl Workflows": "Počet pracovních postupů",
    "GPS Dienst läuft": "Služba GPS běží",
    "GPS Dienst aktiv": "Služba GPS je aktivní",
    "GPS Auth-Status": "Stav ověření GPS",
    "GPS-Positionen (Puffer)": "GPS souřadnice (vazební zóna)",
    "Zugangsdaten": "Přihlašovací údaje",
    "Geräte-Nummer": "Číslo zařízení",
    "Host": "Hostitel",
    "Speichern": "Uložit",
    "Stammdaten neu laden": "Načíst kmenová data znovu",
    "Lokale Daten löschen": "Vymazat místní data",
    "Diagnosedaten senden": "Odeslat diagnostická data",
    "Testdatei senden": "Odeslat testovací soubor",
    "Update prüfen": "Zkontrolovat aktualizace",
    "Dunkler Modus": "Tmavý režim",
    "Aktivieren": "Aktivovat",
    "Anzeigen": "Zobrazit",
    "Anmelden": "Přihlásit se",
    "Personalnummer": "personální číslo",
    "Kennwort": "Heslo",
    "Mit NFC anmelden": "Přihlásit se pomocí NFC",
    "Bitte eingeben": "Zadejte prosím",
    "Passwort eingeben": "Zadejte heslo",
    "Anmelden mit NFC-Chip": "Přihlášení pomocí čipu NFC",
    "Zur Anmeldung NFC-Chip scannen": "Pro přihlášení naskenujte čip NFC",
    "Mit Personalnummer anmelden": "Přihlásit se pomocí personálního čísla",
    "Ablaufdatum": "Datum vypršení platnosti",
    "Kein Fahrer für RFID-Chip gefunden": "Nenalezen žádný ovladač pro čip RFID",
    "Nachrichten": "Zprávy",
    "Berichte": "Zprávy",
    "Urlaubsanträge": "Žádosti o dovolenou",
    "Unfallberichte": "Zprávy o nehodách",
    "Tätigkeitsberichte": "Zprávy o činnosti",
    "an": "na",
    "aus": "z",
    "KeineEintraegeVorhanden": "Žádné záznamy nejsou k dispozici",
    "StoerzeitFuerAuftrag": "Doba, kdy není možné zadat objednávku",
    "StoerzeitFuerTour": "Doba, kdy je trasa uzavřena",
    "Minuten": "minut",
    "Sekunden": "sekundy",
    "Minute": "minuta",
    "TourNichtGestartetLoeschen": "Prohlídka nebyla zahájena. Nelze smazat.",
    "ZeiterfassungOhneTourFehler": "Zaznamenávání pracovní doby nelze spustit bez trasy",
    "Tour start": "Začátek prohlídky",
    "Kilometerstand": "počet najetých kilometrů",
    "Fahrer": "Řidič",
    "Beifahrer": "spolujezdec",
    "Bitte wählen": "Vyberte prosím",
    "Beifahrer 2": "Spolujezdec 2",
    "Abfahrtskontrolle Anhänger": "Kontrola odjezdu přívěsů",
    "Foto aufnehmen": "Pořídit fotografii",
    "Zum Bearbeiten hier tippen": "K úpravám klepněte sem",
    "Eingeben": "Zadat",
    "Uhrzeit": "Čas",
    "Driver": "Ovladač",
    "Passenger": "Cestující",
    "Passenger 2": "Cestující 2",
    "Trailer": "Trailer",
    "Vehicle": "Vozidlo",
    "BitteEingabePruefen": "Zkontrolujte prosím zadání!",
    "RFID scannen": "Skenování RFID",
    "Tour scannen": "Naskenovat trasu",
    "Tour starten": "Spustit prohlídku",
    "Tour laden": "Načíst trasu",
    "Tour entladen": "Načíst trasu",
    "Schreiben": "Dopis",
    "Alle Nachrichten löschen?": "Smazat všechny zprávy?",
    "Löschen": "Smazat",
    "Ja": "Ano",
    "Nein": "Ne",
    "Nächste Prüfung": "Další zkouška",
    "alle anzeigen": "zobrazit vše",
    "Bitte KM eingeben": "Zadejte prosím KM",
    "NFCErkennungLaeuft": "Probíhá rozpoznávání NFC…",
    "RFIDWirdGescannt": "Probíhá skenování RFID…",
    "OK": "OK",
    "Fehlerbeschreibung": "Popis chyby",
    "Bild wirklich löschen?": "Opravdu chcete obrázek smazat?",
    "Frage": "Otázka",
    "Bitte Kilometerstand angeben": "Uveďte prosím počet najetých kilometrů",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Prosím, vyplňte celý formulář při příjezdu",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Prosím, vyplňte úplně formulář pro kontrolu při příjezdu přívěsu",
    "Bitte Unterschrift erfassen": "Zadejte prosím podpis",
    "Bitte Namen für die Unterschrift erfassen": "Zadejte prosím jméno pro podpis",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Prosím, vyhraďte si dostatek času na kontrolu při příletu!",
    "AnkunftskontrolleDauerFrage1": "Nebylo dodrženo stanovené časové rozmezí pro kontrolu při příjezdu. Máme i tak dokončit trasu?",
    "Tour beenden?": "Ukončit prohlídku?",
    "AnkunftskontrolleDauerFrage2": "Nebylo dodrženo stanovené časové okno pro kontrolu při příjezdu. Chcete i tak dokončit trasu?<br /><br />Bude odeslána zpráva!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Prosím, vyplňte kontrolní list před odjezdem v plném rozsahu",
    "AbfahrtskontrolleMeldung1": "Prosím, vyhraďte si dostatek času na kontrolu před odjezdem!",
    "AbfahrtskontrolleMeldung2": "Nebylo dodrženo stanovené časové lhůty pro kontrolu před odjezdem. Máme i tak vyrazit na trasu?",
    "AbfahrtskontrolleMeldung3": "Nebylo dodrženo stanovené časové omezení pro kontrolu před odjezdem. Chcete i tak zahájit trasu?<br /><br />Bude odeslána zpráva!",
    "KeineWiegungTourTrotzdemStarten": "Vážení nebylo provedeno. Chcete i tak zahájit trasu?",
    "Wiegung": "Vážení",
    "WiegungErfolgreich": "Je nutné zvážit!",
    "Tour start?": "Začátek prohlídky?",
    "Tour aktiv seit": "Prohlídka probíhá od",
    "Gestartet um": "Začalo v",
    "Gestartet gestern": "Začalo to včera",
    "Gestartet": "Zahájeno",
    "Keine gültige Auftragsnummer": "Neplatné číslo objednávky",
    "Heute offene Aufträge": "Aktuální zakázky",
    "Heute erledigt Aufträge": "Dnes vyřízené zakázky",
    "Morgen": "Zítra",
    "Keine Transportaufträge": "Žádné přepravní zakázky",
    "1 Transportauftrag": "1 přepravní zakázka",
    "aktuelle Aufträge": "aktuální zakázky",
    "Statusmeldung428": "Zpráva o stavu nelze odeslat. Vážení již bylo spuštěno. Ukončete prosím cyklus a v případě potřeby jej spusťte znovu.",
    "Meldung429": "<p>Nelze zobrazit stav. Prohlídka ještě nezačala.</p><p>Chcete prohlídku spustit nyní?</p>",
    "Meldung430": "Tento stav není povolen. Uveďte prosím jeden z následujících stavů",
    "Meldung431": "Nebyly nahlášeny všechny pozice. Opravdu chcete nahlásit paletu jako hotovou?",
    "Meldung432": "Zpráva o stavu není možná. Nejprve prosím zadejte důvod pro záznam času „{{NAME}}“.",
    "Es muss mindestens ein Foto gemacht werden!": "Je třeba pořídit alespoň jednu fotografii!",
    "Alle Aufträge": "Všechny zakázky",
    "Kommissionierung": "Vychystávání",
    "Wiegungen": "Vážení",
    "Gekoppelte Waagen": "Propojené váhy",
    "Waage suchen...": "Hledat váhu...",
    "Keine Wiegedaten vorhanden": "Nejsou k dispozici žádné údaje o vážení",
    "Keine Waagen konfiguriert": "Není nakonfigurována žádná váha",
    "Waage": "Váha",
    "MAC Adresse": "Adresa MAC",
    "Aktiv": "Aktivní",
    "Uhr synchronisieren": "Synchronizovat hodiny",
    "Wiegen 1": "Vážení 1",
    "Wiegen 2": "Vážení 2",
    "Tarieren": "Vážení",
    "Keine neue Waage gefunden": "Nebyly nalezeny žádné nové váhy",
    "TourAktivBeendenMeldung449": "Prohlídka ještě probíhá. Chcete prohlídku ukončit?",
    "WirklichAbmelden": "Opravdu se chcete odhlásit?",
    "Aktuelle Tour": "Aktuální turné",
    "Tour beenden": "Ukončit prohlídku",
    "Zeiterfassung": "Evidence pracovní doby",
    "Zeiterfassung starten": "Spustit zaznamenávání času",
    "Tour Ende": "Konec prohlídky",
    "Art": "Druh",
    "Arbeitszeit bearbeiten": "Upravit pracovní dobu",
    "Wiegen": "Vážení",
    "Tätigkeitsbericht": "Zpráva o činnosti",
    "Personaldaten": "Osobní údaje",
    "Tätigkeit": "Činnost",
    "Übernachtung": "Ubytování",
    "Beschreibung der Tätigkeit": "Popis činnosti",
    "Neuer Urlaubsantrag": "Nová žádost o dovolenou",
    "Abteilung": "Oddělení",
    "Urlaub": "Dovolená",
    "Angemeldete Beifahrer": "Zaregistrovaní spolujezdci",
    "Beifahrer hinzufügen": "Přidat spolujezdce",
    "Beifahrer NFC scannen": "Naskenujte NFC spolujezdce",
    "BeifahrerListeNichtGeladen": "Seznam spolucestujících se nepodařilo načíst. Zkontrolujte prosím připojení k internetu.",
    "Beifahrer wurde gescannnt": "Spolujezdec byl naskenován",
    "NfcKeinBeifahrerGefunden": "Nebylo nalezeno žádné zařízení pro RFID čip",
    "BeifahrerAlsFahrerMeldung473": "Jste již zaregistrováni jako řidič pro tuto trasu. Nemůžete se znovu zaregistrovat jako spolujezdec.",
    "BeifahrerBereitsAngemeldet": "Jste již zaregistrováni jako spolujezdec.",
    "MaxZweiBeifahrerMoeglich": "Lze přihlásit maximálně 2 spolujezdce",
    "BeifahrerNichtGefunden": "Spolujezdec nebyl nalezen",
    "BeifahrerWurdeHinzugefuegt": "Byl přidán spolujezdec",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Přívěs nelze naskenovat jako vozidlo",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Nákladní vozidlo nelze naskenovat jako přívěs",
    "AngemeldetSeit": "Registrován od",
    "Hinzufügen": "Přidat",
    "NFC scannen": "Naskenovat pomocí NFC",
    "Beifahrer abmelden": "Odhlásit spolujezdce",
    "Hallo": "Ahoj",
    "FuehrerscheinkontrolleText1": "Je čas na kontrolu řidičského průkazu.",
    "FuehrerscheinkontrolleTextFoto": "Vyfoťte prosím přední a zadní stranu svého řidičského průkazu.",
    "Foto Vorderseite": "Fotografie přední strany",
    "Foto Rückseite": "Fotografie zadní strany",
    "FuehrerscheinkontrolleTextNFC": "Naskenujte prosím čip NFC na svém řidičském průkazu.",
    "FuehrerscheinkontrolleNfcFalsch": "Neplatný čip NFC",
    "Fahrerkarten": "Karty řidiče",
    "Führerscheinkontrolle": "Kontrola řidičských průkazů",
    "Später": "Později",
    "Führerschein erfolgreich gescannt": "Řidičský průkaz byl úspěšně naskenován",
    "Bitte Ablaufdatum erfassen": "Zadejte prosím datum platnosti",
    "Führerscheinprüfung wirklich verschieben?": "Opravdu odložit zkoušku na řidičský průkaz?",
    "Abmelden?": "Odhlásit se?",
    "Bitte NFC-Chip scannen": "Naskenujte prosím čip NFC",
    "Suchen": "Hledat",
    "Archiv anzeigen": "Zobrazit archiv",
    "Übersicht": "Přehled",
    "Bitte Entladeort auswählen": "Vyberte prosím místo vykládky",
    "Von": "Od",
    "Bis": "Až do",
    "Zeitausgleich": "kompenzace pracovní doby",
    "Urlaub 2": "Dovolená 2",
    "Urlaub 3": "Dovolená 3",
    "Urlaub 4": "Dovolená 4",
    "Unterschrift erforderlich": "Je nutný podpis",
    "Zum unterschreiben hier tippen": "Klepněte sem pro podpis",
    "Unterschrift": "Podpis",
    "Wird geladen...": "Načítá se...",
    "Funktion im Browser nicht verfügbar": "Funkce není v prohlížeči k dispozici",
    "GETRENNT": "ODDĚLENĚ",
    "FormValidationError": "Zkontrolujte prosím zadané údaje. Formulář nebyl vyplněn úplně.",
    "Permission.ListTouren": "Zobrazit trasy",
    "Permission.EditTouren": "Upravit trasy",
    "Protokoll": "Zápis",
    "Werkstatt": "Dílna",
    "Kostenstellen": "Účtovací jednotky",
    "Benachrichtigungen": "Oznámení",
    "Externe Systeme": "Externí systémy",
    "Regeln": "Pravidla",
    "Masterdata1": "Účetní středisko",
    "Feld ist erforderlich": "Toto pole je povinné",
    "FormularfehlerText": "Zkontrolujte prosím zadané údaje. Formulář nebyl vyplněn úplně.",
    "Eintrag wirklich löschen?": "Opravdu chcete záznam smazat?",
    "MasterdataList1": "Účtovací jednotky",
    "EintragWirklichLoeschen": "Opravdu chcete tento záznam smazat?",
    "Loeschen": "Smazat",
    "AusgewaehlteZeilenWirklichLoeschen": "Opravdu chcete vybrané řádky smazat?",
    "Gerätegruppe einschränken": "Omezit skupinu zařízení",
    "Fahrer-Namen nicht anzeigen": "Nezobrazovat jména řidičů",
    "Rolle bearbeiten": "Upravit roli",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Úprava skupin zařízení (základní údaje)",
    "Permission.Werkstattuebersicht": "Přehled dílen",
    "Permission.Kostenstellen": "Účtovací jednotky",
    "Permission.EinstellungenKunde": "Nastavení (jednoduché)",
    "Design": "Design",
    "Benutzeranmeldung": "Přihlášení uživatele",
    "Fotos": "Fotografie",
    "Tour E-Mails": "E-maily týkající se zájezdu",
    "Sicherheitshinweis": "Bezpečnostní pokyny",
    "Pellets": "Pellety",
    "Allgemein": "Obecně",
    "Custom CSS": "Vlastní CSS",
    "Barcodes": "Čárové kódy",
    "Datenherkunft": "Původ dat",
    "Freigabeprozess": "Schvalovací proces",
    "Kontakte": "Kontakty",
    "Menü": "Nabídka",
    "Preise": "Ceny",
    "Verträge": "Smlouvy",
    "Tour-Start": "Začátek trasy",
    "Tour-Ende": "Konec prohlídky",
    "GPS": "GPS",
    "GPS-Positionen": "GPS souřadnice",
    "Position senden": "Odeslat polohu",
    "Navigation": "Navigace",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Nádoba",
    "Peripherie": "Periferie",
    "Drucker": "Tiskárna",
    "Mobile Waagen": "Přenosné váhy",
    "Stationäre Waagen": "Stacionární váhy",
    "Proglove": "Proglove",
    "LKW-Beladung": "Nakládka nákladních vozidel",
    "Web": "Web",
    "Tourenplanung": "Plánování tras",
    "Sondermodule": "Speciální moduly",
    "Sprachen": "Jazyky",
    "Datenbereinigung": "Očištění dat",
    "Daten-Export": "Export dat",
    "Fehlerdiagnose": "Diagnostika poruch",
    "Untermandanten": "Podmandanti",
    "WebSocket-Verbindung": "WebSocketové připojení",
    "Aufträge": "Zakázky",
    "Karte": "Mapa",
    "ExtNummer": "Externí číslo zakázky",
    "ExtNummerHierEingeben": "Zde zadejte externí číslo zakázky…",
    "Foto aus Galerie auswählen": "Vybrat fotografii z galerie"
  },
  "BG": {
    "Permissions": "Права",
    "Permission.ShowUsers": "Показване на потребители",
    "Permission.EditUsers": "Управление на потребителите",
    "Permission.ShowProjects": "Показване на проекти",
    "Permission.EditProjects": "Управление на проекти",
    "Permission.ShowApplications": "Показване на заявки",
    "Permission.EditApplications": "Управление на заявки",
    "Permission.ShowDemandRequest": "Показване на запитвания за нужди",
    "Permission.EditDemandRequest": "Управление на запитвания за оферти",
    "Permission.CreateDemandRequest": "Създаване на запитвания за оферти",
    "Permission.ShowUserRoles": "Показване на потребителските роли",
    "Permission.EditUserRoles": "Управление на потребителските роли",
    "Permission.ShowGeraete": "Показване на устройства",
    "Permission.EditGeraete": "Управление на устройствата",
    "Permission.ReadGeraete": "Четене на устройства",
    "Permission.Administration": "Администрация",
    "Permission.ReadAuftrag": "Прочитане на поръчки",
    "Permission.ListAuftraege": "Показване на поръчки",
    "Permission.ShowKarte": "Покажи картата",
    "Permission.ProtokollAnzeigen": "Показване на протокола",
    "Permission.ProtokollBearbeiten": "Редактиране на протокола",
    "Permission.KarteAnzeigen": "Покажи картата",
    "Permission.WorkflowsAnzeigen": "Преглед на работните процеси",
    "Permission.WorkflowsBearbeiten": "Редактиране на работни потоци",
    "Permission.FahrerBearbeiten": "Редактиране на шофьора",
    "Permission.FahrerAnzeigen": "Покажи шофьора",
    "Permission.FahrzeugBearbeiten": "Редактиране на превозни средства",
    "Permission.FahrzeugAnzeigen": "Показване на превозни средства",
    "Permission.ArtikelAnzeigen": "Покажи статията",
    "Permission.ArtikelBearbeiten": "Редактиране на статия",
    "Permission.UvvKatalogAnzeigen": "Преглед на каталога с правила за безопасност при работа",
    "Permission.UvvKatalogBearbeiten": "Редактиране на каталога на UVV",
    "Permission.AbfahrtskontrolleKatalogAnzeigen": "Преглед на каталога за контрол на отпътуването",
    "Permission.AbfahrtskontrolleKatalogBearbeiten": "Редактиране на каталога за контрол при тръгване",
    "Permission.FormulareBearbeiten": "Редактиране на формуляри",
    "Permission.UvvPruefungenAnzeigen": "Показване на проверки по UVV",
    "Permission.UvvPruefungenBearbeiten": "Обработка на проверки по UVV",
    "Permission.UvvPruefGegenstaendeAnzeigen": "Показване на обекти, подлежащи на UVV",
    "Permission.UvvPruefGegenstaendeBearbeiten": "Редактиране на елементи от плана за предотвратяване на трудови злополуки",
    "Permission.ChecklisteBearbeiten": "Редактиране на контролни списъци",
    "Permission.ChecklisteAnzeigen": "Показване на списъци за проверка",
    "Permission.AdresseAnzeigen": "Показване на адреси",
    "Permission.DokumenteBearbeiten": "Редактиране на документи",
    "Permission.DruckformulareAnzeigen": "Показване на формуляри за печат",
    "Permission.DruckformulareBearbeiten": "Редактиране на формуляри за печат",
    "Permission.ArtikelgruppenAnzeigen": "Показване на групи артикули",
    "Permission.ArtikelgruppenBearbeiten": "Редактиране на групи от артикули",
    "Permission.Sysadmin": "Системният администратор",
    "Permission.FahrzeuggruppenAnzeigen": "Показване на групи превозни средства",
    "Permission.FahrzeuggruppenBearbeiten": "Редактиране на групи превозни средства",
    "Permission.GeraetegruppenAnzeigen": "Показване на групи устройства",
    "Permission.GeraetegruppenBearbeiten": "Редактиране на групи устройства",
    "Permission.StatuszusatzinfoAnzeigen": "Показване на допълнителна информация за статуса",
    "Permission.StatuszusatzinfoBearbeiten": "Редактиране на допълнителна информация за статуса",
    "Permission.Nachrichten": "Новини",
    "Permission.AdresseBearbeiten": "Редактиране на адреси",
    "Permission.WaageAnzeigen": "Показване на везни",
    "Permission.WaageBearbeiten": "Редактиране на везни",
    "Permission.Tabellenkonfiguration": "Конфигурация на таблицата",
    "Permission.EditGeraeteEinfacheDaten": "Проста промяна на данните в устройствата",
    "Permission.AuftraegeBearbeiten": "Обработка на поръчки",
    "Permission.AuftraegeLoeschen": "Изтриване на поръчки",
    "Permission.DokumenteAnzeigen": "Преглед на документи",
    "Permission.Dashboard": "Общ преглед (табло)",
    "Permission.GastzugangAnzeigen": "Показване на достъпа за гости",
    "Permission.GastzugangBearbeiten": "Редактиране на гост-достъпа",
    "Permission.StammtourAnzeigen": "Показване на редовната обиколка",
    "Permission.StammtourBearbeiten": "Редактиране на обиколката на редовните посетители",
    "Permission.StoerzeitAnzeigen": "Показване на времето на смущения",
    "Permission.StoerzeitBearbeiten": "Редактиране на времето на прекъсване",
    "Permission.TourenAnzeigen": "Показване на маршрути",
    "Permission.TourenBearbeiten": "Редактиране на маршрути",
    "Permission.Tourenplanung": "Планиране на маршрути",
    "Anmelden mit Personalnummer": "Вход с личен номер",
    "TourWiegung1": "1. Претегляне",
    "TourWiegung2": "2. Претегляне",
    "BitteWiegung1Durchfuehren": "Моля, извършете първото претегляне",
    "BitteWiegung2Durchfuehren": "Моля, извършете второ претегляне",
    "Permission.AbfahrtskontrolleBearbeiten": "Редактиране на контрола при отпътуване",
    "Permission.AbfahrtskontrolleAnzeigen": "Показване на контролния пункт при тръгване",
    "Permission.Auswertungen": "Анализи",
    "Permission.TexteAnzeigen": "Показване на текстове",
    "Permission.TexteBearbeiten": "Редактиране на текстове",
    "AuftragWiegung1": "1. Претегляне",
    "AuftragWiegung2": "2. Претегляне",
    "Beladung": "Натоварване",
    "Auftrag scannen": "Сканиране на поръчка",
    "Tour": "Тур",
    "Home_Anmelden": "Вход с личен номер",
    "Home_TourStarten": "Започнете обиколката",
    "Home_TourBeenden": "Приключване на тура",
    "Home_AuftragScannen": "Сканиране на поръчка",
    "Home_Beladung": "Натоварване",
    "Home_Hofauftraege": "Заявки от ферми",
    "Wareneingang": "Получаване на стоки",
    "Glas-Analyse": "Анализ на стъклото",
    "Home_Uebersicht": "Общ преглед",
    "Home_Kunden": "Клиенти",
    "NagivationHome": "Начало",
    "UVV-Prüfungen": "Проверки съгласно UVV",
    "Dokumente": "Документи",
    "Abmelden": "Изход",
    "Smartwatch": "Умен часовник",
    "ProGlove": "ProGlove",
    "Home_System": "Система",
    "Permission.VertraegeAnzeigen": "Преглед на договорите",
    "Permission.VertraegeBearbeiten": "Редактиране на договори",
    "Save": "Запазване",
    "Cancel": "Отказ",
    "NeuenTransportauftragAnlegen": "Да се създаде нова транспортна поръчка?",
    "NeuenWareneingangAnlegen": "Да се регистрира ново постъпление на стока?",
    "NeuenHofauftragAnlegen": "Да създадете нова поръчка за стопанството?",
    "Vertrag": "Договор",
    "Neuer Auftrag": "Нова поръчка",
    "Abbrechen": "Отказ",
    "Home_Zeiterfassung": "Отчитане на работното време",
    "SchreibgeschuetztVorStatusmeldung": "Заявката е само за четене до първото съобщение за състоянието ѝ",
    "NavigationErlaubenWennSchreibgeschuetzt": "Разреши навигация, когато файлът е само за четене",
    "TransportauftragLeerePositionenAusblenden": "Скриване на позициите с количество 0",
    "Auswertungen": "Анализи",
    "Abfahrtskontrolle": "Контрол при тръгване",
    "UVV-Gegenstände": "Предмети, попадащи в обхвата на UVV",
    "UVV-Katalog": "Каталог на правилата за безопасност при работа",
    "Einträge": "Записи",
    "Name": "Име",
    "Beschreibung": "Описание",
    "REST-Schnittstelle": "REST интерфейс",
    "Abrechnung aktiv": "Активно отчитане",
    "API-Token": "API токен",
    "Angelegt am": "Създадено на",
    "Vorname": "Име",
    "Nachname": "Фамилия",
    "Email": "Имейл",
    "Roles": "Роли на потребителите",
    "Field is required": "Полето е задължително",
    "E-Mail": "Имейл",
    "Zugangsdaten ändern": "Промяна на данните за достъп",
    "Passwort": "Парола",
    "Passwort (bestätigen)": "Парола (потвърждение)",
    "Benutzer bearbeiten": "Редактиране на потребител",
    "Key": "Ключ",
    "Checkliste": "Контролен списък",
    "Mandant": "Клиент",
    "ApiToken": "API токен",
    "Latitude": "Latitude",
    "Longitude": "Дължина",
    "Max. Entfernung": "Макс. разстояние",
    "Timeout": "Таймаут",
    "Icon": "Икона",
    "Nummer": "Номер",
    "Bezeichnung": "Наименование",
    "Gruppe": "Група",
    "App Version": "Версия на приложението",
    "Traffic aktueller Monat": "Трафик за текущия месец",
    "Personalnr.": "Личен номер",
    "Personal": "Персонал",
    "Zuletzt online": "Последно онлайн",
    "Fahrzeug": "Превозно средство",
    "Anhänger": "Ремарке",
    "Letzte Position": "Последна позиция",
    "Farbe": "Цвят",
    "Letzte Anmeldung": "Последна регистрация",
    "Letzte Abmeldung": "Последно отписване",
    "Angemeldet": "Влязъл",
    "Telefon": "Телефон",
    "Freitext": "Свободен текст",
    "Platform": "Платформа",
    "Version": "Версия",
    "Hersteller": "Производител",
    "Model": "Модел",
    "Alert Berechtigung": "Право на предупреждение",
    "Erste Verwendung": "Първо използване",
    "Letzte Verwendung": "Последно използване",
    "Abrechnung ab": "Отчитане от",
    "Abrechnung bis": "Отчет до",
    "Preis / Monat": "Цена на месец",
    "Einmaliger Preis ": "Еднократна цена ",
    "Geräte (Systemansicht)": "Устройства (изглед на системата)",
    "RoleName": "Име на ролята",
    "Symbol": "Символ",
    "App-Version": "Версия на приложението",
    "Verfügbare Waagen": "Налични везни",
    "Importieren": "Импортиране",
    "Gerätegruppe bearbeiten": "Редактиране на група устройства",
    "Kopieren": "Копиране",
    "Exportieren": "Експортиране",
    "Zeit (h)": "Време (ч)",
    "Intervall (m)": "Интервал (м)",
    "MeldungText": "Текст на съобщението",
    "Standard-Dauer": "Стандартна продължителност",
    "Typ": "Тип",
    "Datum": "Дата",
    "Verlauf": "Хронология",
    "Auftragsnr.": "Номер на поръчката",
    "Gerätenr.": "Номер на устройството",
    "Gerät": "Устройство",
    "Status": "Статус",
    "PushStatus": "PushStatus",
    "Abholdatum": "Дата на вземане",
    "Abholzeit": "Час на вземане",
    "Erfasser": "Съставител",
    "Adress Nr.": "Адресен номер",
    "Name1": "Име1",
    "Name2": "Име2",
    "Strasse": "Улица",
    "PLZ": "Пощенски код",
    "Ort": "Местоположение",
    "Kunde Nr.": "Клиент №",
    "Kunde Name1": "Клиент Име1",
    "Kunde Name2": "Клиент Име2",
    "Kunde Strasse": "Клиент Улица",
    "Kunde PLZ": "Пощенски код на клиента",
    "Kunde Ort": "Клиент, град",
    "Info1": "Информация 1",
    "Info2": "Информация 2",
    "Info3": "Информация 3",
    "DetailInfo1": "Подробна информация 1",
    "DetailInfo2": "Подробна информация 2",
    "DetailInfo3": "Подробна информация 3",
    "Workflow": "Работен процес",
    "Statusmeldung": "Съобщение за състоянието",
    "Statuszeit": "Време на статуса",
    "Reihenfolge": "Ред",
    "CreationDate": "Дата на създаване",
    "ModificationDate": "Дата на промяна",
    "Lieferpositionen": "Позиции за доставка",
    "Auftrag": "Поръчка",
    "RememberMe": "Остани влязъл",
    "Username": "Потребителско име",
    "Geräte": "Уреди",
    "Stammdaten": "Основни данни",
    "Adressen": "Адреси",
    "Artikelgruppen": "Групи продукти",
    "Artikel": "Статия",
    "Checklisten": "Контролни списъци",
    "Fahrer (Personal)": "Шофьор (персонал)",
    "Fahrzeuge": "Превозни средства",
    "Fahrzeuggruppen": "Групи превозни средства",
    "Konfiguration": "Конфигурация",
    "Benutzer": "Потребител",
    "Benutzerrollen": "Роли на потребителите",
    "Druckformulare": "Формуляри за печат",
    "Einstellungen": "Настройки",
    "Formulare": "Формуляри",
    "Gerätegruppen": "Групи устройства",
    "Waagen": "Везни",
    "Workflows": "Работни процеси",
    "Statuszusatzinfo": "Допълнителна информация за статуса",
    "Texte": "Текстове",
    "Import / Export": "Внос / Износ",
    "Benutzername": "Потребителско име",
    "E-Mail-Adresse": "Е-мейл адрес",
    "Passwort ändern": "Промяна на паролата",
    "Permission.Benachrichtigungen": "Известия",
    "Permission.ZeiterfassungAnzeigen": "Преглед на отчета за работното време",
    "Permission.ZeiterfassungBearbeiten": "Редактиране на отчета за работното време",
    "Nachtmodus": "Нощен режим",
    "Nachmodus": "Нощен режим",
    "KeineAuftraegeGefunden": "Не бяха намерени поръчки",
    "KeineAuftraegeVorhanden": "Няма поръчки. Плъзнете надолу, за да актуализирате.",
    "TourStartenAlertButtonText": "Да започнем обиколката!",
    "Aktuelle Aufträge anzeigen": "Показване на текущите поръчки",
    "Archiv": "Архив",
    "weitere Aufträge vorhanden": "има още поръчки",
    "weiterer Auftrag vorhanden": "има още една поръчка",
    "Anmerkungen": "Бележки",
    "AnmerkungenHierEingeben": "Въведете бележките тук…",
    "AuftragDarfNichtGeaendertWerden": "Поръчката не може да бъде променяна",
    "AuftragBereitsAbgeschlossen": "Поръчката вече е приключена. Промени вече не са възможни.",
    "Start": "Начало",
    "System": "Система",
    "Transportaufträge": "Транспортни поръчки",
    "Hofaufträge": "Заявки за двора",
    "Entladeort": "Място на разтоварване",
    "Bitte Entladeort wählen": "Моля, изберете място за разтоварване",
    "TourStart_Wiegen": "Претегляне",
    "TourEnde_StartWiegung": "Претегляне в началото на тура",
    "TourEnde_EndeWiegung": "Претегляне (пълно товарно превозно средство)",
    "Geplante Reihenfolge anzeigen": "Показване на планирания ред",
    "Permission.GlasAnalyseAnzeigen": "Показване на анализ на стъклото",
    "Permission.GlasAnalyseBearbeiten": "Редактиране на анализ на стъкло",
    "BitteAuswaehlenPlaceholder": "Моля, изберете",
    "BitteAnlageWaehlen": "Моля, изберете приложение",
    "Permission.GlasAnalyseKonfiguration": "Конфигурация за анализ на стъкло",
    "UVV Prüfung": "Проверка за спазване на правилата за безопасност при работа",
    "Auftrag_Abholadresse": "Адрес",
    "Auftrag_Erzeugeradresse": "Клиент",
    "Auftrag_Verwerteradresse": "Обработващ",
    "Auftrag_Fahrzeug": "Превозно средство",
    "Auftrag_Abholdatum": "Дата на вземане",
    "Auftrag_Abholzeit": "Час на вземане",
    "Permission.BerichteAnzeigen": "Преглед на отчетите",
    "Permission.BerichteBearbeiten": "Редактиране на отчети",
    "Permission.Kalender": "Календар",
    "Permission.NVEAnzeigen": "Показване на NVE",
    "Permission.NVEBearbeiten": "Редактиране на NVE",
    "Permission.RegelAnzeigen": "Покажи правилата",
    "Permission.RegelBearbeiten": "Редактиране на правилата",
    "ExportMessageStatus_0": "Начало",
    "ExportMessageStatus_1": "Изпратено",
    "ExportMessageStatus_2": "Обработено",
    "ExportMessageStatus_3": "Грешка",
    "ExportMessageStatus_4": "Изчакай ACK",
    "Gerätegruppe": "Група устройства",
    "Sonstiges": "Други",
    "Sprache": "Език",
    "APP Version": "Версия на приложението",
    "Local storage": "Локално хранилище",
    "Advanced HTTP": "Разширени HTTP",
    "System Alert Berechtigung": "Право за системни предупреждения",
    "Navigations-App": "Приложение за навигация",
    "Zurücksetzen": "Възстановяване",
    "WebSocket": "WebSocket",
    "Push-Status": "Статус на известието",
    "Push-ID": "Push-ID",
    "Push-Type": "Тип „Push“",
    "Anzahl Artikelgruppen": "Брой групи артикули",
    "Anzahl Artikel": "Брой артикули",
    "Anzahl Workflows": "Брой работни потоци",
    "GPS Dienst läuft": "GPS услугата работи",
    "GPS Dienst aktiv": "GPS услугата е активна",
    "GPS Auth-Status": "Статус на GPS автентификацията",
    "GPS-Positionen (Puffer)": "GPS-координати (буфер)",
    "Zugangsdaten": "Данни за достъп",
    "Geräte-Nummer": "Номер на устройството",
    "Host": "Домакин",
    "Speichern": "Запазване",
    "Stammdaten neu laden": "Презареждане на основните данни",
    "Lokale Daten löschen": "Изтриване на локални данни",
    "Diagnosedaten senden": "Изпращане на диагностични данни",
    "Testdatei senden": "Изпращане на тестов файл",
    "Update prüfen": "Провери за актуализации",
    "Dunkler Modus": "Тъмен режим",
    "Aktivieren": "Активиране",
    "Anzeigen": "Реклами",
    "Anmelden": "Вход",
    "Personalnummer": "Личен номер",
    "Kennwort": "Парола",
    "Mit NFC anmelden": "Вход чрез NFC",
    "Bitte eingeben": "Моля, въведете",
    "Passwort eingeben": "Въведете паролата",
    "Anmelden mit NFC-Chip": "Вход с NFC чип",
    "Zur Anmeldung NFC-Chip scannen": "За да се регистрирате, сканирайте NFC чипа",
    "Mit Personalnummer anmelden": "Вход с личен номер",
    "Ablaufdatum": "Дата на изтичане",
    "Kein Fahrer für RFID-Chip gefunden": "Не беше намерен драйвер за RFID чипа",
    "Nachrichten": "Новини",
    "Berichte": "Доклади",
    "Urlaubsanträge": "Молби за отпуск",
    "Unfallberichte": "Доклади за произшествия",
    "Tätigkeitsberichte": "Отчети за дейността",
    "an": "на",
    "aus": "от",
    "KeineEintraegeVorhanden": "Няма записи",
    "StoerzeitFuerAuftrag": "Време за прекъсване на поръчката",
    "StoerzeitFuerTour": "Време за прекъсване на обиколката",
    "Minuten": "минути",
    "Sekunden": "секунди",
    "Minute": "Минута",
    "TourNichtGestartetLoeschen": "Турът не е започнал. Не може да бъде изтрит.",
    "ZeiterfassungOhneTourFehler": "Отчитането на работното време не може да бъде стартирано без маршрут",
    "Tour start": "Начало на тура",
    "Kilometerstand": "Пробег",
    "Fahrer": "Шофьор",
    "Beifahrer": "Пътник на предната седалка",
    "Bitte wählen": "Моля, изберете",
    "Beifahrer 2": "Пътник 2",
    "Abfahrtskontrolle Anhänger": "Контрол на отпътуването на ремаркетата",
    "Foto aufnehmen": "Да се направи снимка",
    "Zum Bearbeiten hier tippen": "Натиснете тук, за да редактирате",
    "Eingeben": "Въведи",
    "Uhrzeit": "Час",
    "Driver": "Драйвер",
    "Passenger": "Пътник",
    "Passenger 2": "Пътник 2",
    "Trailer": "Трейлър",
    "Vehicle": "Превозно средство",
    "BitteEingabePruefen": "Моля, проверете въведените данни!",
    "RFID scannen": "Сканиране с RFID",
    "Tour scannen": "Сканиране на маршрута",
    "Tour starten": "Започнете обиколката",
    "Tour laden": "Зареждане на маршрута",
    "Tour entladen": "Изтегляне на маршрута",
    "Schreiben": "Писмо",
    "Alle Nachrichten löschen?": "Да изтриете всички съобщения?",
    "Löschen": "Изтриване",
    "Ja": "Да",
    "Nein": "Не",
    "Nächste Prüfung": "Следващ изпит",
    "alle anzeigen": "покажи всички",
    "Bitte KM eingeben": "Моля, въведете KM",
    "NFCErkennungLaeuft": "Разнася се NFC…",
    "RFIDWirdGescannt": "RFID се сканира…",
    "OK": "ОК",
    "Fehlerbeschreibung": "Описание на грешката",
    "Bild wirklich löschen?": "Наистина ли искате да изтриете снимката?",
    "Frage": "Въпрос",
    "Bitte Kilometerstand angeben": "Моля, посочете пробега",
    "Bitte Ankunftskontrolle vollständig ausfüllen": "Моля, попълнете изцяло формуляра за регистрация при пристигане",
    "Bitte Ankunftskontrolle Anhänger vollständig ausfüllen": "Моля, попълнете изцяло формуляра за регистрация при пристигане",
    "Bitte Unterschrift erfassen": "Моля, въведете подписа",
    "Bitte Namen für die Unterschrift erfassen": "Моля, въведете името за подписа",
    "Bitte nehmen Sie sich genügend Zeit für die Ankunftskontrolle!": "Моля, предвидете достатъчно време за проверката при пристигане!",
    "AnkunftskontrolleDauerFrage1": "Не е спазено определеното време за проверката при пристигане. Да приключим ли все пак обиколката?",
    "Tour beenden?": "Да приключим обиколката?",
    "AnkunftskontrolleDauerFrage2": "Не е спазено определеното време за проверка при пристигане. Да приключим ли все пак тура?<br /><br />Ще бъде изпратено съобщение!",
    "Bitte Abfahrtskontrolle vollständig ausfüllen": "Моля, попълнете изцяло формуляра за проверка при заминаване",
    "AbfahrtskontrolleMeldung1": "Моля, отделете достатъчно време за проверката при заминаване!",
    "AbfahrtskontrolleMeldung2": "Не е спазено определеното време за проверка при тръгване. Да започнем ли пътуването въпреки това?",
    "AbfahrtskontrolleMeldung3": "Не е спазено предвиденото време за проверка при тръгване. Да се започне ли все пак маршрутът?<br /><br />Изпраща се съобщение!",
    "KeineWiegungTourTrotzdemStarten": "Не е извършено претегляне. Да продължим ли пътуването въпреки това?",
    "Wiegung": "Претегляне",
    "WiegungErfolgreich": "Необходимо е претегляне!",
    "Tour start?": "Начало на тура?",
    "Tour aktiv seit": "Турът е активен от",
    "Gestartet um": "Започна в",
    "Gestartet gestern": "Стартира вчера",
    "Gestartet": "Стартира",
    "Keine gültige Auftragsnummer": "Няма валиден номер на поръчката",
    "Heute offene Aufträge": "Днешни отворени поръчки",
    "Heute erledigt Aufträge": "Изпълнени поръчки днес",
    "Morgen": "Утре",
    "Keine Transportaufträge": "Няма поръчки за транспорт",
    "1 Transportauftrag": "1 транспортна поръчка",
    "aktuelle Aufträge": "текущи поръчки",
    "Statusmeldung428": "Не е възможно да се изведе съобщение за състоянието. Процесът на претегляне вече е започнал. Моля, приключете цикъла и го стартирайте отново, ако е необходимо.",
    "Meldung429": "<p>Не е възможно да се изведе съобщение за състоянието. Турът все още не е започнал.</p><p>Да започне ли турът сега?</p>",
    "Meldung430": "Статусът не е разрешен. Моля, посочете един от следните статуси",
    "Meldung431": "Не всички позиции са отчетени като завършени. Да се отчете палетата наистина като завършена ли?",
    "Meldung432": "Не е възможно да се изпрати съобщение за състоянието. Моля, първо въведете обосновка за записването на работното време „{{NAME}}“.",
    "Es muss mindestens ein Foto gemacht werden!": "Трябва да се направи поне една снимка!",
    "Alle Aufträge": "Всички поръчки",
    "Kommissionierung": "Подготовка на поръчки",
    "Wiegungen": "Претегляния",
    "Gekoppelte Waagen": "Свързани везни",
    "Waage suchen...": "Търсене на везни...",
    "Keine Wiegedaten vorhanden": "Няма данни за теглото",
    "Keine Waagen konfiguriert": "Няма конфигурирани везни",
    "Waage": "Везни",
    "MAC Adresse": "MAC адрес",
    "Aktiv": "Активен",
    "Uhr synchronisieren": "Синхронизиране на часовника",
    "Wiegen 1": "Теглене 1",
    "Wiegen 2": "Теглене 2",
    "Tarieren": "Тариране",
    "Keine neue Waage gefunden": "Не беше намерена нова везна",
    "TourAktivBeendenMeldung449": "Турът все още е активен. Да приключим ли тура сега?",
    "WirklichAbmelden": "Наистина ли искате да се отпишете?",
    "Aktuelle Tour": "Текущо турне",
    "Tour beenden": "Приключване на тура",
    "Zeiterfassung": "Отчитане на работното време",
    "Zeiterfassung starten": "Стартиране на отчитането на работното време",
    "Tour Ende": "Край на тура",
    "Art": "Вид",
    "Arbeitszeit bearbeiten": "Редактиране на работното време",
    "Wiegen": "Претегляне",
    "Tätigkeitsbericht": "Отчет за дейността",
    "Personaldaten": "Лични данни",
    "Tätigkeit": "Дейност",
    "Übernachtung": "Нощувка",
    "Beschreibung der Tätigkeit": "Описание на длъжността",
    "Neuer Urlaubsantrag": "Нова молба за отпуск",
    "Abteilung": "Отдел",
    "Urlaub": "Почивка",
    "Angemeldete Beifahrer": "Регистрирани пътници",
    "Beifahrer hinzufügen": "Добави пътник",
    "Beifahrer NFC scannen": "Сканиране на NFC на пътника",
    "BeifahrerListeNichtGeladen": "Не е възможно да се зареди списъкът с пътниците. Моля, проверете интернет връзката си.",
    "Beifahrer wurde gescannnt": "Пътникът беше сканиран",
    "NfcKeinBeifahrerGefunden": "Не е намерен съпътник за RFID чипа",
    "BeifahrerAlsFahrerMeldung473": "Вече сте регистрирани като шофьор за този тур. Не можете да се регистрирате отново като пътник.",
    "BeifahrerBereitsAngemeldet": "Вече сте регистрирани като пътник.",
    "MaxZweiBeifahrerMoeglich": "Могат да бъдат регистрирани максимум 2 пътници",
    "BeifahrerNichtGefunden": "Не е намерен пътник на предната седалка",
    "BeifahrerWurdeHinzugefuegt": "Добавен е пътникът",
    "Ein Anhänger kann nicht als Fahrzeug gescannt werden": "Ремаркето не може да бъде сканирано като превозно средство",
    "Ein LKW kann nicht als Anhänger gescannt werden": "Камионът не може да бъде сканиран като ремарке",
    "AngemeldetSeit": "Регистриран от",
    "Hinzufügen": "Добави",
    "NFC scannen": "Сканиране чрез NFC",
    "Beifahrer abmelden": "Отписване на пътника",
    "Hallo": "Здравейте",
    "FuehrerscheinkontrolleText1": "Време е за проверка на шофьорската книжка.",
    "FuehrerscheinkontrolleTextFoto": "Моля, снимайте предната и задната страна на шофьорската си книжка.",
    "Foto Vorderseite": "Снимка на предната страна",
    "Foto Rückseite": "Снимка на гърба",
    "FuehrerscheinkontrolleTextNFC": "Моля, сканирайте NFC чипа на шофьорската си книжка.",
    "FuehrerscheinkontrolleNfcFalsch": "Невалиден NFC чип",
    "Fahrerkarten": "Карти на водачите",
    "Führerscheinkontrolle": "Проверка на шофьорските книжки",
    "Später": "По-късно",
    "Führerschein erfolgreich gescannt": "Шофьорската книжка е сканирана успешно",
    "Bitte Ablaufdatum erfassen": "Моля, въведете датата на валидност",
    "Führerscheinprüfung wirklich verschieben?": "Наистина ли да отложим изпита за шофьорска книжка?",
    "Abmelden?": "Да се отпиша ли?",
    "Bitte NFC-Chip scannen": "Моля, сканирайте NFC чипа",
    "Suchen": "Търсене",
    "Archiv anzeigen": "Показване на архива",
    "Übersicht": "Общ преглед",
    "Bitte Entladeort auswählen": "Моля, изберете място за разтоварване",
    "Von": "От",
    "Bis": "До",
    "Zeitausgleich": "Компенсация на работното време",
    "Urlaub 2": "Ваканция 2",
    "Urlaub 3": "Ваканция 3",
    "Urlaub 4": "Ваканция 4",
    "Unterschrift erforderlich": "Необходим е подпис",
    "Zum unterschreiben hier tippen": "Натиснете тук, за да подпишете",
    "Unterschrift": "Подпис",
    "Wird geladen...": "Зарежда се...",
    "Funktion im Browser nicht verfügbar": "Функцията не е достъпна в браузъра",
    "GETRENNT": "РАЗДЕЛНО",
    "FormValidationError": "Моля, проверете въведените данни. Формулярът не е попълнен изцяло.",
    "Permission.ListTouren": "Показване на маршрути",
    "Permission.EditTouren": "Редактиране на маршрути",
    "Protokoll": "Протокол",
    "Werkstatt": "Сервиз",
    "Kostenstellen": "Отдели по разходите",
    "Benachrichtigungen": "Известия",
    "Externe Systeme": "Външни системи",
    "Regeln": "Правила",
    "Masterdata1": "Отдел за разходи",
    "Feld ist erforderlich": "Полето е задължително",
    "FormularfehlerText": "Моля, проверете въведените данни. Формулярът не е попълнен изцяло.",
    "Eintrag wirklich löschen?": "Наистина ли искате да изтриете записа?",
    "MasterdataList1": "Отдели по разходите",
    "EintragWirklichLoeschen": "Наистина ли искате да изтриете тази публикация?",
    "Loeschen": "Изтриване",
    "AusgewaehlteZeilenWirklichLoeschen": "Наистина ли искате да изтриете избраните редове?",
    "Gerätegruppe einschränken": "Ограничаване на групата устройства",
    "Fahrer-Namen nicht anzeigen": "Да не се показват имената на шофьорите",
    "Rolle bearbeiten": "Редактиране на роля",
    "Permission.GeraetegruppenBearbeitenEinfacheDaten": "Редактиране на групи устройства (обикновени данни)",
    "Permission.Werkstattuebersicht": "Общ преглед на сервиза",
    "Permission.Kostenstellen": "Отдели по разходите",
    "Permission.EinstellungenKunde": "Настройки (опростени)",
    "Design": "Дизайн",
    "Benutzeranmeldung": "Вход за потребители",
    "Fotos": "Снимки",
    "Tour E-Mails": "Имейли за екскурзии",
    "Sicherheitshinweis": "Указания за безопасност",
    "Pellets": "Пелети",
    "Allgemein": "Общо",
    "Custom CSS": "Персонализиран CSS",
    "Barcodes": "Баркодове",
    "Datenherkunft": "Източник на данните",
    "Freigabeprozess": "Процес на одобрение",
    "Kontakte": "Контакти",
    "Menü": "Меню",
    "Preise": "Цени",
    "Verträge": "Договори",
    "Tour-Start": "Начало на тура",
    "Tour-Ende": "Край на тура",
    "GPS": "GPS",
    "GPS-Positionen": "GPS координати",
    "Position senden": "Изпрати местоположение",
    "Navigation": "Навигация",
    "NFC": "NFC",
    "UVV": "UVV",
    "Behälter": "Контейнер",
    "Peripherie": "Периферия",
    "Drucker": "Принтер",
    "Mobile Waagen": "Мобилни везни",
    "Stationäre Waagen": "Стационарни везни",
    "Proglove": "Proglove",
    "LKW-Beladung": "Натоварване на камиони",
    "Web": "Уеб",
    "Tourenplanung": "Планиране на маршрути",
    "Sondermodule": "Специални модули",
    "Sprachen": "Езици",
    "Datenbereinigung": "Очистване на данни",
    "Daten-Export": "Експорт на данни",
    "Fehlerdiagnose": "Диагностика на неизправности",
    "Untermandanten": "Подклиенти",
    "WebSocket-Verbindung": "WebSocket връзка",
    "Aufträge": "Поръчки",
    "Karte": "Карта",
    "ExtNummer": "Външен номер на поръчката",
    "ExtNummerHierEingeben": "Въведете тук външния номер на поръчката…",
    "Foto aus Galerie auswählen": "Избор на снимка от галерията"
  }
};
